/*! jQuery v2.1.4 | (c) 2005, 2015 jQuery Foundation, Inc. | jquery.org/license */
!function(a,b){"object"==typeof module&&"object"==typeof module.exports?module.exports=a.document?b(a,!0):function(a){if(!a.document)throw new Error("jQuery requires a window with a document");return b(a)}:b(a)}("undefined"!=typeof window?window:this,function(a,b){var c=[],d=c.slice,e=c.concat,f=c.push,g=c.indexOf,h={},i=h.toString,j=h.hasOwnProperty,k={},l=a.document,m="2.1.4",n=function(a,b){return new n.fn.init(a,b)},o=/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,p=/^-ms-/,q=/-([\da-z])/gi,r=function(a,b){return b.toUpperCase()};n.fn=n.prototype={jquery:m,constructor:n,selector:"",length:0,toArray:function(){return d.call(this)},get:function(a){return null!=a?0>a?this[a+this.length]:this[a]:d.call(this)},pushStack:function(a){var b=n.merge(this.constructor(),a);return b.prevObject=this,b.context=this.context,b},each:function(a,b){return n.each(this,a,b)},map:function(a){return this.pushStack(n.map(this,function(b,c){return a.call(b,c,b)}))},slice:function(){return this.pushStack(d.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},eq:function(a){var b=this.length,c=+a+(0>a?b:0);return this.pushStack(c>=0&&b>c?[this[c]]:[])},end:function(){return this.prevObject||this.constructor(null)},push:f,sort:c.sort,splice:c.splice},n.extend=n.fn.extend=function(){var a,b,c,d,e,f,g=arguments[0]||{},h=1,i=arguments.length,j=!1;for("boolean"==typeof g&&(j=g,g=arguments[h]||{},h++),"object"==typeof g||n.isFunction(g)||(g={}),h===i&&(g=this,h--);i>h;h++)if(null!=(a=arguments[h]))for(b in a)c=g[b],d=a[b],g!==d&&(j&&d&&(n.isPlainObject(d)||(e=n.isArray(d)))?(e?(e=!1,f=c&&n.isArray(c)?c:[]):f=c&&n.isPlainObject(c)?c:{},g[b]=n.extend(j,f,d)):void 0!==d&&(g[b]=d));return g},n.extend({expando:"jQuery"+(m+Math.random()).replace(/\D/g,""),isReady:!0,error:function(a){throw new Error(a)},noop:function(){},isFunction:function(a){return"function"===n.type(a)},isArray:Array.isArray,isWindow:function(a){return null!=a&&a===a.window},isNumeric:function(a){return!n.isArray(a)&&a-parseFloat(a)+1>=0},isPlainObject:function(a){return"object"!==n.type(a)||a.nodeType||n.isWindow(a)?!1:a.constructor&&!j.call(a.constructor.prototype,"isPrototypeOf")?!1:!0},isEmptyObject:function(a){var b;for(b in a)return!1;return!0},type:function(a){return null==a?a+"":"object"==typeof a||"function"==typeof a?h[i.call(a)]||"object":typeof a},globalEval:function(a){var b,c=eval;a=n.trim(a),a&&(1===a.indexOf("use strict")?(b=l.createElement("script"),b.text=a,l.head.appendChild(b).parentNode.removeChild(b)):c(a))},camelCase:function(a){return a.replace(p,"ms-").replace(q,r)},nodeName:function(a,b){return a.nodeName&&a.nodeName.toLowerCase()===b.toLowerCase()},each:function(a,b,c){var d,e=0,f=a.length,g=s(a);if(c){if(g){for(;f>e;e++)if(d=b.apply(a[e],c),d===!1)break}else for(e in a)if(d=b.apply(a[e],c),d===!1)break}else if(g){for(;f>e;e++)if(d=b.call(a[e],e,a[e]),d===!1)break}else for(e in a)if(d=b.call(a[e],e,a[e]),d===!1)break;return a},trim:function(a){return null==a?"":(a+"").replace(o,"")},makeArray:function(a,b){var c=b||[];return null!=a&&(s(Object(a))?n.merge(c,"string"==typeof a?[a]:a):f.call(c,a)),c},inArray:function(a,b,c){return null==b?-1:g.call(b,a,c)},merge:function(a,b){for(var c=+b.length,d=0,e=a.length;c>d;d++)a[e++]=b[d];return a.length=e,a},grep:function(a,b,c){for(var d,e=[],f=0,g=a.length,h=!c;g>f;f++)d=!b(a[f],f),d!==h&&e.push(a[f]);return e},map:function(a,b,c){var d,f=0,g=a.length,h=s(a),i=[];if(h)for(;g>f;f++)d=b(a[f],f,c),null!=d&&i.push(d);else for(f in a)d=b(a[f],f,c),null!=d&&i.push(d);return e.apply([],i)},guid:1,proxy:function(a,b){var c,e,f;return"string"==typeof b&&(c=a[b],b=a,a=c),n.isFunction(a)?(e=d.call(arguments,2),f=function(){return a.apply(b||this,e.concat(d.call(arguments)))},f.guid=a.guid=a.guid||n.guid++,f):void 0},now:Date.now,support:k}),n.each("Boolean Number String Function Array Date RegExp Object Error".split(" "),function(a,b){h["[object "+b+"]"]=b.toLowerCase()});function s(a){var b="length"in a&&a.length,c=n.type(a);return"function"===c||n.isWindow(a)?!1:1===a.nodeType&&b?!0:"array"===c||0===b||"number"==typeof b&&b>0&&b-1 in a}var t=function(a){var b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u="sizzle"+1*new Date,v=a.document,w=0,x=0,y=ha(),z=ha(),A=ha(),B=function(a,b){return a===b&&(l=!0),0},C=1<<31,D={}.hasOwnProperty,E=[],F=E.pop,G=E.push,H=E.push,I=E.slice,J=function(a,b){for(var c=0,d=a.length;d>c;c++)if(a[c]===b)return c;return-1},K="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",L="[\\x20\\t\\r\\n\\f]",M="(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",N=M.replace("w","w#"),O="\\["+L+"*("+M+")(?:"+L+"*([*^$|!~]?=)"+L+"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|("+N+"))|)"+L+"*\\]",P=":("+M+")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|"+O+")*)|.*)\\)|)",Q=new RegExp(L+"+","g"),R=new RegExp("^"+L+"+|((?:^|[^\\\\])(?:\\\\.)*)"+L+"+$","g"),S=new RegExp("^"+L+"*,"+L+"*"),T=new RegExp("^"+L+"*([>+~]|"+L+")"+L+"*"),U=new RegExp("="+L+"*([^\\]'\"]*?)"+L+"*\\]","g"),V=new RegExp(P),W=new RegExp("^"+N+"$"),X={ID:new RegExp("^#("+M+")"),CLASS:new RegExp("^\\.("+M+")"),TAG:new RegExp("^("+M.replace("w","w*")+")"),ATTR:new RegExp("^"+O),PSEUDO:new RegExp("^"+P),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+L+"*(even|odd|(([+-]|)(\\d*)n|)"+L+"*(?:([+-]|)"+L+"*(\\d+)|))"+L+"*\\)|)","i"),bool:new RegExp("^(?:"+K+")$","i"),needsContext:new RegExp("^"+L+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+L+"*((?:-\\d)?\\d*)"+L+"*\\)|)(?=[^-]|$)","i")},Y=/^(?:input|select|textarea|button)$/i,Z=/^h\d$/i,$=/^[^{]+\{\s*\[native \w/,_=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,aa=/[+~]/,ba=/'|\\/g,ca=new RegExp("\\\\([\\da-f]{1,6}"+L+"?|("+L+")|.)","ig"),da=function(a,b,c){var d="0x"+b-65536;return d!==d||c?b:0>d?String.fromCharCode(d+65536):String.fromCharCode(d>>10|55296,1023&d|56320)},ea=function(){m()};try{H.apply(E=I.call(v.childNodes),v.childNodes),E[v.childNodes.length].nodeType}catch(fa){H={apply:E.length?function(a,b){G.apply(a,I.call(b))}:function(a,b){var c=a.length,d=0;while(a[c++]=b[d++]);a.length=c-1}}}function ga(a,b,d,e){var f,h,j,k,l,o,r,s,w,x;if((b?b.ownerDocument||b:v)!==n&&m(b),b=b||n,d=d||[],k=b.nodeType,"string"!=typeof a||!a||1!==k&&9!==k&&11!==k)return d;if(!e&&p){if(11!==k&&(f=_.exec(a)))if(j=f[1]){if(9===k){if(h=b.getElementById(j),!h||!h.parentNode)return d;if(h.id===j)return d.push(h),d}else if(b.ownerDocument&&(h=b.ownerDocument.getElementById(j))&&t(b,h)&&h.id===j)return d.push(h),d}else{if(f[2])return H.apply(d,b.getElementsByTagName(a)),d;if((j=f[3])&&c.getElementsByClassName)return H.apply(d,b.getElementsByClassName(j)),d}if(c.qsa&&(!q||!q.test(a))){if(s=r=u,w=b,x=1!==k&&a,1===k&&"object"!==b.nodeName.toLowerCase()){o=g(a),(r=b.getAttribute("id"))?s=r.replace(ba,"\\$&"):b.setAttribute("id",s),s="[id='"+s+"'] ",l=o.length;while(l--)o[l]=s+ra(o[l]);w=aa.test(a)&&pa(b.parentNode)||b,x=o.join(",")}if(x)try{return H.apply(d,w.querySelectorAll(x)),d}catch(y){}finally{r||b.removeAttribute("id")}}}return i(a.replace(R,"$1"),b,d,e)}function ha(){var a=[];function b(c,e){return a.push(c+" ")>d.cacheLength&&delete b[a.shift()],b[c+" "]=e}return b}function ia(a){return a[u]=!0,a}function ja(a){var b=n.createElement("div");try{return!!a(b)}catch(c){return!1}finally{b.parentNode&&b.parentNode.removeChild(b),b=null}}function ka(a,b){var c=a.split("|"),e=a.length;while(e--)d.attrHandle[c[e]]=b}function la(a,b){var c=b&&a,d=c&&1===a.nodeType&&1===b.nodeType&&(~b.sourceIndex||C)-(~a.sourceIndex||C);if(d)return d;if(c)while(c=c.nextSibling)if(c===b)return-1;return a?1:-1}function ma(a){return function(b){var c=b.nodeName.toLowerCase();return"input"===c&&b.type===a}}function na(a){return function(b){var c=b.nodeName.toLowerCase();return("input"===c||"button"===c)&&b.type===a}}function oa(a){return ia(function(b){return b=+b,ia(function(c,d){var e,f=a([],c.length,b),g=f.length;while(g--)c[e=f[g]]&&(c[e]=!(d[e]=c[e]))})})}function pa(a){return a&&"undefined"!=typeof a.getElementsByTagName&&a}c=ga.support={},f=ga.isXML=function(a){var b=a&&(a.ownerDocument||a).documentElement;return b?"HTML"!==b.nodeName:!1},m=ga.setDocument=function(a){var b,e,g=a?a.ownerDocument||a:v;return g!==n&&9===g.nodeType&&g.documentElement?(n=g,o=g.documentElement,e=g.defaultView,e&&e!==e.top&&(e.addEventListener?e.addEventListener("unload",ea,!1):e.attachEvent&&e.attachEvent("onunload",ea)),p=!f(g),c.attributes=ja(function(a){return a.className="i",!a.getAttribute("className")}),c.getElementsByTagName=ja(function(a){return a.appendChild(g.createComment("")),!a.getElementsByTagName("*").length}),c.getElementsByClassName=$.test(g.getElementsByClassName),c.getById=ja(function(a){return o.appendChild(a).id=u,!g.getElementsByName||!g.getElementsByName(u).length}),c.getById?(d.find.ID=function(a,b){if("undefined"!=typeof b.getElementById&&p){var c=b.getElementById(a);return c&&c.parentNode?[c]:[]}},d.filter.ID=function(a){var b=a.replace(ca,da);return function(a){return a.getAttribute("id")===b}}):(delete d.find.ID,d.filter.ID=function(a){var b=a.replace(ca,da);return function(a){var c="undefined"!=typeof a.getAttributeNode&&a.getAttributeNode("id");return c&&c.value===b}}),d.find.TAG=c.getElementsByTagName?function(a,b){return"undefined"!=typeof b.getElementsByTagName?b.getElementsByTagName(a):c.qsa?b.querySelectorAll(a):void 0}:function(a,b){var c,d=[],e=0,f=b.getElementsByTagName(a);if("*"===a){while(c=f[e++])1===c.nodeType&&d.push(c);return d}return f},d.find.CLASS=c.getElementsByClassName&&function(a,b){return p?b.getElementsByClassName(a):void 0},r=[],q=[],(c.qsa=$.test(g.querySelectorAll))&&(ja(function(a){o.appendChild(a).innerHTML="<a id='"+u+"'></a><select id='"+u+"-\f]' msallowcapture=''><option selected=''></option></select>",a.querySelectorAll("[msallowcapture^='']").length&&q.push("[*^$]="+L+"*(?:''|\"\")"),a.querySelectorAll("[selected]").length||q.push("\\["+L+"*(?:value|"+K+")"),a.querySelectorAll("[id~="+u+"-]").length||q.push("~="),a.querySelectorAll(":checked").length||q.push(":checked"),a.querySelectorAll("a#"+u+"+*").length||q.push(".#.+[+~]")}),ja(function(a){var b=g.createElement("input");b.setAttribute("type","hidden"),a.appendChild(b).setAttribute("name","D"),a.querySelectorAll("[name=d]").length&&q.push("name"+L+"*[*^$|!~]?="),a.querySelectorAll(":enabled").length||q.push(":enabled",":disabled"),a.querySelectorAll("*,:x"),q.push(",.*:")})),(c.matchesSelector=$.test(s=o.matches||o.webkitMatchesSelector||o.mozMatchesSelector||o.oMatchesSelector||o.msMatchesSelector))&&ja(function(a){c.disconnectedMatch=s.call(a,"div"),s.call(a,"[s!='']:x"),r.push("!=",P)}),q=q.length&&new RegExp(q.join("|")),r=r.length&&new RegExp(r.join("|")),b=$.test(o.compareDocumentPosition),t=b||$.test(o.contains)?function(a,b){var c=9===a.nodeType?a.documentElement:a,d=b&&b.parentNode;return a===d||!(!d||1!==d.nodeType||!(c.contains?c.contains(d):a.compareDocumentPosition&&16&a.compareDocumentPosition(d)))}:function(a,b){if(b)while(b=b.parentNode)if(b===a)return!0;return!1},B=b?function(a,b){if(a===b)return l=!0,0;var d=!a.compareDocumentPosition-!b.compareDocumentPosition;return d?d:(d=(a.ownerDocument||a)===(b.ownerDocument||b)?a.compareDocumentPosition(b):1,1&d||!c.sortDetached&&b.compareDocumentPosition(a)===d?a===g||a.ownerDocument===v&&t(v,a)?-1:b===g||b.ownerDocument===v&&t(v,b)?1:k?J(k,a)-J(k,b):0:4&d?-1:1)}:function(a,b){if(a===b)return l=!0,0;var c,d=0,e=a.parentNode,f=b.parentNode,h=[a],i=[b];if(!e||!f)return a===g?-1:b===g?1:e?-1:f?1:k?J(k,a)-J(k,b):0;if(e===f)return la(a,b);c=a;while(c=c.parentNode)h.unshift(c);c=b;while(c=c.parentNode)i.unshift(c);while(h[d]===i[d])d++;return d?la(h[d],i[d]):h[d]===v?-1:i[d]===v?1:0},g):n},ga.matches=function(a,b){return ga(a,null,null,b)},ga.matchesSelector=function(a,b){if((a.ownerDocument||a)!==n&&m(a),b=b.replace(U,"='$1']"),!(!c.matchesSelector||!p||r&&r.test(b)||q&&q.test(b)))try{var d=s.call(a,b);if(d||c.disconnectedMatch||a.document&&11!==a.document.nodeType)return d}catch(e){}return ga(b,n,null,[a]).length>0},ga.contains=function(a,b){return(a.ownerDocument||a)!==n&&m(a),t(a,b)},ga.attr=function(a,b){(a.ownerDocument||a)!==n&&m(a);var e=d.attrHandle[b.toLowerCase()],f=e&&D.call(d.attrHandle,b.toLowerCase())?e(a,b,!p):void 0;return void 0!==f?f:c.attributes||!p?a.getAttribute(b):(f=a.getAttributeNode(b))&&f.specified?f.value:null},ga.error=function(a){throw new Error("Syntax error, unrecognized expression: "+a)},ga.uniqueSort=function(a){var b,d=[],e=0,f=0;if(l=!c.detectDuplicates,k=!c.sortStable&&a.slice(0),a.sort(B),l){while(b=a[f++])b===a[f]&&(e=d.push(f));while(e--)a.splice(d[e],1)}return k=null,a},e=ga.getText=function(a){var b,c="",d=0,f=a.nodeType;if(f){if(1===f||9===f||11===f){if("string"==typeof a.textContent)return a.textContent;for(a=a.firstChild;a;a=a.nextSibling)c+=e(a)}else if(3===f||4===f)return a.nodeValue}else while(b=a[d++])c+=e(b);return c},d=ga.selectors={cacheLength:50,createPseudo:ia,match:X,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(a){return a[1]=a[1].replace(ca,da),a[3]=(a[3]||a[4]||a[5]||"").replace(ca,da),"~="===a[2]&&(a[3]=" "+a[3]+" "),a.slice(0,4)},CHILD:function(a){return a[1]=a[1].toLowerCase(),"nth"===a[1].slice(0,3)?(a[3]||ga.error(a[0]),a[4]=+(a[4]?a[5]+(a[6]||1):2*("even"===a[3]||"odd"===a[3])),a[5]=+(a[7]+a[8]||"odd"===a[3])):a[3]&&ga.error(a[0]),a},PSEUDO:function(a){var b,c=!a[6]&&a[2];return X.CHILD.test(a[0])?null:(a[3]?a[2]=a[4]||a[5]||"":c&&V.test(c)&&(b=g(c,!0))&&(b=c.indexOf(")",c.length-b)-c.length)&&(a[0]=a[0].slice(0,b),a[2]=c.slice(0,b)),a.slice(0,3))}},filter:{TAG:function(a){var b=a.replace(ca,da).toLowerCase();return"*"===a?function(){return!0}:function(a){return a.nodeName&&a.nodeName.toLowerCase()===b}},CLASS:function(a){var b=y[a+" "];return b||(b=new RegExp("(^|"+L+")"+a+"("+L+"|$)"))&&y(a,function(a){return b.test("string"==typeof a.className&&a.className||"undefined"!=typeof a.getAttribute&&a.getAttribute("class")||"")})},ATTR:function(a,b,c){return function(d){var e=ga.attr(d,a);return null==e?"!="===b:b?(e+="","="===b?e===c:"!="===b?e!==c:"^="===b?c&&0===e.indexOf(c):"*="===b?c&&e.indexOf(c)>-1:"$="===b?c&&e.slice(-c.length)===c:"~="===b?(" "+e.replace(Q," ")+" ").indexOf(c)>-1:"|="===b?e===c||e.slice(0,c.length+1)===c+"-":!1):!0}},CHILD:function(a,b,c,d,e){var f="nth"!==a.slice(0,3),g="last"!==a.slice(-4),h="of-type"===b;return 1===d&&0===e?function(a){return!!a.parentNode}:function(b,c,i){var j,k,l,m,n,o,p=f!==g?"nextSibling":"previousSibling",q=b.parentNode,r=h&&b.nodeName.toLowerCase(),s=!i&&!h;if(q){if(f){while(p){l=b;while(l=l[p])if(h?l.nodeName.toLowerCase()===r:1===l.nodeType)return!1;o=p="only"===a&&!o&&"nextSibling"}return!0}if(o=[g?q.firstChild:q.lastChild],g&&s){k=q[u]||(q[u]={}),j=k[a]||[],n=j[0]===w&&j[1],m=j[0]===w&&j[2],l=n&&q.childNodes[n];while(l=++n&&l&&l[p]||(m=n=0)||o.pop())if(1===l.nodeType&&++m&&l===b){k[a]=[w,n,m];break}}else if(s&&(j=(b[u]||(b[u]={}))[a])&&j[0]===w)m=j[1];else while(l=++n&&l&&l[p]||(m=n=0)||o.pop())if((h?l.nodeName.toLowerCase()===r:1===l.nodeType)&&++m&&(s&&((l[u]||(l[u]={}))[a]=[w,m]),l===b))break;return m-=e,m===d||m%d===0&&m/d>=0}}},PSEUDO:function(a,b){var c,e=d.pseudos[a]||d.setFilters[a.toLowerCase()]||ga.error("unsupported pseudo: "+a);return e[u]?e(b):e.length>1?(c=[a,a,"",b],d.setFilters.hasOwnProperty(a.toLowerCase())?ia(function(a,c){var d,f=e(a,b),g=f.length;while(g--)d=J(a,f[g]),a[d]=!(c[d]=f[g])}):function(a){return e(a,0,c)}):e}},pseudos:{not:ia(function(a){var b=[],c=[],d=h(a.replace(R,"$1"));return d[u]?ia(function(a,b,c,e){var f,g=d(a,null,e,[]),h=a.length;while(h--)(f=g[h])&&(a[h]=!(b[h]=f))}):function(a,e,f){return b[0]=a,d(b,null,f,c),b[0]=null,!c.pop()}}),has:ia(function(a){return function(b){return ga(a,b).length>0}}),contains:ia(function(a){return a=a.replace(ca,da),function(b){return(b.textContent||b.innerText||e(b)).indexOf(a)>-1}}),lang:ia(function(a){return W.test(a||"")||ga.error("unsupported lang: "+a),a=a.replace(ca,da).toLowerCase(),function(b){var c;do if(c=p?b.lang:b.getAttribute("xml:lang")||b.getAttribute("lang"))return c=c.toLowerCase(),c===a||0===c.indexOf(a+"-");while((b=b.parentNode)&&1===b.nodeType);return!1}}),target:function(b){var c=a.location&&a.location.hash;return c&&c.slice(1)===b.id},root:function(a){return a===o},focus:function(a){return a===n.activeElement&&(!n.hasFocus||n.hasFocus())&&!!(a.type||a.href||~a.tabIndex)},enabled:function(a){return a.disabled===!1},disabled:function(a){return a.disabled===!0},checked:function(a){var b=a.nodeName.toLowerCase();return"input"===b&&!!a.checked||"option"===b&&!!a.selected},selected:function(a){return a.parentNode&&a.parentNode.selectedIndex,a.selected===!0},empty:function(a){for(a=a.firstChild;a;a=a.nextSibling)if(a.nodeType<6)return!1;return!0},parent:function(a){return!d.pseudos.empty(a)},header:function(a){return Z.test(a.nodeName)},input:function(a){return Y.test(a.nodeName)},button:function(a){var b=a.nodeName.toLowerCase();return"input"===b&&"button"===a.type||"button"===b},text:function(a){var b;return"input"===a.nodeName.toLowerCase()&&"text"===a.type&&(null==(b=a.getAttribute("type"))||"text"===b.toLowerCase())},first:oa(function(){return[0]}),last:oa(function(a,b){return[b-1]}),eq:oa(function(a,b,c){return[0>c?c+b:c]}),even:oa(function(a,b){for(var c=0;b>c;c+=2)a.push(c);return a}),odd:oa(function(a,b){for(var c=1;b>c;c+=2)a.push(c);return a}),lt:oa(function(a,b,c){for(var d=0>c?c+b:c;--d>=0;)a.push(d);return a}),gt:oa(function(a,b,c){for(var d=0>c?c+b:c;++d<b;)a.push(d);return a})}},d.pseudos.nth=d.pseudos.eq;for(b in{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})d.pseudos[b]=ma(b);for(b in{submit:!0,reset:!0})d.pseudos[b]=na(b);function qa(){}qa.prototype=d.filters=d.pseudos,d.setFilters=new qa,g=ga.tokenize=function(a,b){var c,e,f,g,h,i,j,k=z[a+" "];if(k)return b?0:k.slice(0);h=a,i=[],j=d.preFilter;while(h){(!c||(e=S.exec(h)))&&(e&&(h=h.slice(e[0].length)||h),i.push(f=[])),c=!1,(e=T.exec(h))&&(c=e.shift(),f.push({value:c,type:e[0].replace(R," ")}),h=h.slice(c.length));for(g in d.filter)!(e=X[g].exec(h))||j[g]&&!(e=j[g](e))||(c=e.shift(),f.push({value:c,type:g,matches:e}),h=h.slice(c.length));if(!c)break}return b?h.length:h?ga.error(a):z(a,i).slice(0)};function ra(a){for(var b=0,c=a.length,d="";c>b;b++)d+=a[b].value;return d}function sa(a,b,c){var d=b.dir,e=c&&"parentNode"===d,f=x++;return b.first?function(b,c,f){while(b=b[d])if(1===b.nodeType||e)return a(b,c,f)}:function(b,c,g){var h,i,j=[w,f];if(g){while(b=b[d])if((1===b.nodeType||e)&&a(b,c,g))return!0}else while(b=b[d])if(1===b.nodeType||e){if(i=b[u]||(b[u]={}),(h=i[d])&&h[0]===w&&h[1]===f)return j[2]=h[2];if(i[d]=j,j[2]=a(b,c,g))return!0}}}function ta(a){return a.length>1?function(b,c,d){var e=a.length;while(e--)if(!a[e](b,c,d))return!1;return!0}:a[0]}function ua(a,b,c){for(var d=0,e=b.length;e>d;d++)ga(a,b[d],c);return c}function va(a,b,c,d,e){for(var f,g=[],h=0,i=a.length,j=null!=b;i>h;h++)(f=a[h])&&(!c||c(f,d,e))&&(g.push(f),j&&b.push(h));return g}function wa(a,b,c,d,e,f){return d&&!d[u]&&(d=wa(d)),e&&!e[u]&&(e=wa(e,f)),ia(function(f,g,h,i){var j,k,l,m=[],n=[],o=g.length,p=f||ua(b||"*",h.nodeType?[h]:h,[]),q=!a||!f&&b?p:va(p,m,a,h,i),r=c?e||(f?a:o||d)?[]:g:q;if(c&&c(q,r,h,i),d){j=va(r,n),d(j,[],h,i),k=j.length;while(k--)(l=j[k])&&(r[n[k]]=!(q[n[k]]=l))}if(f){if(e||a){if(e){j=[],k=r.length;while(k--)(l=r[k])&&j.push(q[k]=l);e(null,r=[],j,i)}k=r.length;while(k--)(l=r[k])&&(j=e?J(f,l):m[k])>-1&&(f[j]=!(g[j]=l))}}else r=va(r===g?r.splice(o,r.length):r),e?e(null,g,r,i):H.apply(g,r)})}function xa(a){for(var b,c,e,f=a.length,g=d.relative[a[0].type],h=g||d.relative[" "],i=g?1:0,k=sa(function(a){return a===b},h,!0),l=sa(function(a){return J(b,a)>-1},h,!0),m=[function(a,c,d){var e=!g&&(d||c!==j)||((b=c).nodeType?k(a,c,d):l(a,c,d));return b=null,e}];f>i;i++)if(c=d.relative[a[i].type])m=[sa(ta(m),c)];else{if(c=d.filter[a[i].type].apply(null,a[i].matches),c[u]){for(e=++i;f>e;e++)if(d.relative[a[e].type])break;return wa(i>1&&ta(m),i>1&&ra(a.slice(0,i-1).concat({value:" "===a[i-2].type?"*":""})).replace(R,"$1"),c,e>i&&xa(a.slice(i,e)),f>e&&xa(a=a.slice(e)),f>e&&ra(a))}m.push(c)}return ta(m)}function ya(a,b){var c=b.length>0,e=a.length>0,f=function(f,g,h,i,k){var l,m,o,p=0,q="0",r=f&&[],s=[],t=j,u=f||e&&d.find.TAG("*",k),v=w+=null==t?1:Math.random()||.1,x=u.length;for(k&&(j=g!==n&&g);q!==x&&null!=(l=u[q]);q++){if(e&&l){m=0;while(o=a[m++])if(o(l,g,h)){i.push(l);break}k&&(w=v)}c&&((l=!o&&l)&&p--,f&&r.push(l))}if(p+=q,c&&q!==p){m=0;while(o=b[m++])o(r,s,g,h);if(f){if(p>0)while(q--)r[q]||s[q]||(s[q]=F.call(i));s=va(s)}H.apply(i,s),k&&!f&&s.length>0&&p+b.length>1&&ga.uniqueSort(i)}return k&&(w=v,j=t),r};return c?ia(f):f}return h=ga.compile=function(a,b){var c,d=[],e=[],f=A[a+" "];if(!f){b||(b=g(a)),c=b.length;while(c--)f=xa(b[c]),f[u]?d.push(f):e.push(f);f=A(a,ya(e,d)),f.selector=a}return f},i=ga.select=function(a,b,e,f){var i,j,k,l,m,n="function"==typeof a&&a,o=!f&&g(a=n.selector||a);if(e=e||[],1===o.length){if(j=o[0]=o[0].slice(0),j.length>2&&"ID"===(k=j[0]).type&&c.getById&&9===b.nodeType&&p&&d.relative[j[1].type]){if(b=(d.find.ID(k.matches[0].replace(ca,da),b)||[])[0],!b)return e;n&&(b=b.parentNode),a=a.slice(j.shift().value.length)}i=X.needsContext.test(a)?0:j.length;while(i--){if(k=j[i],d.relative[l=k.type])break;if((m=d.find[l])&&(f=m(k.matches[0].replace(ca,da),aa.test(j[0].type)&&pa(b.parentNode)||b))){if(j.splice(i,1),a=f.length&&ra(j),!a)return H.apply(e,f),e;break}}}return(n||h(a,o))(f,b,!p,e,aa.test(a)&&pa(b.parentNode)||b),e},c.sortStable=u.split("").sort(B).join("")===u,c.detectDuplicates=!!l,m(),c.sortDetached=ja(function(a){return 1&a.compareDocumentPosition(n.createElement("div"))}),ja(function(a){return a.innerHTML="<a href='#'></a>","#"===a.firstChild.getAttribute("href")})||ka("type|href|height|width",function(a,b,c){return c?void 0:a.getAttribute(b,"type"===b.toLowerCase()?1:2)}),c.attributes&&ja(function(a){return a.innerHTML="<input/>",a.firstChild.setAttribute("value",""),""===a.firstChild.getAttribute("value")})||ka("value",function(a,b,c){return c||"input"!==a.nodeName.toLowerCase()?void 0:a.defaultValue}),ja(function(a){return null==a.getAttribute("disabled")})||ka(K,function(a,b,c){var d;return c?void 0:a[b]===!0?b.toLowerCase():(d=a.getAttributeNode(b))&&d.specified?d.value:null}),ga}(a);n.find=t,n.expr=t.selectors,n.expr[":"]=n.expr.pseudos,n.unique=t.uniqueSort,n.text=t.getText,n.isXMLDoc=t.isXML,n.contains=t.contains;var u=n.expr.match.needsContext,v=/^<(\w+)\s*\/?>(?:<\/\1>|)$/,w=/^.[^:#\[\.,]*$/;function x(a,b,c){if(n.isFunction(b))return n.grep(a,function(a,d){return!!b.call(a,d,a)!==c});if(b.nodeType)return n.grep(a,function(a){return a===b!==c});if("string"==typeof b){if(w.test(b))return n.filter(b,a,c);b=n.filter(b,a)}return n.grep(a,function(a){return g.call(b,a)>=0!==c})}n.filter=function(a,b,c){var d=b[0];return c&&(a=":not("+a+")"),1===b.length&&1===d.nodeType?n.find.matchesSelector(d,a)?[d]:[]:n.find.matches(a,n.grep(b,function(a){return 1===a.nodeType}))},n.fn.extend({find:function(a){var b,c=this.length,d=[],e=this;if("string"!=typeof a)return this.pushStack(n(a).filter(function(){for(b=0;c>b;b++)if(n.contains(e[b],this))return!0}));for(b=0;c>b;b++)n.find(a,e[b],d);return d=this.pushStack(c>1?n.unique(d):d),d.selector=this.selector?this.selector+" "+a:a,d},filter:function(a){return this.pushStack(x(this,a||[],!1))},not:function(a){return this.pushStack(x(this,a||[],!0))},is:function(a){return!!x(this,"string"==typeof a&&u.test(a)?n(a):a||[],!1).length}});var y,z=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,A=n.fn.init=function(a,b){var c,d;if(!a)return this;if("string"==typeof a){if(c="<"===a[0]&&">"===a[a.length-1]&&a.length>=3?[null,a,null]:z.exec(a),!c||!c[1]&&b)return!b||b.jquery?(b||y).find(a):this.constructor(b).find(a);if(c[1]){if(b=b instanceof n?b[0]:b,n.merge(this,n.parseHTML(c[1],b&&b.nodeType?b.ownerDocument||b:l,!0)),v.test(c[1])&&n.isPlainObject(b))for(c in b)n.isFunction(this[c])?this[c](b[c]):this.attr(c,b[c]);return this}return d=l.getElementById(c[2]),d&&d.parentNode&&(this.length=1,this[0]=d),this.context=l,this.selector=a,this}return a.nodeType?(this.context=this[0]=a,this.length=1,this):n.isFunction(a)?"undefined"!=typeof y.ready?y.ready(a):a(n):(void 0!==a.selector&&(this.selector=a.selector,this.context=a.context),n.makeArray(a,this))};A.prototype=n.fn,y=n(l);var B=/^(?:parents|prev(?:Until|All))/,C={children:!0,contents:!0,next:!0,prev:!0};n.extend({dir:function(a,b,c){var d=[],e=void 0!==c;while((a=a[b])&&9!==a.nodeType)if(1===a.nodeType){if(e&&n(a).is(c))break;d.push(a)}return d},sibling:function(a,b){for(var c=[];a;a=a.nextSibling)1===a.nodeType&&a!==b&&c.push(a);return c}}),n.fn.extend({has:function(a){var b=n(a,this),c=b.length;return this.filter(function(){for(var a=0;c>a;a++)if(n.contains(this,b[a]))return!0})},closest:function(a,b){for(var c,d=0,e=this.length,f=[],g=u.test(a)||"string"!=typeof a?n(a,b||this.context):0;e>d;d++)for(c=this[d];c&&c!==b;c=c.parentNode)if(c.nodeType<11&&(g?g.index(c)>-1:1===c.nodeType&&n.find.matchesSelector(c,a))){f.push(c);break}return this.pushStack(f.length>1?n.unique(f):f)},index:function(a){return a?"string"==typeof a?g.call(n(a),this[0]):g.call(this,a.jquery?a[0]:a):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(a,b){return this.pushStack(n.unique(n.merge(this.get(),n(a,b))))},addBack:function(a){return this.add(null==a?this.prevObject:this.prevObject.filter(a))}});function D(a,b){while((a=a[b])&&1!==a.nodeType);return a}n.each({parent:function(a){var b=a.parentNode;return b&&11!==b.nodeType?b:null},parents:function(a){return n.dir(a,"parentNode")},parentsUntil:function(a,b,c){return n.dir(a,"parentNode",c)},next:function(a){return D(a,"nextSibling")},prev:function(a){return D(a,"previousSibling")},nextAll:function(a){return n.dir(a,"nextSibling")},prevAll:function(a){return n.dir(a,"previousSibling")},nextUntil:function(a,b,c){return n.dir(a,"nextSibling",c)},prevUntil:function(a,b,c){return n.dir(a,"previousSibling",c)},siblings:function(a){return n.sibling((a.parentNode||{}).firstChild,a)},children:function(a){return n.sibling(a.firstChild)},contents:function(a){return a.contentDocument||n.merge([],a.childNodes)}},function(a,b){n.fn[a]=function(c,d){var e=n.map(this,b,c);return"Until"!==a.slice(-5)&&(d=c),d&&"string"==typeof d&&(e=n.filter(d,e)),this.length>1&&(C[a]||n.unique(e),B.test(a)&&e.reverse()),this.pushStack(e)}});var E=/\S+/g,F={};function G(a){var b=F[a]={};return n.each(a.match(E)||[],function(a,c){b[c]=!0}),b}n.Callbacks=function(a){a="string"==typeof a?F[a]||G(a):n.extend({},a);var b,c,d,e,f,g,h=[],i=!a.once&&[],j=function(l){for(b=a.memory&&l,c=!0,g=e||0,e=0,f=h.length,d=!0;h&&f>g;g++)if(h[g].apply(l[0],l[1])===!1&&a.stopOnFalse){b=!1;break}d=!1,h&&(i?i.length&&j(i.shift()):b?h=[]:k.disable())},k={add:function(){if(h){var c=h.length;!function g(b){n.each(b,function(b,c){var d=n.type(c);"function"===d?a.unique&&k.has(c)||h.push(c):c&&c.length&&"string"!==d&&g(c)})}(arguments),d?f=h.length:b&&(e=c,j(b))}return this},remove:function(){return h&&n.each(arguments,function(a,b){var c;while((c=n.inArray(b,h,c))>-1)h.splice(c,1),d&&(f>=c&&f--,g>=c&&g--)}),this},has:function(a){return a?n.inArray(a,h)>-1:!(!h||!h.length)},empty:function(){return h=[],f=0,this},disable:function(){return h=i=b=void 0,this},disabled:function(){return!h},lock:function(){return i=void 0,b||k.disable(),this},locked:function(){return!i},fireWith:function(a,b){return!h||c&&!i||(b=b||[],b=[a,b.slice?b.slice():b],d?i.push(b):j(b)),this},fire:function(){return k.fireWith(this,arguments),this},fired:function(){return!!c}};return k},n.extend({Deferred:function(a){var b=[["resolve","done",n.Callbacks("once memory"),"resolved"],["reject","fail",n.Callbacks("once memory"),"rejected"],["notify","progress",n.Callbacks("memory")]],c="pending",d={state:function(){return c},always:function(){return e.done(arguments).fail(arguments),this},then:function(){var a=arguments;return n.Deferred(function(c){n.each(b,function(b,f){var g=n.isFunction(a[b])&&a[b];e[f[1]](function(){var a=g&&g.apply(this,arguments);a&&n.isFunction(a.promise)?a.promise().done(c.resolve).fail(c.reject).progress(c.notify):c[f[0]+"With"](this===d?c.promise():this,g?[a]:arguments)})}),a=null}).promise()},promise:function(a){return null!=a?n.extend(a,d):d}},e={};return d.pipe=d.then,n.each(b,function(a,f){var g=f[2],h=f[3];d[f[1]]=g.add,h&&g.add(function(){c=h},b[1^a][2].disable,b[2][2].lock),e[f[0]]=function(){return e[f[0]+"With"](this===e?d:this,arguments),this},e[f[0]+"With"]=g.fireWith}),d.promise(e),a&&a.call(e,e),e},when:function(a){var b=0,c=d.call(arguments),e=c.length,f=1!==e||a&&n.isFunction(a.promise)?e:0,g=1===f?a:n.Deferred(),h=function(a,b,c){return function(e){b[a]=this,c[a]=arguments.length>1?d.call(arguments):e,c===i?g.notifyWith(b,c):--f||g.resolveWith(b,c)}},i,j,k;if(e>1)for(i=new Array(e),j=new Array(e),k=new Array(e);e>b;b++)c[b]&&n.isFunction(c[b].promise)?c[b].promise().done(h(b,k,c)).fail(g.reject).progress(h(b,j,i)):--f;return f||g.resolveWith(k,c),g.promise()}});var H;n.fn.ready=function(a){return n.ready.promise().done(a),this},n.extend({isReady:!1,readyWait:1,holdReady:function(a){a?n.readyWait++:n.ready(!0)},ready:function(a){(a===!0?--n.readyWait:n.isReady)||(n.isReady=!0,a!==!0&&--n.readyWait>0||(H.resolveWith(l,[n]),n.fn.triggerHandler&&(n(l).triggerHandler("ready"),n(l).off("ready"))))}});function I(){l.removeEventListener("DOMContentLoaded",I,!1),a.removeEventListener("load",I,!1),n.ready()}n.ready.promise=function(b){return H||(H=n.Deferred(),"complete"===l.readyState?setTimeout(n.ready):(l.addEventListener("DOMContentLoaded",I,!1),a.addEventListener("load",I,!1))),H.promise(b)},n.ready.promise();var J=n.access=function(a,b,c,d,e,f,g){var h=0,i=a.length,j=null==c;if("object"===n.type(c)){e=!0;for(h in c)n.access(a,b,h,c[h],!0,f,g)}else if(void 0!==d&&(e=!0,n.isFunction(d)||(g=!0),j&&(g?(b.call(a,d),b=null):(j=b,b=function(a,b,c){return j.call(n(a),c)})),b))for(;i>h;h++)b(a[h],c,g?d:d.call(a[h],h,b(a[h],c)));return e?a:j?b.call(a):i?b(a[0],c):f};n.acceptData=function(a){return 1===a.nodeType||9===a.nodeType||!+a.nodeType};function K(){Object.defineProperty(this.cache={},0,{get:function(){return{}}}),this.expando=n.expando+K.uid++}K.uid=1,K.accepts=n.acceptData,K.prototype={key:function(a){if(!K.accepts(a))return 0;var b={},c=a[this.expando];if(!c){c=K.uid++;try{b[this.expando]={value:c},Object.defineProperties(a,b)}catch(d){b[this.expando]=c,n.extend(a,b)}}return this.cache[c]||(this.cache[c]={}),c},set:function(a,b,c){var d,e=this.key(a),f=this.cache[e];if("string"==typeof b)f[b]=c;else if(n.isEmptyObject(f))n.extend(this.cache[e],b);else for(d in b)f[d]=b[d];return f},get:function(a,b){var c=this.cache[this.key(a)];return void 0===b?c:c[b]},access:function(a,b,c){var d;return void 0===b||b&&"string"==typeof b&&void 0===c?(d=this.get(a,b),void 0!==d?d:this.get(a,n.camelCase(b))):(this.set(a,b,c),void 0!==c?c:b)},remove:function(a,b){var c,d,e,f=this.key(a),g=this.cache[f];if(void 0===b)this.cache[f]={};else{n.isArray(b)?d=b.concat(b.map(n.camelCase)):(e=n.camelCase(b),b in g?d=[b,e]:(d=e,d=d in g?[d]:d.match(E)||[])),c=d.length;while(c--)delete g[d[c]]}},hasData:function(a){return!n.isEmptyObject(this.cache[a[this.expando]]||{})},discard:function(a){a[this.expando]&&delete this.cache[a[this.expando]]}};var L=new K,M=new K,N=/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,O=/([A-Z])/g;function P(a,b,c){var d;if(void 0===c&&1===a.nodeType)if(d="data-"+b.replace(O,"-$1").toLowerCase(),c=a.getAttribute(d),"string"==typeof c){try{c="true"===c?!0:"false"===c?!1:"null"===c?null:+c+""===c?+c:N.test(c)?n.parseJSON(c):c}catch(e){}M.set(a,b,c)}else c=void 0;return c}n.extend({hasData:function(a){return M.hasData(a)||L.hasData(a)},data:function(a,b,c){
return M.access(a,b,c)},removeData:function(a,b){M.remove(a,b)},_data:function(a,b,c){return L.access(a,b,c)},_removeData:function(a,b){L.remove(a,b)}}),n.fn.extend({data:function(a,b){var c,d,e,f=this[0],g=f&&f.attributes;if(void 0===a){if(this.length&&(e=M.get(f),1===f.nodeType&&!L.get(f,"hasDataAttrs"))){c=g.length;while(c--)g[c]&&(d=g[c].name,0===d.indexOf("data-")&&(d=n.camelCase(d.slice(5)),P(f,d,e[d])));L.set(f,"hasDataAttrs",!0)}return e}return"object"==typeof a?this.each(function(){M.set(this,a)}):J(this,function(b){var c,d=n.camelCase(a);if(f&&void 0===b){if(c=M.get(f,a),void 0!==c)return c;if(c=M.get(f,d),void 0!==c)return c;if(c=P(f,d,void 0),void 0!==c)return c}else this.each(function(){var c=M.get(this,d);M.set(this,d,b),-1!==a.indexOf("-")&&void 0!==c&&M.set(this,a,b)})},null,b,arguments.length>1,null,!0)},removeData:function(a){return this.each(function(){M.remove(this,a)})}}),n.extend({queue:function(a,b,c){var d;return a?(b=(b||"fx")+"queue",d=L.get(a,b),c&&(!d||n.isArray(c)?d=L.access(a,b,n.makeArray(c)):d.push(c)),d||[]):void 0},dequeue:function(a,b){b=b||"fx";var c=n.queue(a,b),d=c.length,e=c.shift(),f=n._queueHooks(a,b),g=function(){n.dequeue(a,b)};"inprogress"===e&&(e=c.shift(),d--),e&&("fx"===b&&c.unshift("inprogress"),delete f.stop,e.call(a,g,f)),!d&&f&&f.empty.fire()},_queueHooks:function(a,b){var c=b+"queueHooks";return L.get(a,c)||L.access(a,c,{empty:n.Callbacks("once memory").add(function(){L.remove(a,[b+"queue",c])})})}}),n.fn.extend({queue:function(a,b){var c=2;return"string"!=typeof a&&(b=a,a="fx",c--),arguments.length<c?n.queue(this[0],a):void 0===b?this:this.each(function(){var c=n.queue(this,a,b);n._queueHooks(this,a),"fx"===a&&"inprogress"!==c[0]&&n.dequeue(this,a)})},dequeue:function(a){return this.each(function(){n.dequeue(this,a)})},clearQueue:function(a){return this.queue(a||"fx",[])},promise:function(a,b){var c,d=1,e=n.Deferred(),f=this,g=this.length,h=function(){--d||e.resolveWith(f,[f])};"string"!=typeof a&&(b=a,a=void 0),a=a||"fx";while(g--)c=L.get(f[g],a+"queueHooks"),c&&c.empty&&(d++,c.empty.add(h));return h(),e.promise(b)}});var Q=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,R=["Top","Right","Bottom","Left"],S=function(a,b){return a=b||a,"none"===n.css(a,"display")||!n.contains(a.ownerDocument,a)},T=/^(?:checkbox|radio)$/i;!function(){var a=l.createDocumentFragment(),b=a.appendChild(l.createElement("div")),c=l.createElement("input");c.setAttribute("type","radio"),c.setAttribute("checked","checked"),c.setAttribute("name","t"),b.appendChild(c),k.checkClone=b.cloneNode(!0).cloneNode(!0).lastChild.checked,b.innerHTML="<textarea>x</textarea>",k.noCloneChecked=!!b.cloneNode(!0).lastChild.defaultValue}();var U="undefined";k.focusinBubbles="onfocusin"in a;var V=/^key/,W=/^(?:mouse|pointer|contextmenu)|click/,X=/^(?:focusinfocus|focusoutblur)$/,Y=/^([^.]*)(?:\.(.+)|)$/;function Z(){return!0}function $(){return!1}function _(){try{return l.activeElement}catch(a){}}n.event={global:{},add:function(a,b,c,d,e){var f,g,h,i,j,k,l,m,o,p,q,r=L.get(a);if(r){c.handler&&(f=c,c=f.handler,e=f.selector),c.guid||(c.guid=n.guid++),(i=r.events)||(i=r.events={}),(g=r.handle)||(g=r.handle=function(b){return typeof n!==U&&n.event.triggered!==b.type?n.event.dispatch.apply(a,arguments):void 0}),b=(b||"").match(E)||[""],j=b.length;while(j--)h=Y.exec(b[j])||[],o=q=h[1],p=(h[2]||"").split(".").sort(),o&&(l=n.event.special[o]||{},o=(e?l.delegateType:l.bindType)||o,l=n.event.special[o]||{},k=n.extend({type:o,origType:q,data:d,handler:c,guid:c.guid,selector:e,needsContext:e&&n.expr.match.needsContext.test(e),namespace:p.join(".")},f),(m=i[o])||(m=i[o]=[],m.delegateCount=0,l.setup&&l.setup.call(a,d,p,g)!==!1||a.addEventListener&&a.addEventListener(o,g,!1)),l.add&&(l.add.call(a,k),k.handler.guid||(k.handler.guid=c.guid)),e?m.splice(m.delegateCount++,0,k):m.push(k),n.event.global[o]=!0)}},remove:function(a,b,c,d,e){var f,g,h,i,j,k,l,m,o,p,q,r=L.hasData(a)&&L.get(a);if(r&&(i=r.events)){b=(b||"").match(E)||[""],j=b.length;while(j--)if(h=Y.exec(b[j])||[],o=q=h[1],p=(h[2]||"").split(".").sort(),o){l=n.event.special[o]||{},o=(d?l.delegateType:l.bindType)||o,m=i[o]||[],h=h[2]&&new RegExp("(^|\\.)"+p.join("\\.(?:.*\\.|)")+"(\\.|$)"),g=f=m.length;while(f--)k=m[f],!e&&q!==k.origType||c&&c.guid!==k.guid||h&&!h.test(k.namespace)||d&&d!==k.selector&&("**"!==d||!k.selector)||(m.splice(f,1),k.selector&&m.delegateCount--,l.remove&&l.remove.call(a,k));g&&!m.length&&(l.teardown&&l.teardown.call(a,p,r.handle)!==!1||n.removeEvent(a,o,r.handle),delete i[o])}else for(o in i)n.event.remove(a,o+b[j],c,d,!0);n.isEmptyObject(i)&&(delete r.handle,L.remove(a,"events"))}},trigger:function(b,c,d,e){var f,g,h,i,k,m,o,p=[d||l],q=j.call(b,"type")?b.type:b,r=j.call(b,"namespace")?b.namespace.split("."):[];if(g=h=d=d||l,3!==d.nodeType&&8!==d.nodeType&&!X.test(q+n.event.triggered)&&(q.indexOf(".")>=0&&(r=q.split("."),q=r.shift(),r.sort()),k=q.indexOf(":")<0&&"on"+q,b=b[n.expando]?b:new n.Event(q,"object"==typeof b&&b),b.isTrigger=e?2:3,b.namespace=r.join("."),b.namespace_re=b.namespace?new RegExp("(^|\\.)"+r.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,b.result=void 0,b.target||(b.target=d),c=null==c?[b]:n.makeArray(c,[b]),o=n.event.special[q]||{},e||!o.trigger||o.trigger.apply(d,c)!==!1)){if(!e&&!o.noBubble&&!n.isWindow(d)){for(i=o.delegateType||q,X.test(i+q)||(g=g.parentNode);g;g=g.parentNode)p.push(g),h=g;h===(d.ownerDocument||l)&&p.push(h.defaultView||h.parentWindow||a)}f=0;while((g=p[f++])&&!b.isPropagationStopped())b.type=f>1?i:o.bindType||q,m=(L.get(g,"events")||{})[b.type]&&L.get(g,"handle"),m&&m.apply(g,c),m=k&&g[k],m&&m.apply&&n.acceptData(g)&&(b.result=m.apply(g,c),b.result===!1&&b.preventDefault());return b.type=q,e||b.isDefaultPrevented()||o._default&&o._default.apply(p.pop(),c)!==!1||!n.acceptData(d)||k&&n.isFunction(d[q])&&!n.isWindow(d)&&(h=d[k],h&&(d[k]=null),n.event.triggered=q,d[q](),n.event.triggered=void 0,h&&(d[k]=h)),b.result}},dispatch:function(a){a=n.event.fix(a);var b,c,e,f,g,h=[],i=d.call(arguments),j=(L.get(this,"events")||{})[a.type]||[],k=n.event.special[a.type]||{};if(i[0]=a,a.delegateTarget=this,!k.preDispatch||k.preDispatch.call(this,a)!==!1){h=n.event.handlers.call(this,a,j),b=0;while((f=h[b++])&&!a.isPropagationStopped()){a.currentTarget=f.elem,c=0;while((g=f.handlers[c++])&&!a.isImmediatePropagationStopped())(!a.namespace_re||a.namespace_re.test(g.namespace))&&(a.handleObj=g,a.data=g.data,e=((n.event.special[g.origType]||{}).handle||g.handler).apply(f.elem,i),void 0!==e&&(a.result=e)===!1&&(a.preventDefault(),a.stopPropagation()))}return k.postDispatch&&k.postDispatch.call(this,a),a.result}},handlers:function(a,b){var c,d,e,f,g=[],h=b.delegateCount,i=a.target;if(h&&i.nodeType&&(!a.button||"click"!==a.type))for(;i!==this;i=i.parentNode||this)if(i.disabled!==!0||"click"!==a.type){for(d=[],c=0;h>c;c++)f=b[c],e=f.selector+" ",void 0===d[e]&&(d[e]=f.needsContext?n(e,this).index(i)>=0:n.find(e,this,null,[i]).length),d[e]&&d.push(f);d.length&&g.push({elem:i,handlers:d})}return h<b.length&&g.push({elem:this,handlers:b.slice(h)}),g},props:"altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),fixHooks:{},keyHooks:{props:"char charCode key keyCode".split(" "),filter:function(a,b){return null==a.which&&(a.which=null!=b.charCode?b.charCode:b.keyCode),a}},mouseHooks:{props:"button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(" "),filter:function(a,b){var c,d,e,f=b.button;return null==a.pageX&&null!=b.clientX&&(c=a.target.ownerDocument||l,d=c.documentElement,e=c.body,a.pageX=b.clientX+(d&&d.scrollLeft||e&&e.scrollLeft||0)-(d&&d.clientLeft||e&&e.clientLeft||0),a.pageY=b.clientY+(d&&d.scrollTop||e&&e.scrollTop||0)-(d&&d.clientTop||e&&e.clientTop||0)),a.which||void 0===f||(a.which=1&f?1:2&f?3:4&f?2:0),a}},fix:function(a){if(a[n.expando])return a;var b,c,d,e=a.type,f=a,g=this.fixHooks[e];g||(this.fixHooks[e]=g=W.test(e)?this.mouseHooks:V.test(e)?this.keyHooks:{}),d=g.props?this.props.concat(g.props):this.props,a=new n.Event(f),b=d.length;while(b--)c=d[b],a[c]=f[c];return a.target||(a.target=l),3===a.target.nodeType&&(a.target=a.target.parentNode),g.filter?g.filter(a,f):a},special:{load:{noBubble:!0},focus:{trigger:function(){return this!==_()&&this.focus?(this.focus(),!1):void 0},delegateType:"focusin"},blur:{trigger:function(){return this===_()&&this.blur?(this.blur(),!1):void 0},delegateType:"focusout"},click:{trigger:function(){return"checkbox"===this.type&&this.click&&n.nodeName(this,"input")?(this.click(),!1):void 0},_default:function(a){return n.nodeName(a.target,"a")}},beforeunload:{postDispatch:function(a){void 0!==a.result&&a.originalEvent&&(a.originalEvent.returnValue=a.result)}}},simulate:function(a,b,c,d){var e=n.extend(new n.Event,c,{type:a,isSimulated:!0,originalEvent:{}});d?n.event.trigger(e,null,b):n.event.dispatch.call(b,e),e.isDefaultPrevented()&&c.preventDefault()}},n.removeEvent=function(a,b,c){a.removeEventListener&&a.removeEventListener(b,c,!1)},n.Event=function(a,b){return this instanceof n.Event?(a&&a.type?(this.originalEvent=a,this.type=a.type,this.isDefaultPrevented=a.defaultPrevented||void 0===a.defaultPrevented&&a.returnValue===!1?Z:$):this.type=a,b&&n.extend(this,b),this.timeStamp=a&&a.timeStamp||n.now(),void(this[n.expando]=!0)):new n.Event(a,b)},n.Event.prototype={isDefaultPrevented:$,isPropagationStopped:$,isImmediatePropagationStopped:$,preventDefault:function(){var a=this.originalEvent;this.isDefaultPrevented=Z,a&&a.preventDefault&&a.preventDefault()},stopPropagation:function(){var a=this.originalEvent;this.isPropagationStopped=Z,a&&a.stopPropagation&&a.stopPropagation()},stopImmediatePropagation:function(){var a=this.originalEvent;this.isImmediatePropagationStopped=Z,a&&a.stopImmediatePropagation&&a.stopImmediatePropagation(),this.stopPropagation()}},n.each({mouseenter:"mouseover",mouseleave:"mouseout",pointerenter:"pointerover",pointerleave:"pointerout"},function(a,b){n.event.special[a]={delegateType:b,bindType:b,handle:function(a){var c,d=this,e=a.relatedTarget,f=a.handleObj;return(!e||e!==d&&!n.contains(d,e))&&(a.type=f.origType,c=f.handler.apply(this,arguments),a.type=b),c}}}),k.focusinBubbles||n.each({focus:"focusin",blur:"focusout"},function(a,b){var c=function(a){n.event.simulate(b,a.target,n.event.fix(a),!0)};n.event.special[b]={setup:function(){var d=this.ownerDocument||this,e=L.access(d,b);e||d.addEventListener(a,c,!0),L.access(d,b,(e||0)+1)},teardown:function(){var d=this.ownerDocument||this,e=L.access(d,b)-1;e?L.access(d,b,e):(d.removeEventListener(a,c,!0),L.remove(d,b))}}}),n.fn.extend({on:function(a,b,c,d,e){var f,g;if("object"==typeof a){"string"!=typeof b&&(c=c||b,b=void 0);for(g in a)this.on(g,b,c,a[g],e);return this}if(null==c&&null==d?(d=b,c=b=void 0):null==d&&("string"==typeof b?(d=c,c=void 0):(d=c,c=b,b=void 0)),d===!1)d=$;else if(!d)return this;return 1===e&&(f=d,d=function(a){return n().off(a),f.apply(this,arguments)},d.guid=f.guid||(f.guid=n.guid++)),this.each(function(){n.event.add(this,a,d,c,b)})},one:function(a,b,c,d){return this.on(a,b,c,d,1)},off:function(a,b,c){var d,e;if(a&&a.preventDefault&&a.handleObj)return d=a.handleObj,n(a.delegateTarget).off(d.namespace?d.origType+"."+d.namespace:d.origType,d.selector,d.handler),this;if("object"==typeof a){for(e in a)this.off(e,b,a[e]);return this}return(b===!1||"function"==typeof b)&&(c=b,b=void 0),c===!1&&(c=$),this.each(function(){n.event.remove(this,a,c,b)})},trigger:function(a,b){return this.each(function(){n.event.trigger(a,b,this)})},triggerHandler:function(a,b){var c=this[0];return c?n.event.trigger(a,b,c,!0):void 0}});var aa=/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,ba=/<([\w:]+)/,ca=/<|&#?\w+;/,da=/<(?:script|style|link)/i,ea=/checked\s*(?:[^=]|=\s*.checked.)/i,fa=/^$|\/(?:java|ecma)script/i,ga=/^true\/(.*)/,ha=/^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,ia={option:[1,"<select multiple='multiple'>","</select>"],thead:[1,"<table>","</table>"],col:[2,"<table><colgroup>","</colgroup></table>"],tr:[2,"<table><tbody>","</tbody></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:[0,"",""]};ia.optgroup=ia.option,ia.tbody=ia.tfoot=ia.colgroup=ia.caption=ia.thead,ia.th=ia.td;function ja(a,b){return n.nodeName(a,"table")&&n.nodeName(11!==b.nodeType?b:b.firstChild,"tr")?a.getElementsByTagName("tbody")[0]||a.appendChild(a.ownerDocument.createElement("tbody")):a}function ka(a){return a.type=(null!==a.getAttribute("type"))+"/"+a.type,a}function la(a){var b=ga.exec(a.type);return b?a.type=b[1]:a.removeAttribute("type"),a}function ma(a,b){for(var c=0,d=a.length;d>c;c++)L.set(a[c],"globalEval",!b||L.get(b[c],"globalEval"))}function na(a,b){var c,d,e,f,g,h,i,j;if(1===b.nodeType){if(L.hasData(a)&&(f=L.access(a),g=L.set(b,f),j=f.events)){delete g.handle,g.events={};for(e in j)for(c=0,d=j[e].length;d>c;c++)n.event.add(b,e,j[e][c])}M.hasData(a)&&(h=M.access(a),i=n.extend({},h),M.set(b,i))}}function oa(a,b){var c=a.getElementsByTagName?a.getElementsByTagName(b||"*"):a.querySelectorAll?a.querySelectorAll(b||"*"):[];return void 0===b||b&&n.nodeName(a,b)?n.merge([a],c):c}function pa(a,b){var c=b.nodeName.toLowerCase();"input"===c&&T.test(a.type)?b.checked=a.checked:("input"===c||"textarea"===c)&&(b.defaultValue=a.defaultValue)}n.extend({clone:function(a,b,c){var d,e,f,g,h=a.cloneNode(!0),i=n.contains(a.ownerDocument,a);if(!(k.noCloneChecked||1!==a.nodeType&&11!==a.nodeType||n.isXMLDoc(a)))for(g=oa(h),f=oa(a),d=0,e=f.length;e>d;d++)pa(f[d],g[d]);if(b)if(c)for(f=f||oa(a),g=g||oa(h),d=0,e=f.length;e>d;d++)na(f[d],g[d]);else na(a,h);return g=oa(h,"script"),g.length>0&&ma(g,!i&&oa(a,"script")),h},buildFragment:function(a,b,c,d){for(var e,f,g,h,i,j,k=b.createDocumentFragment(),l=[],m=0,o=a.length;o>m;m++)if(e=a[m],e||0===e)if("object"===n.type(e))n.merge(l,e.nodeType?[e]:e);else if(ca.test(e)){f=f||k.appendChild(b.createElement("div")),g=(ba.exec(e)||["",""])[1].toLowerCase(),h=ia[g]||ia._default,f.innerHTML=h[1]+e.replace(aa,"<$1></$2>")+h[2],j=h[0];while(j--)f=f.lastChild;n.merge(l,f.childNodes),f=k.firstChild,f.textContent=""}else l.push(b.createTextNode(e));k.textContent="",m=0;while(e=l[m++])if((!d||-1===n.inArray(e,d))&&(i=n.contains(e.ownerDocument,e),f=oa(k.appendChild(e),"script"),i&&ma(f),c)){j=0;while(e=f[j++])fa.test(e.type||"")&&c.push(e)}return k},cleanData:function(a){for(var b,c,d,e,f=n.event.special,g=0;void 0!==(c=a[g]);g++){if(n.acceptData(c)&&(e=c[L.expando],e&&(b=L.cache[e]))){if(b.events)for(d in b.events)f[d]?n.event.remove(c,d):n.removeEvent(c,d,b.handle);L.cache[e]&&delete L.cache[e]}delete M.cache[c[M.expando]]}}}),n.fn.extend({text:function(a){return J(this,function(a){return void 0===a?n.text(this):this.empty().each(function(){(1===this.nodeType||11===this.nodeType||9===this.nodeType)&&(this.textContent=a)})},null,a,arguments.length)},append:function(){return this.domManip(arguments,function(a){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var b=ja(this,a);b.appendChild(a)}})},prepend:function(){return this.domManip(arguments,function(a){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var b=ja(this,a);b.insertBefore(a,b.firstChild)}})},before:function(){return this.domManip(arguments,function(a){this.parentNode&&this.parentNode.insertBefore(a,this)})},after:function(){return this.domManip(arguments,function(a){this.parentNode&&this.parentNode.insertBefore(a,this.nextSibling)})},remove:function(a,b){for(var c,d=a?n.filter(a,this):this,e=0;null!=(c=d[e]);e++)b||1!==c.nodeType||n.cleanData(oa(c)),c.parentNode&&(b&&n.contains(c.ownerDocument,c)&&ma(oa(c,"script")),c.parentNode.removeChild(c));return this},empty:function(){for(var a,b=0;null!=(a=this[b]);b++)1===a.nodeType&&(n.cleanData(oa(a,!1)),a.textContent="");return this},clone:function(a,b){return a=null==a?!1:a,b=null==b?a:b,this.map(function(){return n.clone(this,a,b)})},html:function(a){return J(this,function(a){var b=this[0]||{},c=0,d=this.length;if(void 0===a&&1===b.nodeType)return b.innerHTML;if("string"==typeof a&&!da.test(a)&&!ia[(ba.exec(a)||["",""])[1].toLowerCase()]){a=a.replace(aa,"<$1></$2>");try{for(;d>c;c++)b=this[c]||{},1===b.nodeType&&(n.cleanData(oa(b,!1)),b.innerHTML=a);b=0}catch(e){}}b&&this.empty().append(a)},null,a,arguments.length)},replaceWith:function(){var a=arguments[0];return this.domManip(arguments,function(b){a=this.parentNode,n.cleanData(oa(this)),a&&a.replaceChild(b,this)}),a&&(a.length||a.nodeType)?this:this.remove()},detach:function(a){return this.remove(a,!0)},domManip:function(a,b){a=e.apply([],a);var c,d,f,g,h,i,j=0,l=this.length,m=this,o=l-1,p=a[0],q=n.isFunction(p);if(q||l>1&&"string"==typeof p&&!k.checkClone&&ea.test(p))return this.each(function(c){var d=m.eq(c);q&&(a[0]=p.call(this,c,d.html())),d.domManip(a,b)});if(l&&(c=n.buildFragment(a,this[0].ownerDocument,!1,this),d=c.firstChild,1===c.childNodes.length&&(c=d),d)){for(f=n.map(oa(c,"script"),ka),g=f.length;l>j;j++)h=c,j!==o&&(h=n.clone(h,!0,!0),g&&n.merge(f,oa(h,"script"))),b.call(this[j],h,j);if(g)for(i=f[f.length-1].ownerDocument,n.map(f,la),j=0;g>j;j++)h=f[j],fa.test(h.type||"")&&!L.access(h,"globalEval")&&n.contains(i,h)&&(h.src?n._evalUrl&&n._evalUrl(h.src):n.globalEval(h.textContent.replace(ha,"")))}return this}}),n.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(a,b){n.fn[a]=function(a){for(var c,d=[],e=n(a),g=e.length-1,h=0;g>=h;h++)c=h===g?this:this.clone(!0),n(e[h])[b](c),f.apply(d,c.get());return this.pushStack(d)}});var qa,ra={};function sa(b,c){var d,e=n(c.createElement(b)).appendTo(c.body),f=a.getDefaultComputedStyle&&(d=a.getDefaultComputedStyle(e[0]))?d.display:n.css(e[0],"display");return e.detach(),f}function ta(a){var b=l,c=ra[a];return c||(c=sa(a,b),"none"!==c&&c||(qa=(qa||n("<iframe frameborder='0' width='0' height='0'/>")).appendTo(b.documentElement),b=qa[0].contentDocument,b.write(),b.close(),c=sa(a,b),qa.detach()),ra[a]=c),c}var ua=/^margin/,va=new RegExp("^("+Q+")(?!px)[a-z%]+$","i"),wa=function(b){return b.ownerDocument.defaultView.opener?b.ownerDocument.defaultView.getComputedStyle(b,null):a.getComputedStyle(b,null)};function xa(a,b,c){var d,e,f,g,h=a.style;return c=c||wa(a),c&&(g=c.getPropertyValue(b)||c[b]),c&&(""!==g||n.contains(a.ownerDocument,a)||(g=n.style(a,b)),va.test(g)&&ua.test(b)&&(d=h.width,e=h.minWidth,f=h.maxWidth,h.minWidth=h.maxWidth=h.width=g,g=c.width,h.width=d,h.minWidth=e,h.maxWidth=f)),void 0!==g?g+"":g}function ya(a,b){return{get:function(){return a()?void delete this.get:(this.get=b).apply(this,arguments)}}}!function(){var b,c,d=l.documentElement,e=l.createElement("div"),f=l.createElement("div");if(f.style){f.style.backgroundClip="content-box",f.cloneNode(!0).style.backgroundClip="",k.clearCloneStyle="content-box"===f.style.backgroundClip,e.style.cssText="border:0;width:0;height:0;top:0;left:-9999px;margin-top:1px;position:absolute",e.appendChild(f);function g(){f.style.cssText="-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;display:block;margin-top:1%;top:1%;border:1px;padding:1px;width:4px;position:absolute",f.innerHTML="",d.appendChild(e);var g=a.getComputedStyle(f,null);b="1%"!==g.top,c="4px"===g.width,d.removeChild(e)}a.getComputedStyle&&n.extend(k,{pixelPosition:function(){return g(),b},boxSizingReliable:function(){return null==c&&g(),c},reliableMarginRight:function(){var b,c=f.appendChild(l.createElement("div"));return c.style.cssText=f.style.cssText="-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0",c.style.marginRight=c.style.width="0",f.style.width="1px",d.appendChild(e),b=!parseFloat(a.getComputedStyle(c,null).marginRight),d.removeChild(e),f.removeChild(c),b}})}}(),n.swap=function(a,b,c,d){var e,f,g={};for(f in b)g[f]=a.style[f],a.style[f]=b[f];e=c.apply(a,d||[]);for(f in b)a.style[f]=g[f];return e};var za=/^(none|table(?!-c[ea]).+)/,Aa=new RegExp("^("+Q+")(.*)$","i"),Ba=new RegExp("^([+-])=("+Q+")","i"),Ca={position:"absolute",visibility:"hidden",display:"block"},Da={letterSpacing:"0",fontWeight:"400"},Ea=["Webkit","O","Moz","ms"];function Fa(a,b){if(b in a)return b;var c=b[0].toUpperCase()+b.slice(1),d=b,e=Ea.length;while(e--)if(b=Ea[e]+c,b in a)return b;return d}function Ga(a,b,c){var d=Aa.exec(b);return d?Math.max(0,d[1]-(c||0))+(d[2]||"px"):b}function Ha(a,b,c,d,e){for(var f=c===(d?"border":"content")?4:"width"===b?1:0,g=0;4>f;f+=2)"margin"===c&&(g+=n.css(a,c+R[f],!0,e)),d?("content"===c&&(g-=n.css(a,"padding"+R[f],!0,e)),"margin"!==c&&(g-=n.css(a,"border"+R[f]+"Width",!0,e))):(g+=n.css(a,"padding"+R[f],!0,e),"padding"!==c&&(g+=n.css(a,"border"+R[f]+"Width",!0,e)));return g}function Ia(a,b,c){var d=!0,e="width"===b?a.offsetWidth:a.offsetHeight,f=wa(a),g="border-box"===n.css(a,"boxSizing",!1,f);if(0>=e||null==e){if(e=xa(a,b,f),(0>e||null==e)&&(e=a.style[b]),va.test(e))return e;d=g&&(k.boxSizingReliable()||e===a.style[b]),e=parseFloat(e)||0}return e+Ha(a,b,c||(g?"border":"content"),d,f)+"px"}function Ja(a,b){for(var c,d,e,f=[],g=0,h=a.length;h>g;g++)d=a[g],d.style&&(f[g]=L.get(d,"olddisplay"),c=d.style.display,b?(f[g]||"none"!==c||(d.style.display=""),""===d.style.display&&S(d)&&(f[g]=L.access(d,"olddisplay",ta(d.nodeName)))):(e=S(d),"none"===c&&e||L.set(d,"olddisplay",e?c:n.css(d,"display"))));for(g=0;h>g;g++)d=a[g],d.style&&(b&&"none"!==d.style.display&&""!==d.style.display||(d.style.display=b?f[g]||"":"none"));return a}n.extend({cssHooks:{opacity:{get:function(a,b){if(b){var c=xa(a,"opacity");return""===c?"1":c}}}},cssNumber:{columnCount:!0,fillOpacity:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,widows:!0,zIndex:!0,zoom:!0},cssProps:{"float":"cssFloat"},style:function(a,b,c,d){if(a&&3!==a.nodeType&&8!==a.nodeType&&a.style){var e,f,g,h=n.camelCase(b),i=a.style;return b=n.cssProps[h]||(n.cssProps[h]=Fa(i,h)),g=n.cssHooks[b]||n.cssHooks[h],void 0===c?g&&"get"in g&&void 0!==(e=g.get(a,!1,d))?e:i[b]:(f=typeof c,"string"===f&&(e=Ba.exec(c))&&(c=(e[1]+1)*e[2]+parseFloat(n.css(a,b)),f="number"),null!=c&&c===c&&("number"!==f||n.cssNumber[h]||(c+="px"),k.clearCloneStyle||""!==c||0!==b.indexOf("background")||(i[b]="inherit"),g&&"set"in g&&void 0===(c=g.set(a,c,d))||(i[b]=c)),void 0)}},css:function(a,b,c,d){var e,f,g,h=n.camelCase(b);return b=n.cssProps[h]||(n.cssProps[h]=Fa(a.style,h)),g=n.cssHooks[b]||n.cssHooks[h],g&&"get"in g&&(e=g.get(a,!0,c)),void 0===e&&(e=xa(a,b,d)),"normal"===e&&b in Da&&(e=Da[b]),""===c||c?(f=parseFloat(e),c===!0||n.isNumeric(f)?f||0:e):e}}),n.each(["height","width"],function(a,b){n.cssHooks[b]={get:function(a,c,d){return c?za.test(n.css(a,"display"))&&0===a.offsetWidth?n.swap(a,Ca,function(){return Ia(a,b,d)}):Ia(a,b,d):void 0},set:function(a,c,d){var e=d&&wa(a);return Ga(a,c,d?Ha(a,b,d,"border-box"===n.css(a,"boxSizing",!1,e),e):0)}}}),n.cssHooks.marginRight=ya(k.reliableMarginRight,function(a,b){return b?n.swap(a,{display:"inline-block"},xa,[a,"marginRight"]):void 0}),n.each({margin:"",padding:"",border:"Width"},function(a,b){n.cssHooks[a+b]={expand:function(c){for(var d=0,e={},f="string"==typeof c?c.split(" "):[c];4>d;d++)e[a+R[d]+b]=f[d]||f[d-2]||f[0];return e}},ua.test(a)||(n.cssHooks[a+b].set=Ga)}),n.fn.extend({css:function(a,b){return J(this,function(a,b,c){var d,e,f={},g=0;if(n.isArray(b)){for(d=wa(a),e=b.length;e>g;g++)f[b[g]]=n.css(a,b[g],!1,d);return f}return void 0!==c?n.style(a,b,c):n.css(a,b)},a,b,arguments.length>1)},show:function(){return Ja(this,!0)},hide:function(){return Ja(this)},toggle:function(a){return"boolean"==typeof a?a?this.show():this.hide():this.each(function(){S(this)?n(this).show():n(this).hide()})}});function Ka(a,b,c,d,e){return new Ka.prototype.init(a,b,c,d,e)}n.Tween=Ka,Ka.prototype={constructor:Ka,init:function(a,b,c,d,e,f){this.elem=a,this.prop=c,this.easing=e||"swing",this.options=b,this.start=this.now=this.cur(),this.end=d,this.unit=f||(n.cssNumber[c]?"":"px")},cur:function(){var a=Ka.propHooks[this.prop];return a&&a.get?a.get(this):Ka.propHooks._default.get(this)},run:function(a){var b,c=Ka.propHooks[this.prop];return this.options.duration?this.pos=b=n.easing[this.easing](a,this.options.duration*a,0,1,this.options.duration):this.pos=b=a,this.now=(this.end-this.start)*b+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),c&&c.set?c.set(this):Ka.propHooks._default.set(this),this}},Ka.prototype.init.prototype=Ka.prototype,Ka.propHooks={_default:{get:function(a){var b;return null==a.elem[a.prop]||a.elem.style&&null!=a.elem.style[a.prop]?(b=n.css(a.elem,a.prop,""),b&&"auto"!==b?b:0):a.elem[a.prop]},set:function(a){n.fx.step[a.prop]?n.fx.step[a.prop](a):a.elem.style&&(null!=a.elem.style[n.cssProps[a.prop]]||n.cssHooks[a.prop])?n.style(a.elem,a.prop,a.now+a.unit):a.elem[a.prop]=a.now}}},Ka.propHooks.scrollTop=Ka.propHooks.scrollLeft={set:function(a){a.elem.nodeType&&a.elem.parentNode&&(a.elem[a.prop]=a.now)}},n.easing={linear:function(a){return a},swing:function(a){return.5-Math.cos(a*Math.PI)/2}},n.fx=Ka.prototype.init,n.fx.step={};var La,Ma,Na=/^(?:toggle|show|hide)$/,Oa=new RegExp("^(?:([+-])=|)("+Q+")([a-z%]*)$","i"),Pa=/queueHooks$/,Qa=[Va],Ra={"*":[function(a,b){var c=this.createTween(a,b),d=c.cur(),e=Oa.exec(b),f=e&&e[3]||(n.cssNumber[a]?"":"px"),g=(n.cssNumber[a]||"px"!==f&&+d)&&Oa.exec(n.css(c.elem,a)),h=1,i=20;if(g&&g[3]!==f){f=f||g[3],e=e||[],g=+d||1;do h=h||".5",g/=h,n.style(c.elem,a,g+f);while(h!==(h=c.cur()/d)&&1!==h&&--i)}return e&&(g=c.start=+g||+d||0,c.unit=f,c.end=e[1]?g+(e[1]+1)*e[2]:+e[2]),c}]};function Sa(){return setTimeout(function(){La=void 0}),La=n.now()}function Ta(a,b){var c,d=0,e={height:a};for(b=b?1:0;4>d;d+=2-b)c=R[d],e["margin"+c]=e["padding"+c]=a;return b&&(e.opacity=e.width=a),e}function Ua(a,b,c){for(var d,e=(Ra[b]||[]).concat(Ra["*"]),f=0,g=e.length;g>f;f++)if(d=e[f].call(c,b,a))return d}function Va(a,b,c){var d,e,f,g,h,i,j,k,l=this,m={},o=a.style,p=a.nodeType&&S(a),q=L.get(a,"fxshow");c.queue||(h=n._queueHooks(a,"fx"),null==h.unqueued&&(h.unqueued=0,i=h.empty.fire,h.empty.fire=function(){h.unqueued||i()}),h.unqueued++,l.always(function(){l.always(function(){h.unqueued--,n.queue(a,"fx").length||h.empty.fire()})})),1===a.nodeType&&("height"in b||"width"in b)&&(c.overflow=[o.overflow,o.overflowX,o.overflowY],j=n.css(a,"display"),k="none"===j?L.get(a,"olddisplay")||ta(a.nodeName):j,"inline"===k&&"none"===n.css(a,"float")&&(o.display="inline-block")),c.overflow&&(o.overflow="hidden",l.always(function(){o.overflow=c.overflow[0],o.overflowX=c.overflow[1],o.overflowY=c.overflow[2]}));for(d in b)if(e=b[d],Na.exec(e)){if(delete b[d],f=f||"toggle"===e,e===(p?"hide":"show")){if("show"!==e||!q||void 0===q[d])continue;p=!0}m[d]=q&&q[d]||n.style(a,d)}else j=void 0;if(n.isEmptyObject(m))"inline"===("none"===j?ta(a.nodeName):j)&&(o.display=j);else{q?"hidden"in q&&(p=q.hidden):q=L.access(a,"fxshow",{}),f&&(q.hidden=!p),p?n(a).show():l.done(function(){n(a).hide()}),l.done(function(){var b;L.remove(a,"fxshow");for(b in m)n.style(a,b,m[b])});for(d in m)g=Ua(p?q[d]:0,d,l),d in q||(q[d]=g.start,p&&(g.end=g.start,g.start="width"===d||"height"===d?1:0))}}function Wa(a,b){var c,d,e,f,g;for(c in a)if(d=n.camelCase(c),e=b[d],f=a[c],n.isArray(f)&&(e=f[1],f=a[c]=f[0]),c!==d&&(a[d]=f,delete a[c]),g=n.cssHooks[d],g&&"expand"in g){f=g.expand(f),delete a[d];for(c in f)c in a||(a[c]=f[c],b[c]=e)}else b[d]=e}function Xa(a,b,c){var d,e,f=0,g=Qa.length,h=n.Deferred().always(function(){delete i.elem}),i=function(){if(e)return!1;for(var b=La||Sa(),c=Math.max(0,j.startTime+j.duration-b),d=c/j.duration||0,f=1-d,g=0,i=j.tweens.length;i>g;g++)j.tweens[g].run(f);return h.notifyWith(a,[j,f,c]),1>f&&i?c:(h.resolveWith(a,[j]),!1)},j=h.promise({elem:a,props:n.extend({},b),opts:n.extend(!0,{specialEasing:{}},c),originalProperties:b,originalOptions:c,startTime:La||Sa(),duration:c.duration,tweens:[],createTween:function(b,c){var d=n.Tween(a,j.opts,b,c,j.opts.specialEasing[b]||j.opts.easing);return j.tweens.push(d),d},stop:function(b){var c=0,d=b?j.tweens.length:0;if(e)return this;for(e=!0;d>c;c++)j.tweens[c].run(1);return b?h.resolveWith(a,[j,b]):h.rejectWith(a,[j,b]),this}}),k=j.props;for(Wa(k,j.opts.specialEasing);g>f;f++)if(d=Qa[f].call(j,a,k,j.opts))return d;return n.map(k,Ua,j),n.isFunction(j.opts.start)&&j.opts.start.call(a,j),n.fx.timer(n.extend(i,{elem:a,anim:j,queue:j.opts.queue})),j.progress(j.opts.progress).done(j.opts.done,j.opts.complete).fail(j.opts.fail).always(j.opts.always)}n.Animation=n.extend(Xa,{tweener:function(a,b){n.isFunction(a)?(b=a,a=["*"]):a=a.split(" ");for(var c,d=0,e=a.length;e>d;d++)c=a[d],Ra[c]=Ra[c]||[],Ra[c].unshift(b)},prefilter:function(a,b){b?Qa.unshift(a):Qa.push(a)}}),n.speed=function(a,b,c){var d=a&&"object"==typeof a?n.extend({},a):{complete:c||!c&&b||n.isFunction(a)&&a,duration:a,easing:c&&b||b&&!n.isFunction(b)&&b};return d.duration=n.fx.off?0:"number"==typeof d.duration?d.duration:d.duration in n.fx.speeds?n.fx.speeds[d.duration]:n.fx.speeds._default,(null==d.queue||d.queue===!0)&&(d.queue="fx"),d.old=d.complete,d.complete=function(){n.isFunction(d.old)&&d.old.call(this),d.queue&&n.dequeue(this,d.queue)},d},n.fn.extend({fadeTo:function(a,b,c,d){return this.filter(S).css("opacity",0).show().end().animate({opacity:b},a,c,d)},animate:function(a,b,c,d){var e=n.isEmptyObject(a),f=n.speed(b,c,d),g=function(){var b=Xa(this,n.extend({},a),f);(e||L.get(this,"finish"))&&b.stop(!0)};return g.finish=g,e||f.queue===!1?this.each(g):this.queue(f.queue,g)},stop:function(a,b,c){var d=function(a){var b=a.stop;delete a.stop,b(c)};return"string"!=typeof a&&(c=b,b=a,a=void 0),b&&a!==!1&&this.queue(a||"fx",[]),this.each(function(){var b=!0,e=null!=a&&a+"queueHooks",f=n.timers,g=L.get(this);if(e)g[e]&&g[e].stop&&d(g[e]);else for(e in g)g[e]&&g[e].stop&&Pa.test(e)&&d(g[e]);for(e=f.length;e--;)f[e].elem!==this||null!=a&&f[e].queue!==a||(f[e].anim.stop(c),b=!1,f.splice(e,1));(b||!c)&&n.dequeue(this,a)})},finish:function(a){return a!==!1&&(a=a||"fx"),this.each(function(){var b,c=L.get(this),d=c[a+"queue"],e=c[a+"queueHooks"],f=n.timers,g=d?d.length:0;for(c.finish=!0,n.queue(this,a,[]),e&&e.stop&&e.stop.call(this,!0),b=f.length;b--;)f[b].elem===this&&f[b].queue===a&&(f[b].anim.stop(!0),f.splice(b,1));for(b=0;g>b;b++)d[b]&&d[b].finish&&d[b].finish.call(this);delete c.finish})}}),n.each(["toggle","show","hide"],function(a,b){var c=n.fn[b];n.fn[b]=function(a,d,e){return null==a||"boolean"==typeof a?c.apply(this,arguments):this.animate(Ta(b,!0),a,d,e)}}),n.each({slideDown:Ta("show"),slideUp:Ta("hide"),slideToggle:Ta("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(a,b){n.fn[a]=function(a,c,d){return this.animate(b,a,c,d)}}),n.timers=[],n.fx.tick=function(){var a,b=0,c=n.timers;for(La=n.now();b<c.length;b++)a=c[b],a()||c[b]!==a||c.splice(b--,1);c.length||n.fx.stop(),La=void 0},n.fx.timer=function(a){n.timers.push(a),a()?n.fx.start():n.timers.pop()},n.fx.interval=13,n.fx.start=function(){Ma||(Ma=setInterval(n.fx.tick,n.fx.interval))},n.fx.stop=function(){clearInterval(Ma),Ma=null},n.fx.speeds={slow:600,fast:200,_default:400},n.fn.delay=function(a,b){return a=n.fx?n.fx.speeds[a]||a:a,b=b||"fx",this.queue(b,function(b,c){var d=setTimeout(b,a);c.stop=function(){clearTimeout(d)}})},function(){var a=l.createElement("input"),b=l.createElement("select"),c=b.appendChild(l.createElement("option"));a.type="checkbox",k.checkOn=""!==a.value,k.optSelected=c.selected,b.disabled=!0,k.optDisabled=!c.disabled,a=l.createElement("input"),a.value="t",a.type="radio",k.radioValue="t"===a.value}();var Ya,Za,$a=n.expr.attrHandle;n.fn.extend({attr:function(a,b){return J(this,n.attr,a,b,arguments.length>1)},removeAttr:function(a){return this.each(function(){n.removeAttr(this,a)})}}),n.extend({attr:function(a,b,c){var d,e,f=a.nodeType;if(a&&3!==f&&8!==f&&2!==f)return typeof a.getAttribute===U?n.prop(a,b,c):(1===f&&n.isXMLDoc(a)||(b=b.toLowerCase(),d=n.attrHooks[b]||(n.expr.match.bool.test(b)?Za:Ya)),
void 0===c?d&&"get"in d&&null!==(e=d.get(a,b))?e:(e=n.find.attr(a,b),null==e?void 0:e):null!==c?d&&"set"in d&&void 0!==(e=d.set(a,c,b))?e:(a.setAttribute(b,c+""),c):void n.removeAttr(a,b))},removeAttr:function(a,b){var c,d,e=0,f=b&&b.match(E);if(f&&1===a.nodeType)while(c=f[e++])d=n.propFix[c]||c,n.expr.match.bool.test(c)&&(a[d]=!1),a.removeAttribute(c)},attrHooks:{type:{set:function(a,b){if(!k.radioValue&&"radio"===b&&n.nodeName(a,"input")){var c=a.value;return a.setAttribute("type",b),c&&(a.value=c),b}}}}}),Za={set:function(a,b,c){return b===!1?n.removeAttr(a,c):a.setAttribute(c,c),c}},n.each(n.expr.match.bool.source.match(/\w+/g),function(a,b){var c=$a[b]||n.find.attr;$a[b]=function(a,b,d){var e,f;return d||(f=$a[b],$a[b]=e,e=null!=c(a,b,d)?b.toLowerCase():null,$a[b]=f),e}});var _a=/^(?:input|select|textarea|button)$/i;n.fn.extend({prop:function(a,b){return J(this,n.prop,a,b,arguments.length>1)},removeProp:function(a){return this.each(function(){delete this[n.propFix[a]||a]})}}),n.extend({propFix:{"for":"htmlFor","class":"className"},prop:function(a,b,c){var d,e,f,g=a.nodeType;if(a&&3!==g&&8!==g&&2!==g)return f=1!==g||!n.isXMLDoc(a),f&&(b=n.propFix[b]||b,e=n.propHooks[b]),void 0!==c?e&&"set"in e&&void 0!==(d=e.set(a,c,b))?d:a[b]=c:e&&"get"in e&&null!==(d=e.get(a,b))?d:a[b]},propHooks:{tabIndex:{get:function(a){return a.hasAttribute("tabindex")||_a.test(a.nodeName)||a.href?a.tabIndex:-1}}}}),k.optSelected||(n.propHooks.selected={get:function(a){var b=a.parentNode;return b&&b.parentNode&&b.parentNode.selectedIndex,null}}),n.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],function(){n.propFix[this.toLowerCase()]=this});var ab=/[\t\r\n\f]/g;n.fn.extend({addClass:function(a){var b,c,d,e,f,g,h="string"==typeof a&&a,i=0,j=this.length;if(n.isFunction(a))return this.each(function(b){n(this).addClass(a.call(this,b,this.className))});if(h)for(b=(a||"").match(E)||[];j>i;i++)if(c=this[i],d=1===c.nodeType&&(c.className?(" "+c.className+" ").replace(ab," "):" ")){f=0;while(e=b[f++])d.indexOf(" "+e+" ")<0&&(d+=e+" ");g=n.trim(d),c.className!==g&&(c.className=g)}return this},removeClass:function(a){var b,c,d,e,f,g,h=0===arguments.length||"string"==typeof a&&a,i=0,j=this.length;if(n.isFunction(a))return this.each(function(b){n(this).removeClass(a.call(this,b,this.className))});if(h)for(b=(a||"").match(E)||[];j>i;i++)if(c=this[i],d=1===c.nodeType&&(c.className?(" "+c.className+" ").replace(ab," "):"")){f=0;while(e=b[f++])while(d.indexOf(" "+e+" ")>=0)d=d.replace(" "+e+" "," ");g=a?n.trim(d):"",c.className!==g&&(c.className=g)}return this},toggleClass:function(a,b){var c=typeof a;return"boolean"==typeof b&&"string"===c?b?this.addClass(a):this.removeClass(a):this.each(n.isFunction(a)?function(c){n(this).toggleClass(a.call(this,c,this.className,b),b)}:function(){if("string"===c){var b,d=0,e=n(this),f=a.match(E)||[];while(b=f[d++])e.hasClass(b)?e.removeClass(b):e.addClass(b)}else(c===U||"boolean"===c)&&(this.className&&L.set(this,"__className__",this.className),this.className=this.className||a===!1?"":L.get(this,"__className__")||"")})},hasClass:function(a){for(var b=" "+a+" ",c=0,d=this.length;d>c;c++)if(1===this[c].nodeType&&(" "+this[c].className+" ").replace(ab," ").indexOf(b)>=0)return!0;return!1}});var bb=/\r/g;n.fn.extend({val:function(a){var b,c,d,e=this[0];{if(arguments.length)return d=n.isFunction(a),this.each(function(c){var e;1===this.nodeType&&(e=d?a.call(this,c,n(this).val()):a,null==e?e="":"number"==typeof e?e+="":n.isArray(e)&&(e=n.map(e,function(a){return null==a?"":a+""})),b=n.valHooks[this.type]||n.valHooks[this.nodeName.toLowerCase()],b&&"set"in b&&void 0!==b.set(this,e,"value")||(this.value=e))});if(e)return b=n.valHooks[e.type]||n.valHooks[e.nodeName.toLowerCase()],b&&"get"in b&&void 0!==(c=b.get(e,"value"))?c:(c=e.value,"string"==typeof c?c.replace(bb,""):null==c?"":c)}}}),n.extend({valHooks:{option:{get:function(a){var b=n.find.attr(a,"value");return null!=b?b:n.trim(n.text(a))}},select:{get:function(a){for(var b,c,d=a.options,e=a.selectedIndex,f="select-one"===a.type||0>e,g=f?null:[],h=f?e+1:d.length,i=0>e?h:f?e:0;h>i;i++)if(c=d[i],!(!c.selected&&i!==e||(k.optDisabled?c.disabled:null!==c.getAttribute("disabled"))||c.parentNode.disabled&&n.nodeName(c.parentNode,"optgroup"))){if(b=n(c).val(),f)return b;g.push(b)}return g},set:function(a,b){var c,d,e=a.options,f=n.makeArray(b),g=e.length;while(g--)d=e[g],(d.selected=n.inArray(d.value,f)>=0)&&(c=!0);return c||(a.selectedIndex=-1),f}}}}),n.each(["radio","checkbox"],function(){n.valHooks[this]={set:function(a,b){return n.isArray(b)?a.checked=n.inArray(n(a).val(),b)>=0:void 0}},k.checkOn||(n.valHooks[this].get=function(a){return null===a.getAttribute("value")?"on":a.value})}),n.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "),function(a,b){n.fn[b]=function(a,c){return arguments.length>0?this.on(b,null,a,c):this.trigger(b)}}),n.fn.extend({hover:function(a,b){return this.mouseenter(a).mouseleave(b||a)},bind:function(a,b,c){return this.on(a,null,b,c)},unbind:function(a,b){return this.off(a,null,b)},delegate:function(a,b,c,d){return this.on(b,a,c,d)},undelegate:function(a,b,c){return 1===arguments.length?this.off(a,"**"):this.off(b,a||"**",c)}});var cb=n.now(),db=/\?/;n.parseJSON=function(a){return JSON.parse(a+"")},n.parseXML=function(a){var b,c;if(!a||"string"!=typeof a)return null;try{c=new DOMParser,b=c.parseFromString(a,"text/xml")}catch(d){b=void 0}return(!b||b.getElementsByTagName("parsererror").length)&&n.error("Invalid XML: "+a),b};var eb=/#.*$/,fb=/([?&])_=[^&]*/,gb=/^(.*?):[ \t]*([^\r\n]*)$/gm,hb=/^(?:about|app|app-storage|.+-extension|file|res|widget):$/,ib=/^(?:GET|HEAD)$/,jb=/^\/\//,kb=/^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,lb={},mb={},nb="*/".concat("*"),ob=a.location.href,pb=kb.exec(ob.toLowerCase())||[];function qb(a){return function(b,c){"string"!=typeof b&&(c=b,b="*");var d,e=0,f=b.toLowerCase().match(E)||[];if(n.isFunction(c))while(d=f[e++])"+"===d[0]?(d=d.slice(1)||"*",(a[d]=a[d]||[]).unshift(c)):(a[d]=a[d]||[]).push(c)}}function rb(a,b,c,d){var e={},f=a===mb;function g(h){var i;return e[h]=!0,n.each(a[h]||[],function(a,h){var j=h(b,c,d);return"string"!=typeof j||f||e[j]?f?!(i=j):void 0:(b.dataTypes.unshift(j),g(j),!1)}),i}return g(b.dataTypes[0])||!e["*"]&&g("*")}function sb(a,b){var c,d,e=n.ajaxSettings.flatOptions||{};for(c in b)void 0!==b[c]&&((e[c]?a:d||(d={}))[c]=b[c]);return d&&n.extend(!0,a,d),a}function tb(a,b,c){var d,e,f,g,h=a.contents,i=a.dataTypes;while("*"===i[0])i.shift(),void 0===d&&(d=a.mimeType||b.getResponseHeader("Content-Type"));if(d)for(e in h)if(h[e]&&h[e].test(d)){i.unshift(e);break}if(i[0]in c)f=i[0];else{for(e in c){if(!i[0]||a.converters[e+" "+i[0]]){f=e;break}g||(g=e)}f=f||g}return f?(f!==i[0]&&i.unshift(f),c[f]):void 0}function ub(a,b,c,d){var e,f,g,h,i,j={},k=a.dataTypes.slice();if(k[1])for(g in a.converters)j[g.toLowerCase()]=a.converters[g];f=k.shift();while(f)if(a.responseFields[f]&&(c[a.responseFields[f]]=b),!i&&d&&a.dataFilter&&(b=a.dataFilter(b,a.dataType)),i=f,f=k.shift())if("*"===f)f=i;else if("*"!==i&&i!==f){if(g=j[i+" "+f]||j["* "+f],!g)for(e in j)if(h=e.split(" "),h[1]===f&&(g=j[i+" "+h[0]]||j["* "+h[0]])){g===!0?g=j[e]:j[e]!==!0&&(f=h[0],k.unshift(h[1]));break}if(g!==!0)if(g&&a["throws"])b=g(b);else try{b=g(b)}catch(l){return{state:"parsererror",error:g?l:"No conversion from "+i+" to "+f}}}return{state:"success",data:b}}n.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:ob,type:"GET",isLocal:hb.test(pb[1]),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":nb,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/xml/,html:/html/,json:/json/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":n.parseJSON,"text xml":n.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(a,b){return b?sb(sb(a,n.ajaxSettings),b):sb(n.ajaxSettings,a)},ajaxPrefilter:qb(lb),ajaxTransport:qb(mb),ajax:function(a,b){"object"==typeof a&&(b=a,a=void 0),b=b||{};var c,d,e,f,g,h,i,j,k=n.ajaxSetup({},b),l=k.context||k,m=k.context&&(l.nodeType||l.jquery)?n(l):n.event,o=n.Deferred(),p=n.Callbacks("once memory"),q=k.statusCode||{},r={},s={},t=0,u="canceled",v={readyState:0,getResponseHeader:function(a){var b;if(2===t){if(!f){f={};while(b=gb.exec(e))f[b[1].toLowerCase()]=b[2]}b=f[a.toLowerCase()]}return null==b?null:b},getAllResponseHeaders:function(){return 2===t?e:null},setRequestHeader:function(a,b){var c=a.toLowerCase();return t||(a=s[c]=s[c]||a,r[a]=b),this},overrideMimeType:function(a){return t||(k.mimeType=a),this},statusCode:function(a){var b;if(a)if(2>t)for(b in a)q[b]=[q[b],a[b]];else v.always(a[v.status]);return this},abort:function(a){var b=a||u;return c&&c.abort(b),x(0,b),this}};if(o.promise(v).complete=p.add,v.success=v.done,v.error=v.fail,k.url=((a||k.url||ob)+"").replace(eb,"").replace(jb,pb[1]+"//"),k.type=b.method||b.type||k.method||k.type,k.dataTypes=n.trim(k.dataType||"*").toLowerCase().match(E)||[""],null==k.crossDomain&&(h=kb.exec(k.url.toLowerCase()),k.crossDomain=!(!h||h[1]===pb[1]&&h[2]===pb[2]&&(h[3]||("http:"===h[1]?"80":"443"))===(pb[3]||("http:"===pb[1]?"80":"443")))),k.data&&k.processData&&"string"!=typeof k.data&&(k.data=n.param(k.data,k.traditional)),rb(lb,k,b,v),2===t)return v;i=n.event&&k.global,i&&0===n.active++&&n.event.trigger("ajaxStart"),k.type=k.type.toUpperCase(),k.hasContent=!ib.test(k.type),d=k.url,k.hasContent||(k.data&&(d=k.url+=(db.test(d)?"&":"?")+k.data,delete k.data),k.cache===!1&&(k.url=fb.test(d)?d.replace(fb,"$1_="+cb++):d+(db.test(d)?"&":"?")+"_="+cb++)),k.ifModified&&(n.lastModified[d]&&v.setRequestHeader("If-Modified-Since",n.lastModified[d]),n.etag[d]&&v.setRequestHeader("If-None-Match",n.etag[d])),(k.data&&k.hasContent&&k.contentType!==!1||b.contentType)&&v.setRequestHeader("Content-Type",k.contentType),v.setRequestHeader("Accept",k.dataTypes[0]&&k.accepts[k.dataTypes[0]]?k.accepts[k.dataTypes[0]]+("*"!==k.dataTypes[0]?", "+nb+"; q=0.01":""):k.accepts["*"]);for(j in k.headers)v.setRequestHeader(j,k.headers[j]);if(k.beforeSend&&(k.beforeSend.call(l,v,k)===!1||2===t))return v.abort();u="abort";for(j in{success:1,error:1,complete:1})v[j](k[j]);if(c=rb(mb,k,b,v)){v.readyState=1,i&&m.trigger("ajaxSend",[v,k]),k.async&&k.timeout>0&&(g=setTimeout(function(){v.abort("timeout")},k.timeout));try{t=1,c.send(r,x)}catch(w){if(!(2>t))throw w;x(-1,w)}}else x(-1,"No Transport");function x(a,b,f,h){var j,r,s,u,w,x=b;2!==t&&(t=2,g&&clearTimeout(g),c=void 0,e=h||"",v.readyState=a>0?4:0,j=a>=200&&300>a||304===a,f&&(u=tb(k,v,f)),u=ub(k,u,v,j),j?(k.ifModified&&(w=v.getResponseHeader("Last-Modified"),w&&(n.lastModified[d]=w),w=v.getResponseHeader("etag"),w&&(n.etag[d]=w)),204===a||"HEAD"===k.type?x="nocontent":304===a?x="notmodified":(x=u.state,r=u.data,s=u.error,j=!s)):(s=x,(a||!x)&&(x="error",0>a&&(a=0))),v.status=a,v.statusText=(b||x)+"",j?o.resolveWith(l,[r,x,v]):o.rejectWith(l,[v,x,s]),v.statusCode(q),q=void 0,i&&m.trigger(j?"ajaxSuccess":"ajaxError",[v,k,j?r:s]),p.fireWith(l,[v,x]),i&&(m.trigger("ajaxComplete",[v,k]),--n.active||n.event.trigger("ajaxStop")))}return v},getJSON:function(a,b,c){return n.get(a,b,c,"json")},getScript:function(a,b){return n.get(a,void 0,b,"script")}}),n.each(["get","post"],function(a,b){n[b]=function(a,c,d,e){return n.isFunction(c)&&(e=e||d,d=c,c=void 0),n.ajax({url:a,type:b,dataType:e,data:c,success:d})}}),n._evalUrl=function(a){return n.ajax({url:a,type:"GET",dataType:"script",async:!1,global:!1,"throws":!0})},n.fn.extend({wrapAll:function(a){var b;return n.isFunction(a)?this.each(function(b){n(this).wrapAll(a.call(this,b))}):(this[0]&&(b=n(a,this[0].ownerDocument).eq(0).clone(!0),this[0].parentNode&&b.insertBefore(this[0]),b.map(function(){var a=this;while(a.firstElementChild)a=a.firstElementChild;return a}).append(this)),this)},wrapInner:function(a){return this.each(n.isFunction(a)?function(b){n(this).wrapInner(a.call(this,b))}:function(){var b=n(this),c=b.contents();c.length?c.wrapAll(a):b.append(a)})},wrap:function(a){var b=n.isFunction(a);return this.each(function(c){n(this).wrapAll(b?a.call(this,c):a)})},unwrap:function(){return this.parent().each(function(){n.nodeName(this,"body")||n(this).replaceWith(this.childNodes)}).end()}}),n.expr.filters.hidden=function(a){return a.offsetWidth<=0&&a.offsetHeight<=0},n.expr.filters.visible=function(a){return!n.expr.filters.hidden(a)};var vb=/%20/g,wb=/\[\]$/,xb=/\r?\n/g,yb=/^(?:submit|button|image|reset|file)$/i,zb=/^(?:input|select|textarea|keygen)/i;function Ab(a,b,c,d){var e;if(n.isArray(b))n.each(b,function(b,e){c||wb.test(a)?d(a,e):Ab(a+"["+("object"==typeof e?b:"")+"]",e,c,d)});else if(c||"object"!==n.type(b))d(a,b);else for(e in b)Ab(a+"["+e+"]",b[e],c,d)}n.param=function(a,b){var c,d=[],e=function(a,b){b=n.isFunction(b)?b():null==b?"":b,d[d.length]=encodeURIComponent(a)+"="+encodeURIComponent(b)};if(void 0===b&&(b=n.ajaxSettings&&n.ajaxSettings.traditional),n.isArray(a)||a.jquery&&!n.isPlainObject(a))n.each(a,function(){e(this.name,this.value)});else for(c in a)Ab(c,a[c],b,e);return d.join("&").replace(vb,"+")},n.fn.extend({serialize:function(){return n.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var a=n.prop(this,"elements");return a?n.makeArray(a):this}).filter(function(){var a=this.type;return this.name&&!n(this).is(":disabled")&&zb.test(this.nodeName)&&!yb.test(a)&&(this.checked||!T.test(a))}).map(function(a,b){var c=n(this).val();return null==c?null:n.isArray(c)?n.map(c,function(a){return{name:b.name,value:a.replace(xb,"\r\n")}}):{name:b.name,value:c.replace(xb,"\r\n")}}).get()}}),n.ajaxSettings.xhr=function(){try{return new XMLHttpRequest}catch(a){}};var Bb=0,Cb={},Db={0:200,1223:204},Eb=n.ajaxSettings.xhr();a.attachEvent&&a.attachEvent("onunload",function(){for(var a in Cb)Cb[a]()}),k.cors=!!Eb&&"withCredentials"in Eb,k.ajax=Eb=!!Eb,n.ajaxTransport(function(a){var b;return k.cors||Eb&&!a.crossDomain?{send:function(c,d){var e,f=a.xhr(),g=++Bb;if(f.open(a.type,a.url,a.async,a.username,a.password),a.xhrFields)for(e in a.xhrFields)f[e]=a.xhrFields[e];a.mimeType&&f.overrideMimeType&&f.overrideMimeType(a.mimeType),a.crossDomain||c["X-Requested-With"]||(c["X-Requested-With"]="XMLHttpRequest");for(e in c)f.setRequestHeader(e,c[e]);b=function(a){return function(){b&&(delete Cb[g],b=f.onload=f.onerror=null,"abort"===a?f.abort():"error"===a?d(f.status,f.statusText):d(Db[f.status]||f.status,f.statusText,"string"==typeof f.responseText?{text:f.responseText}:void 0,f.getAllResponseHeaders()))}},f.onload=b(),f.onerror=b("error"),b=Cb[g]=b("abort");try{f.send(a.hasContent&&a.data||null)}catch(h){if(b)throw h}},abort:function(){b&&b()}}:void 0}),n.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/(?:java|ecma)script/},converters:{"text script":function(a){return n.globalEval(a),a}}}),n.ajaxPrefilter("script",function(a){void 0===a.cache&&(a.cache=!1),a.crossDomain&&(a.type="GET")}),n.ajaxTransport("script",function(a){if(a.crossDomain){var b,c;return{send:function(d,e){b=n("<script>").prop({async:!0,charset:a.scriptCharset,src:a.url}).on("load error",c=function(a){b.remove(),c=null,a&&e("error"===a.type?404:200,a.type)}),l.head.appendChild(b[0])},abort:function(){c&&c()}}}});var Fb=[],Gb=/(=)\?(?=&|$)|\?\?/;n.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var a=Fb.pop()||n.expando+"_"+cb++;return this[a]=!0,a}}),n.ajaxPrefilter("json jsonp",function(b,c,d){var e,f,g,h=b.jsonp!==!1&&(Gb.test(b.url)?"url":"string"==typeof b.data&&!(b.contentType||"").indexOf("application/x-www-form-urlencoded")&&Gb.test(b.data)&&"data");return h||"jsonp"===b.dataTypes[0]?(e=b.jsonpCallback=n.isFunction(b.jsonpCallback)?b.jsonpCallback():b.jsonpCallback,h?b[h]=b[h].replace(Gb,"$1"+e):b.jsonp!==!1&&(b.url+=(db.test(b.url)?"&":"?")+b.jsonp+"="+e),b.converters["script json"]=function(){return g||n.error(e+" was not called"),g[0]},b.dataTypes[0]="json",f=a[e],a[e]=function(){g=arguments},d.always(function(){a[e]=f,b[e]&&(b.jsonpCallback=c.jsonpCallback,Fb.push(e)),g&&n.isFunction(f)&&f(g[0]),g=f=void 0}),"script"):void 0}),n.parseHTML=function(a,b,c){if(!a||"string"!=typeof a)return null;"boolean"==typeof b&&(c=b,b=!1),b=b||l;var d=v.exec(a),e=!c&&[];return d?[b.createElement(d[1])]:(d=n.buildFragment([a],b,e),e&&e.length&&n(e).remove(),n.merge([],d.childNodes))};var Hb=n.fn.load;n.fn.load=function(a,b,c){if("string"!=typeof a&&Hb)return Hb.apply(this,arguments);var d,e,f,g=this,h=a.indexOf(" ");return h>=0&&(d=n.trim(a.slice(h)),a=a.slice(0,h)),n.isFunction(b)?(c=b,b=void 0):b&&"object"==typeof b&&(e="POST"),g.length>0&&n.ajax({url:a,type:e,dataType:"html",data:b}).done(function(a){f=arguments,g.html(d?n("<div>").append(n.parseHTML(a)).find(d):a)}).complete(c&&function(a,b){g.each(c,f||[a.responseText,b,a])}),this},n.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(a,b){n.fn[b]=function(a){return this.on(b,a)}}),n.expr.filters.animated=function(a){return n.grep(n.timers,function(b){return a===b.elem}).length};var Ib=a.document.documentElement;function Jb(a){return n.isWindow(a)?a:9===a.nodeType&&a.defaultView}n.offset={setOffset:function(a,b,c){var d,e,f,g,h,i,j,k=n.css(a,"position"),l=n(a),m={};"static"===k&&(a.style.position="relative"),h=l.offset(),f=n.css(a,"top"),i=n.css(a,"left"),j=("absolute"===k||"fixed"===k)&&(f+i).indexOf("auto")>-1,j?(d=l.position(),g=d.top,e=d.left):(g=parseFloat(f)||0,e=parseFloat(i)||0),n.isFunction(b)&&(b=b.call(a,c,h)),null!=b.top&&(m.top=b.top-h.top+g),null!=b.left&&(m.left=b.left-h.left+e),"using"in b?b.using.call(a,m):l.css(m)}},n.fn.extend({offset:function(a){if(arguments.length)return void 0===a?this:this.each(function(b){n.offset.setOffset(this,a,b)});var b,c,d=this[0],e={top:0,left:0},f=d&&d.ownerDocument;if(f)return b=f.documentElement,n.contains(b,d)?(typeof d.getBoundingClientRect!==U&&(e=d.getBoundingClientRect()),c=Jb(f),{top:e.top+c.pageYOffset-b.clientTop,left:e.left+c.pageXOffset-b.clientLeft}):e},position:function(){if(this[0]){var a,b,c=this[0],d={top:0,left:0};return"fixed"===n.css(c,"position")?b=c.getBoundingClientRect():(a=this.offsetParent(),b=this.offset(),n.nodeName(a[0],"html")||(d=a.offset()),d.top+=n.css(a[0],"borderTopWidth",!0),d.left+=n.css(a[0],"borderLeftWidth",!0)),{top:b.top-d.top-n.css(c,"marginTop",!0),left:b.left-d.left-n.css(c,"marginLeft",!0)}}},offsetParent:function(){return this.map(function(){var a=this.offsetParent||Ib;while(a&&!n.nodeName(a,"html")&&"static"===n.css(a,"position"))a=a.offsetParent;return a||Ib})}}),n.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(b,c){var d="pageYOffset"===c;n.fn[b]=function(e){return J(this,function(b,e,f){var g=Jb(b);return void 0===f?g?g[c]:b[e]:void(g?g.scrollTo(d?a.pageXOffset:f,d?f:a.pageYOffset):b[e]=f)},b,e,arguments.length,null)}}),n.each(["top","left"],function(a,b){n.cssHooks[b]=ya(k.pixelPosition,function(a,c){return c?(c=xa(a,b),va.test(c)?n(a).position()[b]+"px":c):void 0})}),n.each({Height:"height",Width:"width"},function(a,b){n.each({padding:"inner"+a,content:b,"":"outer"+a},function(c,d){n.fn[d]=function(d,e){var f=arguments.length&&(c||"boolean"!=typeof d),g=c||(d===!0||e===!0?"margin":"border");return J(this,function(b,c,d){var e;return n.isWindow(b)?b.document.documentElement["client"+a]:9===b.nodeType?(e=b.documentElement,Math.max(b.body["scroll"+a],e["scroll"+a],b.body["offset"+a],e["offset"+a],e["client"+a])):void 0===d?n.css(b,c,g):n.style(b,c,d,g)},b,f?d:void 0,f,null)}})}),n.fn.size=function(){return this.length},n.fn.andSelf=n.fn.addBack,"function"==typeof define&&define.amd&&define("jquery",[],function(){return n});var Kb=a.jQuery,Lb=a.$;return n.noConflict=function(b){return a.$===n&&(a.$=Lb),b&&a.jQuery===n&&(a.jQuery=Kb),n},typeof b===U&&(a.jQuery=a.$=n),n});

/* Modernizr 2.8.3 (Custom Build) | MIT & BSD
 * Build: http://modernizr.com/download/#-fontface-csstransforms-csstransforms3d-touch-cssclasses-teststyles-testprop-testallprops-prefixes-domprefixes-cssclassprefix:supports!
 */
;window.Modernizr=function(a,b,c){function z(a){j.cssText=a}function A(a,b){return z(m.join(a+";")+(b||""))}function B(a,b){return typeof a===b}function C(a,b){return!!~(""+a).indexOf(b)}function D(a,b){for(var d in a){var e=a[d];if(!C(e,"-")&&j[e]!==c)return b=="pfx"?e:!0}return!1}function E(a,b,d){for(var e in a){var f=b[a[e]];if(f!==c)return d===!1?a[e]:B(f,"function")?f.bind(d||b):f}return!1}function F(a,b,c){var d=a.charAt(0).toUpperCase()+a.slice(1),e=(a+" "+o.join(d+" ")+d).split(" ");return B(b,"string")||B(b,"undefined")?D(e,b):(e=(a+" "+p.join(d+" ")+d).split(" "),E(e,b,c))}var d="2.8.3",e={},f=!0,g=b.documentElement,h="modernizr",i=b.createElement(h),j=i.style,k,l={}.toString,m=" -webkit- -moz- -o- -ms- ".split(" "),n="Webkit Moz O ms",o=n.split(" "),p=n.toLowerCase().split(" "),q={},r={},s={},t=[],u=t.slice,v,w=function(a,c,d,e){var f,i,j,k,l=b.createElement("div"),m=b.body,n=m||b.createElement("body");if(parseInt(d,10))while(d--)j=b.createElement("div"),j.id=e?e[d]:h+(d+1),l.appendChild(j);return f=["&#173;",'<style id="s',h,'">',a,"</style>"].join(""),l.id=h,(m?l:n).innerHTML+=f,n.appendChild(l),m||(n.style.background="",n.style.overflow="hidden",k=g.style.overflow,g.style.overflow="hidden",g.appendChild(n)),i=c(l,a),m?l.parentNode.removeChild(l):(n.parentNode.removeChild(n),g.style.overflow=k),!!i},x={}.hasOwnProperty,y;!B(x,"undefined")&&!B(x.call,"undefined")?y=function(a,b){return x.call(a,b)}:y=function(a,b){return b in a&&B(a.constructor.prototype[b],"undefined")},Function.prototype.bind||(Function.prototype.bind=function(b){var c=this;if(typeof c!="function")throw new TypeError;var d=u.call(arguments,1),e=function(){if(this instanceof e){var a=function(){};a.prototype=c.prototype;var f=new a,g=c.apply(f,d.concat(u.call(arguments)));return Object(g)===g?g:f}return c.apply(b,d.concat(u.call(arguments)))};return e}),q.touch=function(){var c;return"ontouchstart"in a||a.DocumentTouch&&b instanceof DocumentTouch?c=!0:w(["@media (",m.join("touch-enabled),("),h,")","{#modernizr{top:9px;position:absolute}}"].join(""),function(a){c=a.offsetTop===9}),c},q.csstransforms=function(){return!!F("transform")},q.csstransforms3d=function(){var a=!!F("perspective");return a&&"webkitPerspective"in g.style&&w("@media (transform-3d),(-webkit-transform-3d){#modernizr{left:9px;position:absolute;height:3px;}}",function(b,c){a=b.offsetLeft===9&&b.offsetHeight===3}),a},q.fontface=function(){var a;return w('@font-face {font-family:"font";src:url("https://")}',function(c,d){var e=b.getElementById("smodernizr"),f=e.sheet||e.styleSheet,g=f?f.cssRules&&f.cssRules[0]?f.cssRules[0].cssText:f.cssText||"":"";a=/src/i.test(g)&&g.indexOf(d.split(" ")[0])===0}),a};for(var G in q)y(q,G)&&(v=G.toLowerCase(),e[v]=q[G](),t.push((e[v]?"":"no-")+v));return e.addTest=function(a,b){if(typeof a=="object")for(var d in a)y(a,d)&&e.addTest(d,a[d]);else{a=a.toLowerCase();if(e[a]!==c)return e;b=typeof b=="function"?b():b,typeof f!="undefined"&&f&&(g.className+=" supports-"+(b?"":"no-")+a),e[a]=b}return e},z(""),i=k=null,e._version=d,e._prefixes=m,e._domPrefixes=p,e._cssomPrefixes=o,e.testProp=function(a){return D([a])},e.testAllProps=F,e.testStyles=w,g.className=g.className.replace(/(^|\s)no-js(\s|$)/,"$1$2")+(f?" supports-js supports-"+t.join(" supports-"):""),e}(this,this.document);

/*!
  * headroom.js v0.9.3 - Give your page some headroom. Hide your header until you need it
  * Copyright (c) 2016 Nick Williams - http://wicky.nillia.ms/headroom.js
  * License: MIT
  */
!function(a,b){"use strict";"function"==typeof define&&define.amd?define([],b):"object"==typeof exports?module.exports=b():a.Headroom=b()}(this,function(){"use strict";function b(a){this.callback=a,this.ticking=!1}function c(a){return a&&"undefined"!=typeof window&&(a===window||a.nodeType)}function d(a){if(arguments.length<=0)throw new Error("Missing arguments in extend function");var e,f,b=a||{};for(f=1;f<arguments.length;f++){var g=arguments[f]||{};for(e in g)"object"!=typeof b[e]||c(b[e])?b[e]=b[e]||g[e]:b[e]=d(b[e],g[e])}return b}function e(a){return a===Object(a)?a:{down:a,up:a}}function f(a,b){b=d(b,f.options),this.lastKnownScrollY=0,this.elem=a,this.tolerance=e(b.tolerance),this.classes=b.classes,this.offset=b.offset,this.scroller=b.scroller,this.initialised=!1,this.onPin=b.onPin,this.onUnpin=b.onUnpin,this.onTop=b.onTop,this.onNotTop=b.onNotTop,this.onBottom=b.onBottom,this.onNotBottom=b.onNotBottom}var a={bind:!!function(){}.bind,classList:"classList"in document.documentElement,rAF:!!(window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame)};return window.requestAnimationFrame=window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame,b.prototype={constructor:b,update:function(){this.callback&&this.callback(),this.ticking=!1},requestTick:function(){this.ticking||(requestAnimationFrame(this.rafCallback||(this.rafCallback=this.update.bind(this))),this.ticking=!0)},handleEvent:function(){this.requestTick()}},f.prototype={constructor:f,init:function(){if(f.cutsTheMustard)return this.debouncer=new b(this.update.bind(this)),this.elem.classList.add(this.classes.initial),setTimeout(this.attachEvent.bind(this),100),this},destroy:function(){var a=this.classes;this.initialised=!1,this.elem.classList.remove(a.unpinned,a.pinned,a.top,a.notTop,a.initial),this.scroller.removeEventListener("scroll",this.debouncer,!1)},attachEvent:function(){this.initialised||(this.lastKnownScrollY=this.getScrollY(),this.initialised=!0,this.scroller.addEventListener("scroll",this.debouncer,!1),this.debouncer.handleEvent())},unpin:function(){var a=this.elem.classList,b=this.classes;!a.contains(b.pinned)&&a.contains(b.unpinned)||(a.add(b.unpinned),a.remove(b.pinned),this.onUnpin&&this.onUnpin.call(this))},pin:function(){var a=this.elem.classList,b=this.classes;a.contains(b.unpinned)&&(a.remove(b.unpinned),a.add(b.pinned),this.onPin&&this.onPin.call(this))},top:function(){var a=this.elem.classList,b=this.classes;a.contains(b.top)||(a.add(b.top),a.remove(b.notTop),this.onTop&&this.onTop.call(this))},notTop:function(){var a=this.elem.classList,b=this.classes;a.contains(b.notTop)||(a.add(b.notTop),a.remove(b.top),this.onNotTop&&this.onNotTop.call(this))},bottom:function(){var a=this.elem.classList,b=this.classes;a.contains(b.bottom)||(a.add(b.bottom),a.remove(b.notBottom),this.onBottom&&this.onBottom.call(this))},notBottom:function(){var a=this.elem.classList,b=this.classes;a.contains(b.notBottom)||(a.add(b.notBottom),a.remove(b.bottom),this.onNotBottom&&this.onNotBottom.call(this))},getScrollY:function(){return void 0!==this.scroller.pageYOffset?this.scroller.pageYOffset:void 0!==this.scroller.scrollTop?this.scroller.scrollTop:(document.documentElement||document.body.parentNode||document.body).scrollTop},getViewportHeight:function(){return window.innerHeight||document.documentElement.clientHeight||document.body.clientHeight},getElementPhysicalHeight:function(a){return Math.max(a.offsetHeight,a.clientHeight)},getScrollerPhysicalHeight:function(){return this.scroller===window||this.scroller===document.body?this.getViewportHeight():this.getElementPhysicalHeight(this.scroller)},getDocumentHeight:function(){var a=document.body,b=document.documentElement;return Math.max(a.scrollHeight,b.scrollHeight,a.offsetHeight,b.offsetHeight,a.clientHeight,b.clientHeight)},getElementHeight:function(a){return Math.max(a.scrollHeight,a.offsetHeight,a.clientHeight)},getScrollerHeight:function(){return this.scroller===window||this.scroller===document.body?this.getDocumentHeight():this.getElementHeight(this.scroller)},isOutOfBounds:function(a){var b=a<0,c=a+this.getScrollerPhysicalHeight()>this.getScrollerHeight();return b||c},toleranceExceeded:function(a,b){return Math.abs(a-this.lastKnownScrollY)>=this.tolerance[b]},shouldUnpin:function(a,b){var c=a>this.lastKnownScrollY,d=a>=this.offset;return c&&d&&b},shouldPin:function(a,b){var c=a<this.lastKnownScrollY,d=a<=this.offset;return c&&b||d},update:function(){var a=this.getScrollY(),b=a>this.lastKnownScrollY?"down":"up",c=this.toleranceExceeded(a,b);this.isOutOfBounds(a)||(a<=this.offset?this.top():this.notTop(),a+this.getViewportHeight()>=this.getScrollerHeight()?this.bottom():this.notBottom(),this.shouldUnpin(a,c)?this.unpin():this.shouldPin(a,c)&&this.pin(),this.lastKnownScrollY=a)}},f.options={tolerance:{up:0,down:50},offset:400,scroller:window,classes:{pinned:"headroom--pinned",unpinned:"headroom--unpinned",top:"headroom--top",notTop:"headroom--not-top",bottom:"headroom--bottom",notBottom:"headroom--not-bottom",initial:"headroom"}},f.cutsTheMustard="undefined"!=typeof a&&a.rAF&&a.bind&&a.classList,f});

/*!
  * jQuery Headroom
  */
!function(a){a&&(a.fn.headroom=function(b){return this.each(function(){var c=a(this),d=c.data("headroom"),e="object"==typeof b&&b;e=a.extend(!0,{},Headroom.options,e),d||(d=new Headroom(this,e),d.init(),c.data("headroom",d)),"string"==typeof b&&(d[b](),"destroy"===b&&c.removeData("headroom"))})},a("[data-headroom]").each(function(){var b=a(this);b.headroom(b.data())}))}(window.Zepto||window.jQuery);

/*!
  * JavaScript Cookie v2.1.3
  * https://github.com/js-cookie/js-cookie
  * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
  * Released under the MIT license
  */
try {
!function(a){var b=!1;if("function"==typeof define&&define.amd&&(define(a),b=!0),"object"==typeof exports&&(module.exports=a(),b=!0),!b){var c=window.Cookies,d=window.Cookies=a();d.noConflict=function(){return window.Cookies=c,d}}}(function(){function a(){for(var a=0,b={};a<arguments.length;a++){var c=arguments[a];for(var d in c)b[d]=c[d]}return b}function b(c){function d(b,e,f){var g;if("undefined"!=typeof document){if(arguments.length>1){if(f=a({path:"/"},d.defaults,f),"number"==typeof f.expires){var h=new Date;h.setMilliseconds(h.getMilliseconds()+864e5*f.expires),f.expires=h}f.expires=f.expires?f.expires.toUTCString():"";try{g=JSON.stringify(e),/^[\{\[]/.test(g)&&(e=g)}catch(a){}e=c.write?c.write(e,b):encodeURIComponent(String(e)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,decodeURIComponent),b=encodeURIComponent(String(b)),b=b.replace(/%(23|24|26|2B|5E|60|7C)/g,decodeURIComponent),b=b.replace(/[\(\)]/g,escape);var i="";for(var j in f)f[j]&&(i+="; "+j,f[j]!==!0&&(i+="="+f[j]));return document.cookie=b+"="+e+i}b||(g={});for(var k=document.cookie?document.cookie.split("; "):[],l=/(%[0-9A-Z]{2})+/g,m=0;m<k.length;m++){var n=k[m].split("="),o=n.slice(1).join("=");'"'===o.charAt(0)&&(o=o.slice(1,-1));try{var p=n[0].replace(l,decodeURIComponent);if(o=c.read?c.read(o,p):c(o,p)||o.replace(l,decodeURIComponent),this.json)try{o=JSON.parse(o)}catch(a){}if(b===p){g=o;break}b||(g[p]=o)}catch(a){}}return g}}return d.set=d,d.get=function(a){return d.call(d,a)},d.getJSON=function(){return d.apply({json:!0},[].slice.call(arguments))},d.defaults={},d.remove=function(b,c){d(b,"",a(c,{expires:-1}))},d.withConverter=b,d}return b(function(){})});
} catch (e) { }
;try{
!function(){"use strict";function e(n){return"undefined"==typeof this||Object.getPrototypeOf(this)!==e.prototype?new e(n):(O=this,O.version="3.3.2",O.tools=new E,O.isSupported()?(O.tools.extend(O.defaults,n||{}),O.defaults.container=t(O.defaults),O.store={elements:{},containers:[]},O.sequences={},O.history=[],O.uid=0,O.initialized=!1):"undefined"!=typeof console&&null!==console,O)}function t(e){if(e&&e.container){if("string"==typeof e.container)return window.document.documentElement.querySelector(e.container);if(O.tools.isNode(e.container))return e.container}return O.defaults.container}function n(e,t){return"string"==typeof e?Array.prototype.slice.call(t.querySelectorAll(e)):O.tools.isNode(e)?[e]:O.tools.isNodeList(e)?Array.prototype.slice.call(e):[]}function i(){return++O.uid}function o(e,t,n){t.container&&(t.container=n),e.config?e.config=O.tools.extendClone(e.config,t):e.config=O.tools.extendClone(O.defaults,t),"top"===e.config.origin||"bottom"===e.config.origin?e.config.axis="Y":e.config.axis="X"}function r(e){var t=window.getComputedStyle(e.domEl);e.styles||(e.styles={transition:{},transform:{},computed:{}},e.styles.inline=e.domEl.getAttribute("style")||"",e.styles.inline+="; visibility: visible; ",e.styles.computed.opacity=t.opacity,t.transition&&"all 0s ease 0s"!==t.transition?e.styles.computed.transition=t.transition+", ":e.styles.computed.transition=""),e.styles.transition.instant=s(e,0),e.styles.transition.delayed=s(e,e.config.delay),e.styles.transform.initial=" -webkit-transform:",e.styles.transform.target=" -webkit-transform:",a(e),e.styles.transform.initial+="transform:",e.styles.transform.target+="transform:",a(e)}function s(e,t){var n=e.config;return"-webkit-transition: "+e.styles.computed.transition+"-webkit-transform "+n.duration/1e3+"s "+n.easing+" "+t/1e3+"s, opacity "+n.duration/1e3+"s "+n.easing+" "+t/1e3+"s; transition: "+e.styles.computed.transition+"transform "+n.duration/1e3+"s "+n.easing+" "+t/1e3+"s, opacity "+n.duration/1e3+"s "+n.easing+" "+t/1e3+"s; "}function a(e){var t,n=e.config,i=e.styles.transform;t="top"===n.origin||"left"===n.origin?/^-/.test(n.distance)?n.distance.substr(1):"-"+n.distance:n.distance,parseInt(n.distance)&&(i.initial+=" translate"+n.axis+"("+t+")",i.target+=" translate"+n.axis+"(0)"),n.scale&&(i.initial+=" scale("+n.scale+")",i.target+=" scale(1)"),n.rotate.x&&(i.initial+=" rotateX("+n.rotate.x+"deg)",i.target+=" rotateX(0)"),n.rotate.y&&(i.initial+=" rotateY("+n.rotate.y+"deg)",i.target+=" rotateY(0)"),n.rotate.z&&(i.initial+=" rotateZ("+n.rotate.z+"deg)",i.target+=" rotateZ(0)"),i.initial+="; opacity: "+n.opacity+";",i.target+="; opacity: "+e.styles.computed.opacity+";"}function l(e){var t=e.config.container;t&&O.store.containers.indexOf(t)===-1&&O.store.containers.push(e.config.container),O.store.elements[e.id]=e}function c(e,t,n){var i={target:e,config:t,interval:n};O.history.push(i)}function f(){if(O.isSupported()){y();for(var e=0;e<O.store.containers.length;e++)O.store.containers[e].addEventListener("scroll",d),O.store.containers[e].addEventListener("resize",d);O.initialized||(window.addEventListener("scroll",d),window.addEventListener("resize",d),O.initialized=!0)}return O}function d(){T(y)}function u(){var e,t,n,i;O.tools.forOwn(O.sequences,function(o){i=O.sequences[o],e=!1;for(var r=0;r<i.elemIds.length;r++)n=i.elemIds[r],t=O.store.elements[n],q(t)&&!e&&(e=!0);i.active=e})}function y(){var e,t;u(),O.tools.forOwn(O.store.elements,function(n){t=O.store.elements[n],e=w(t),g(t)?(t.config.beforeReveal(t.domEl),e?t.domEl.setAttribute("style",t.styles.inline+t.styles.transform.target+t.styles.transition.delayed):t.domEl.setAttribute("style",t.styles.inline+t.styles.transform.target+t.styles.transition.instant),p("reveal",t,e),t.revealing=!0,t.seen=!0,t.sequence&&m(t,e)):v(t)&&(t.config.beforeReset(t.domEl),t.domEl.setAttribute("style",t.styles.inline+t.styles.transform.initial+t.styles.transition.instant),p("reset",t),t.revealing=!1)})}function m(e,t){var n=0,i=0,o=O.sequences[e.sequence.id];o.blocked=!0,t&&"onload"===e.config.useDelay&&(i=e.config.delay),e.sequence.timer&&(n=Math.abs(e.sequence.timer.started-new Date),window.clearTimeout(e.sequence.timer)),e.sequence.timer={started:new Date},e.sequence.timer.clock=window.setTimeout(function(){o.blocked=!1,e.sequence.timer=null,d()},Math.abs(o.interval)+i-n)}function p(e,t,n){var i=0,o=0,r="after";switch(e){case"reveal":o=t.config.duration,n&&(o+=t.config.delay),r+="Reveal";break;case"reset":o=t.config.duration,r+="Reset"}t.timer&&(i=Math.abs(t.timer.started-new Date),window.clearTimeout(t.timer.clock)),t.timer={started:new Date},t.timer.clock=window.setTimeout(function(){t.config[r](t.domEl),t.timer=null},o-i)}function g(e){if(e.sequence){var t=O.sequences[e.sequence.id];return t.active&&!t.blocked&&!e.revealing&&!e.disabled}return q(e)&&!e.revealing&&!e.disabled}function w(e){var t=e.config.useDelay;return"always"===t||"onload"===t&&!O.initialized||"once"===t&&!e.seen}function v(e){if(e.sequence){var t=O.sequences[e.sequence.id];return!t.active&&e.config.reset&&e.revealing&&!e.disabled}return!q(e)&&e.config.reset&&e.revealing&&!e.disabled}function b(e){return{width:e.clientWidth,height:e.clientHeight}}function h(e){if(e&&e!==window.document.documentElement){var t=x(e);return{x:e.scrollLeft+t.left,y:e.scrollTop+t.top}}return{x:window.pageXOffset,y:window.pageYOffset}}function x(e){var t=0,n=0,i=e.offsetHeight,o=e.offsetWidth;do isNaN(e.offsetTop)||(t+=e.offsetTop),isNaN(e.offsetLeft)||(n+=e.offsetLeft),e=e.offsetParent;while(e);return{top:t,left:n,height:i,width:o}}function q(e){function t(){var t=c+a*s,n=f+l*s,i=d-a*s,y=u-l*s,m=r.y+e.config.viewOffset.top,p=r.x+e.config.viewOffset.left,g=r.y-e.config.viewOffset.bottom+o.height,w=r.x-e.config.viewOffset.right+o.width;return t<g&&i>m&&n>p&&y<w}function n(){return"fixed"===window.getComputedStyle(e.domEl).position}var i=x(e.domEl),o=b(e.config.container),r=h(e.config.container),s=e.config.viewFactor,a=i.height,l=i.width,c=i.top,f=i.left,d=c+a,u=f+l;return t()||n()}function E(){}var O,T;e.prototype.defaults={origin:"bottom",distance:"20px",duration:500,delay:0,rotate:{x:0,y:0,z:0},opacity:0,scale:.9,easing:"cubic-bezier(0.6, 0.2, 0.1, 1)",container:window.document.documentElement,mobile:!0,reset:!1,useDelay:"always",viewFactor:.2,viewOffset:{top:0,right:0,bottom:0,left:0},beforeReveal:function(e){},beforeReset:function(e){},afterReveal:function(e){},afterReset:function(e){}},e.prototype.isSupported=function(){var e=document.documentElement.style;return"WebkitTransition"in e&&"WebkitTransform"in e||"transition"in e&&"transform"in e},e.prototype.reveal=function(e,s,a,d){var u,y,m,p,g,w;if(void 0!==s&&"number"==typeof s?(a=s,s={}):void 0!==s&&null!==s||(s={}),u=t(s),y=n(e,u),!y.length)return O;a&&"number"==typeof a&&(w=i(),g=O.sequences[w]={id:w,interval:a,elemIds:[],active:!1});for(var v=0;v<y.length;v++)p=y[v].getAttribute("data-sr-id"),p?m=O.store.elements[p]:(m={id:i(),domEl:y[v],seen:!1,revealing:!1},m.domEl.setAttribute("data-sr-id",m.id)),g&&(m.sequence={id:g.id,index:g.elemIds.length},g.elemIds.push(m.id)),o(m,s,u),r(m),l(m),O.tools.isMobile()&&!m.config.mobile||!O.isSupported()?(m.domEl.setAttribute("style",m.styles.inline),m.disabled=!0):m.revealing||m.domEl.setAttribute("style",m.styles.inline+m.styles.transform.initial);return!d&&O.isSupported()&&(c(e,s,a),O.initTimeout&&window.clearTimeout(O.initTimeout),O.initTimeout=window.setTimeout(f,0)),O},e.prototype.sync=function(){if(O.history.length&&O.isSupported()){for(var e=0;e<O.history.length;e++){var t=O.history[e];O.reveal(t.target,t.config,t.interval,!0)}f()}return O},E.prototype.isObject=function(e){return null!==e&&"object"==typeof e&&e.constructor===Object},E.prototype.isNode=function(e){return"object"==typeof window.Node?e instanceof window.Node:e&&"object"==typeof e&&"number"==typeof e.nodeType&&"string"==typeof e.nodeName},E.prototype.isNodeList=function(e){var t=Object.prototype.toString.call(e),n=/^\[object (HTMLCollection|NodeList|Object)\]$/;return"object"==typeof window.NodeList?e instanceof window.NodeList:e&&"object"==typeof e&&n.test(t)&&"number"==typeof e.length&&(0===e.length||this.isNode(e[0]))},E.prototype.forOwn=function(e,t){if(!this.isObject(e))throw new TypeError('Expected "object", but received "'+typeof e+'".');for(var n in e)e.hasOwnProperty(n)&&t(n)},E.prototype.extend=function(e,t){return this.forOwn(t,function(n){this.isObject(t[n])?(e[n]&&this.isObject(e[n])||(e[n]={}),this.extend(e[n],t[n])):e[n]=t[n]}.bind(this)),e},E.prototype.extendClone=function(e,t){return this.extend(this.extend({},e),t)},E.prototype.isMobile=function(){return/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)},T=window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame||function(e){window.setTimeout(e,1e3/60)},"function"==typeof define&&"object"==typeof define.amd&&define.amd?define(function(){return e}):"undefined"!=typeof module&&module.exports?module.exports=e:window.ScrollReveal=e}();
} catch(e) {}

/*
  FastClick: polyfill to remove click delays on browsers with touch UIs.

  @version 1.0.3
  @codingstandard ftlabs-jsv2
  @copyright The Financial Times Limited [All Rights Reserved]
  @license MIT License (see LICENSE.txt)
*/
(function(){"use strict";function e(t,r){function s(e,t){return function(){return e.apply(t,arguments)}}var i;r=r||{};this.trackingClick=false;this.trackingClickStart=0;this.targetElement=null;this.touchStartX=0;this.touchStartY=0;this.lastTouchIdentifier=0;this.touchBoundary=r.touchBoundary||10;this.layer=t;this.tapDelay=r.tapDelay||200;this.tapTimeout=r.tapTimeout||700;if(e.notNeeded(t)){return}var o=["onMouse","onClick","onTouchStart","onTouchMove","onTouchEnd","onTouchCancel"];var u=this;for(var a=0,f=o.length;a<f;a++){u[o[a]]=s(u[o[a]],u)}if(n){t.addEventListener("mouseover",this.onMouse,true);t.addEventListener("mousedown",this.onMouse,true);t.addEventListener("mouseup",this.onMouse,true)}t.addEventListener("click",this.onClick,true);t.addEventListener("touchstart",this.onTouchStart,false);t.addEventListener("touchmove",this.onTouchMove,false);t.addEventListener("touchend",this.onTouchEnd,false);t.addEventListener("touchcancel",this.onTouchCancel,false);if(!Event.prototype.stopImmediatePropagation){t.removeEventListener=function(e,n,r){var i=Node.prototype.removeEventListener;if(e==="click"){i.call(t,e,n.hijacked||n,r)}else{i.call(t,e,n,r)}};t.addEventListener=function(e,n,r){var i=Node.prototype.addEventListener;if(e==="click"){i.call(t,e,n.hijacked||(n.hijacked=function(e){if(!e.propagationStopped){n(e)}}),r)}else{i.call(t,e,n,r)}}}if(typeof t.onclick==="function"){i=t.onclick;t.addEventListener("click",function(e){i(e)},false);t.onclick=null}}var t=navigator.userAgent.indexOf("Windows Phone")>=0;var n=navigator.userAgent.indexOf("Android")>0&&!t;var r=/iP(ad|hone|od)/.test(navigator.userAgent)&&!t;var i=r&&/OS 4_\d(_\d)?/.test(navigator.userAgent);var s=r&&/OS ([6-9]|\d{2})_\d/.test(navigator.userAgent);var o=navigator.userAgent.indexOf("BB10")>0;e.prototype.needsClick=function(e){switch(e.nodeName.toLowerCase()){case"button":case"select":case"textarea":if(e.disabled){return true}break;case"input":if(r&&e.type==="file"||e.disabled){return true}break;case"label":case"iframe":case"video":return true}return/\bneedsclick\b/.test(e.className)};e.prototype.needsFocus=function(e){switch(e.nodeName.toLowerCase()){case"textarea":return true;case"select":return!n;case"input":switch(e.type){case"button":case"checkbox":case"file":case"image":case"radio":case"submit":return false}return!e.disabled&&!e.readOnly;default:return/\bneedsfocus\b/.test(e.className)}};e.prototype.sendClick=function(e,t){var n,r;if(document.activeElement&&document.activeElement!==e){document.activeElement.blur()}r=t.changedTouches[0];n=document.createEvent("MouseEvents");n.initMouseEvent(this.determineEventType(e),true,true,window,1,r.screenX,r.screenY,r.clientX,r.clientY,false,false,false,false,0,null);n.forwardedTouchEvent=true;e.dispatchEvent(n)};e.prototype.determineEventType=function(e){if(n&&e.tagName.toLowerCase()==="select"){return"mousedown"}return"click"};e.prototype.focus=function(e){var t;if(r&&e.setSelectionRange&&e.type.indexOf("date")!==0&&e.type!=="time"&&e.type!=="month"){t=e.value.length;e.setSelectionRange(t,t)}else{e.focus()}};e.prototype.updateScrollParent=function(e){var t,n;t=e.fastClickScrollParent;if(!t||!t.contains(e)){n=e;do{if(n.scrollHeight>n.offsetHeight){t=n;e.fastClickScrollParent=n;break}n=n.parentElement}while(n)}if(t){t.fastClickLastScrollTop=t.scrollTop}};e.prototype.getTargetElementFromEventTarget=function(e){if(e.nodeType===Node.TEXT_NODE){return e.parentNode}return e};e.prototype.onTouchStart=function(e){var t,n,s;if(e.targetTouches.length>1){return true}t=this.getTargetElementFromEventTarget(e.target);n=e.targetTouches[0];if(r){s=window.getSelection();if(s.rangeCount&&!s.isCollapsed){return true}if(!i){if(n.identifier&&n.identifier===this.lastTouchIdentifier){e.preventDefault();return false}this.lastTouchIdentifier=n.identifier;this.updateScrollParent(t)}}this.trackingClick=true;this.trackingClickStart=e.timeStamp;this.targetElement=t;this.touchStartX=n.pageX;this.touchStartY=n.pageY;if(e.timeStamp-this.lastClickTime<this.tapDelay){e.preventDefault()}return true};e.prototype.touchHasMoved=function(e){var t=e.changedTouches[0],n=this.touchBoundary;if(Math.abs(t.pageX-this.touchStartX)>n||Math.abs(t.pageY-this.touchStartY)>n){return true}return false};e.prototype.onTouchMove=function(e){if(!this.trackingClick){return true}if(this.targetElement!==this.getTargetElementFromEventTarget(e.target)||this.touchHasMoved(e)){this.trackingClick=false;this.targetElement=null}return true};e.prototype.findControl=function(e){if(e.control!==undefined){return e.control}if(e.htmlFor){return document.getElementById(e.htmlFor)}return e.querySelector("button, input:not([type=hidden]), keygen, meter, output, progress, select, textarea")};e.prototype.onTouchEnd=function(e){var t,o,u,a,f,l=this.targetElement;if(!this.trackingClick){return true}if(e.timeStamp-this.lastClickTime<this.tapDelay){this.cancelNextClick=true;return true}if(e.timeStamp-this.trackingClickStart>this.tapTimeout){return true}this.cancelNextClick=false;this.lastClickTime=e.timeStamp;o=this.trackingClickStart;this.trackingClick=false;this.trackingClickStart=0;if(s){f=e.changedTouches[0];l=document.elementFromPoint(f.pageX-window.pageXOffset,f.pageY-window.pageYOffset)||l;l.fastClickScrollParent=this.targetElement.fastClickScrollParent}u=l.tagName.toLowerCase();if(u==="label"){t=this.findControl(l);if(t){this.focus(l);if(n){return false}l=t}}else if(this.needsFocus(l)){if(e.timeStamp-o>100||r&&window.top!==window&&u==="input"){this.targetElement=null;return false}this.focus(l);this.sendClick(l,e);if(!r||u!=="select"){this.targetElement=null;e.preventDefault()}return false}if(r&&!i){a=l.fastClickScrollParent;if(a&&a.fastClickLastScrollTop!==a.scrollTop){return true}}if(!this.needsClick(l)){e.preventDefault();this.sendClick(l,e)}return false};e.prototype.onTouchCancel=function(){this.trackingClick=false;this.targetElement=null};e.prototype.onMouse=function(e){if(!this.targetElement){return true}if(e.forwardedTouchEvent){return true}if(!e.cancelable){return true}if(!this.needsClick(this.targetElement)||this.cancelNextClick){if(e.stopImmediatePropagation){e.stopImmediatePropagation()}else{e.propagationStopped=true}e.stopPropagation();e.preventDefault();return false}return true};e.prototype.onClick=function(e){var t;if(this.trackingClick){this.targetElement=null;this.trackingClick=false;return true}if(e.target.type==="submit"&&e.detail===0){return true}t=this.onMouse(e);if(!t){this.targetElement=null}return t};e.prototype.destroy=function(){var e=this.layer;if(n){e.removeEventListener("mouseover",this.onMouse,true);e.removeEventListener("mousedown",this.onMouse,true);e.removeEventListener("mouseup",this.onMouse,true)}e.removeEventListener("click",this.onClick,true);e.removeEventListener("touchstart",this.onTouchStart,false);e.removeEventListener("touchmove",this.onTouchMove,false);e.removeEventListener("touchend",this.onTouchEnd,false);e.removeEventListener("touchcancel",this.onTouchCancel,false)};e.notNeeded=function(e){var t;var r;var i;if(typeof window.ontouchstart==="undefined"){return true}r=+(/Chrome\/([0-9]+)/.exec(navigator.userAgent)||[,0])[1];if(r){if(n){t=document.querySelector("meta[name=viewport]");if(t){if(t.content.indexOf("user-scalable=no")!==-1){return true}if(r>31&&document.documentElement.scrollWidth<=window.outerWidth){return true}}}else{return true}}if(o){i=navigator.userAgent.match(/Version\/([0-9]*)\.([0-9]*)/);if(i[1]>=10&&i[2]>=3){t=document.querySelector("meta[name=viewport]");if(t){if(t.content.indexOf("user-scalable=no")!==-1){return true}if(document.documentElement.scrollWidth<=window.outerWidth){return true}}}}if(e.style.msTouchAction==="none"){return true}if(e.style.touchAction==="none"){return true}return false};e.attach=function(t,n){return new e(t,n)};if(typeof define=="function"&&typeof define.amd=="object"&&define.amd){define(function(){return e})}else if(typeof module!=="undefined"&&module.exports){module.exports=e.attach;module.exports.FastClick=e}else{window.FastClick=e}})();

/**!
 * trunk8 v1.3.2
 * https://github.com/rviscomi/trunk8
 * 
 * Copyright 2012 Rick Viscomi
 * Released under the MIT License.
 * 
 * Date: October 21, 2012
 */

(function($){var methods,utils,SIDES={center:'center',left:'left',right:'right'},WIDTH={auto:'auto'};function trunk8(element){this.$element=$(element);this.original_text=this.$element.html();this.settings=$.extend({},$.fn.trunk8.defaults);}trunk8.prototype.updateSettings=function(options){this.settings=$.extend(this.settings,options);};function truncate(){var data=this.data('trunk8'),settings=data.settings,width=settings.width,side=settings.side,fill=settings.fill,line_height=utils.getLineHeight(this)*settings.lines,str=data.original_text,length=str.length,max_bite='',lower,upper,bite_size,bite;this.html(str);if(width===WIDTH.auto){if(this.height()<=line_height){return;}lower=0;upper=length-1;while(lower<=upper){bite_size=lower+((upper-lower)>>1);bite=utils.eatStr(str,side,length-bite_size,fill);this.html(bite);if(this.height()>line_height){upper=bite_size-1;}else{lower=bite_size+1;max_bite=(max_bite.length>bite.length)?max_bite:bite;}}this.html('');this.html(max_bite);if(settings.tooltip){this.attr('title',str);}}else if(!isNaN(width)){bite_size=length-width;bite=utils.eatStr(str,side,bite_size,fill);this.html(bite);if(settings.tooltip){this.attr('title',str);}}else{$.error('Invalid width "'+width+'".');}}methods={init:function(options){return this.each(function(){var $this=$(this),data=$this.data('trunk8');if(!data){$this.data('trunk8',(data=new trunk8(this)));}data.updateSettings(options);truncate.call($this);});},update:function(new_string){return this.each(function(){var $this=$(this);if(new_string){$this.data('trunk8').original_text=new_string;}truncate.call($this);});},revert:function(){return this.each(function(){var text=$(this).data('trunk8').original_text;$(this).html(text);});},getSettings:function(){return this.get(0).data('trunk8').settings;}};utils={eatStr:function(str,side,bite_size,fill){var length=str.length,key=utils.eatStr.generateKey.apply(null,arguments),half_length,half_bite_size;if(utils.eatStr.cache[key]){return utils.eatStr.cache[key];}if((typeof str!=='string')||(length===0)){$.error('Invalid source string "'+str+'".');}if((bite_size<0)||(bite_size>length)){$.error('Invalid bite size "'+bite_size+'".');}else if(bite_size===0){return str;}if(typeof(fill+'')!=='string'){$.error('Fill unable to be converted to a string.');}switch(side){case SIDES.right:return utils.eatStr.cache[key]=$.trim(str.substr(0,length-bite_size))+fill;case SIDES.left:return utils.eatStr.cache[key]=fill+$.trim(str.substr(bite_size));case SIDES.center:half_length=length>>1;half_bite_size=bite_size>>1;return utils.eatStr.cache[key]=$.trim(utils.eatStr(str.substr(0,length-half_length),SIDES.right,bite_size-half_bite_size,''))+fill+$.trim(utils.eatStr(str.substr(length-half_length),SIDES.left,half_bite_size,''));default:$.error('Invalid side "'+side+'".');}},getLineHeight:function(elem){var $elem=$(elem),float=$elem.css('float'),position=$elem.css('position'),html=$elem.html(),wrapper_id='line-height-test',line_height;if(float!=='none'){$elem.css('float','none');}if(position==='absolute'){$elem.css('position','static');}$elem.html('i').wrap('<div id="'+wrapper_id+'" />');line_height=$('#'+wrapper_id).innerHeight();$elem.html(html).css({'float':float,'position':position}).unwrap();return line_height;}};utils.eatStr.cache={};utils.eatStr.generateKey=function(){return Array.prototype.join.call(arguments,'');};$.fn.trunk8=function(method){if(methods[method]){return methods[method].apply(this,Array.prototype.slice.call(arguments,1));}else if(typeof method==='object'||!method){return methods.init.apply(this,arguments);}else{$.error('Method '+method+' does not exist on jQuery.trunk8');}};$.fn.trunk8.defaults={fill:'&hellip;',lines:1,side:SIDES.right,tooltip:true,width:WIDTH.auto};})(jQuery);

/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
(function(a){a.fn.prepareTransition=function(){return this.each(function(){var b=a(this);b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",function(){b.removeClass("is-transitioning")});var c=["transition-duration","-moz-transition-duration","-webkit-transition-duration","-o-transition-duration"];var d=0;a.each(c,function(a,c){d=parseFloat(b.css(c))||d});if(d!=0){b.addClass("is-transitioning");b[0].offsetWidth}})}})(jQuery);

/* replaceUrlParam - http://stackoverflow.com/questions/7171099/how-to-replace-url-parameter-with-javascript-jquery */
function replaceUrlParam(e,r,a){var n=new RegExp("("+r+"=).*?(&|$)"),c=e;return c=e.search(n)>=0?e.replace(n,"$1"+a+"$2"):c+(c.indexOf("?")>0?"&":"?")+r+"="+a};

$(document).ready(function(){
  // campaign discount banner JS starts
 
  window.store_active_currency_symbol =  getactive_currency_symbol();
  
  function getactive_currency_symbol() {
    var store_active_currency = Shopify.currency.active;
    if ( store_active_currency == 'GBP') {
      return '\xA3';
    } else if ( store_active_currency == 'USD') {
      return '\x24';
    } else if ( store_active_currency == 'EUR') {
      return '\x80';
    }
  }

  $('.active_currency_symbol').text(window.store_active_currency_symbol)
  var code_and_value = getCampaignParams();

  if (code_and_value) {
    var code = code_and_value[0];
    var value = code_and_value[1];
    var basket_total = $('#camp-cart-total').text() / 100;
    var discount_remaining = value - basket_total;

    $('.campaign-discount .discount-code').text(code);
    $('.campaign-discount .discount-value').text(value);
    $('.campaign-discount .basket-total').text(basket_total);
    if (discount_remaining > 0) {
      $('.campaign-discount .discount-remaining').text(discount_remaining);
    } else {
      $('.campaign-discount .gift-card').remove();
    }
    
    $('.campaign-discount').show();
  }
  // campaign discount banner JS ends
});

function getCampaignParams() {
  var search = '';
  var has_code = false;
  var has_value = false;
  var code = '';
  var value = '';

  search = window.location.search.substr(1);
  var params = search.split('&');
  params.forEach(function(param){
    if (param.indexOf('nbcode') > -1) {
      has_code = true;
      code = param.split('=')[1];
    }
    if (param.indexOf('nbvalue') > -1) {
      has_value = true;
      value = param.split('=')[1];
    }
  });

  if (has_code && has_value) {
    setCookie("campaign_discount", "nbcode=" + code + "&nbvalue=" + value, 30);

    return [code, value];
  } else {
    var campaign_discount_cookie = getCookie("campaign_discount");
    if (campaign_discount_cookie) {
      code = campaign_discount_cookie.split('&')[0].split('=')[1];
      value = campaign_discount_cookie.split('&')[1].split('=')[1]

      return [code, value];
    } else {
      return false;
    }
  }
}

function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days*24*60*60*1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
    var c = ca[i];
    while (c.charAt(0)==' ') c = c.substring(1,c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}
// campaign discount banner JS ends


/*============================================================================
  Money Format
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/
if ((typeof Shopify) === 'undefined') { Shopify = {}; }
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || this.money_format);

    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

// Timber functions
window.timber = window.timber || {};

timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html                    : $('html'),
    $body                    : $(document.body),

    // Navigation
    $navigation              : $('#AccessibleNav'),
    $mobileSubNavToggle      : $('.mobile-nav__toggle'),


    // Collection Pages
    $changeView              : $('.change-view'),

    // Product Page
    $productImage            : $('#ProductPhotoImg'),
    $thumbImages             : $('#ProductThumbs').find('a.product-single__thumbnail'),

    // Customer Pages
    $recoverPasswordLink     : $('#RecoverPassword'),
    $hideRecoverPasswordLink : $('#HideRecoverPasswordLink'),
    $recoverPasswordForm     : $('#RecoverPasswordForm'),
    $customerLoginForm       : $('#CustomerLoginForm'),
    $passwordResetSuccess    : $('#ResetSuccess')
  };
};

timber.init = function () {
  //FastClick.attach(document.body);
  timber.cacheSelectors();
  //timber.accessibleNav();
  timber.drawersInit();
  timber.mobileNavToggle();
  timber.productImageSwitch();
  timber.responsiveVideos();
  timber.collectionViews();
  timber.loginForms();
  //timber.searchNav();
};

timber.searchNav = function () { 
  var searchDropdown = $('#search-wrapper'),
      headerBG = $('.site-header'),
      searchContainer = $('.search-dropdown');

  var navClose = function(event){
    $(searchContainer).removeClass('searching');
    $(headerBG).removeClass('mega-nav-bg');
    $('.dimSearch').css("display","none");
    $('.dim').css("display","none");
    $('body').unbind('click', navOpen);
  }

  var navOpen = function(event) {
    var $eventTarget = $(event.target);
    if($eventTarget.closest('#search-wrapper').length == 0) {
      if($('.search-dropdown').is(':visible')) {
        navClose();
      }  
    }
  }

  searchDropdown.click(function(event){
    event.stopPropagation();
    $('body').unbind('click', navOpen); //Clear it just in case
    $('.dim').css("display","none");
    $(searchContainer).addClass('searching');
    $('.dimSearch').css("display","block");
    $(headerBG).addClass('mega-nav-bg');

    $("body").click (navOpen);

  });

  $(window).scroll(function(e) {
    if($('.search-dropdown').is(':visible')) {
      $('.dim').css("display","none");
      $('.dimSearch').css("display","block");
      navClose();
    }  
  })

};



timber.drawersInit = function () {
  timber.LeftDrawer = new timber.Drawers('NavDrawer', 'left');
  
  if(typeof ajaxCart !== 'undefined') {
    timber.RightDrawer = new timber.Drawers('CartDrawer', 'right', {
      'onDrawerOpen': ajaxCart.load
    });
  }
  
};

timber.mobileNavToggle = function () {
  timber.cache.$mobileSubNavToggle.on('click', function() {
    $(this).parent().toggleClass('mobile-nav--expanded');
  });
};

timber.getHash = function () {
  return window.location.hash;
};

timber.productPage = function (options) {
  var moneyFormat = options.money_format,
      variant = options.variant,
      selector = options.selector,
      section_id = $('.ProductSection').data('section-id');

  // Selectors
  var $productImage = $('#ProductPhotoImg'),
      $addToCart = $('#AddToCart'),      
      $addToCartDesk = $('#AddToCartDesk'),
      $AddToCartSold = $('#AddToCartSold'),
      $smart = $('.shopify-payment-button'),
      $productPrice = $('#ProductPrice, #ProductPriceMobile'),
      $productCurrentVariant = $('#ProductCurrentVariant'),
      $comparePrice = $('#ComparePrice'),
      $quantityElements = $('.quantity-selector, label + .js-qty'),
      $addToCartText = $('#AddToCartText'),
      $addToCartTextDesk = $('#AddToCartTextDesk');

  if (variant) {
    // Update variant image, if one is set
    if (variant.featured_image) {
      var prodImg = ".ProductImg-" + $('.product-template__container').data('section-id');
      
      
      var v_img = $(prodImg + '[data-image-id="' + variant.featured_image.id + '"]');
      var newPosition = v_img.parent().attr('data-slick-index');
      if(newPosition !== undefined) {
        $('.simple_product .sb_header_slider').slick('slickGoTo', newPosition);
      }
    } 
    var $this = $(this);
    var $option_selected = $this.find('option:selected');
    if($option_selected.data('img-id')) {
        var img_id = $this.find('option:selected').data('img-id');
        var $prod_slider = $details_container.find('.featured-product-slider');
        var newPosition = $prod_slider.find('img[data-fimg-id="' + img_id + '"]').parent().attr('data-slick-index');
        if(newPosition !== undefined) {
          $prod_slider.slick('slickGoTo', newPosition);
        }
      }

    // Select a valid variant if available
    if (variant.available) {
      // Available, enable the submit button, change text, show quantity elements
      $addToCart.removeClass('disabled').prop('disabled', false);
      $smart.show();
      $addToCartDesk.show();
      $AddToCartSold.hide();
      $addToCartText.html("Add to Basket");
      $quantityElements.show();
    } else {
      // Sold out, disable the submit button, change text, hide quantity elements
      $smart.addClass('disabled').prop('disabled', true).hide();
      $addToCart.addClass('disabled').prop('disabled', true);
      $addToCartDesk.hide();
      $addToCartDesk.addClass('disabled').prop('disabled', true);;
      $AddToCartSold.show();
      $AddToCartSold.addClass('disabled').prop('disabled', true);
      $addToCartText.html("Sold Out");
      $addToCartTextDesk.html("Sold Out");
      $quantityElements.hide();
    }

    // Regardless of stock, update the product price
    $productPrice.html( Shopify.formatMoney(variant.price, moneyFormat) );
    
    // Also update and show the product's compare price if necessary
    if (variant.compare_at_price > variant.price) {
      $comparePrice
      .html("was" + ' ' + Shopify.formatMoney(variant.compare_at_price, moneyFormat))
      .show();
    } else {
      $comparePrice.hide();
    }

  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html("Unavailable");
    $quantityElements.hide();
  }
};

timber.productImageSwitch = function () {
  if (timber.cache.$thumbImages.length) {
    // Switch the main image with one of the thumbnails
    // Note: this does not change the variant selected, just the image
    timber.cache.$thumbImages.on('click', function(evt) {
      evt.preventDefault();
      var newImage = $(this).attr('href');
      
      timber.switchImage(newImage, null, timber.cache.$productImage);
    });
  }
};

timber.switchImage = function (src, imgObject, el) {
  // Make sure element is a jquery object
  var $el = $(el);
  $el.attr('src', src);
};

timber.responsiveVideos = function () {
  var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
  var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

  $iframeVideo.each(function () {
    // Add wrapper to make video responsive
    $(this).wrap('<div class="video-wrapper"></div>');
  });

  $iframeReset.each(function () {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on 'back'" bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
  });
};

timber.collectionViews = function () {
  if (timber.cache.$changeView.length) {
    timber.cache.$changeView.on('click', function() {
      var view = $(this).data('view'),
          url = document.URL,
          hasParams = url.indexOf('?') > -1;

      if (hasParams) {
        window.location = replaceUrlParam(url, 'view', view);
      } else {
        window.location = url + '?view=' + view;
      }
    });
  }
};

timber.loginForms = function() {
  function showRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.show();
    timber.cache.$customerLoginForm.hide();
  }

  function hideRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.hide();
    timber.cache.$customerLoginForm.show();
  }

  timber.cache.$recoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
  });

  timber.cache.$hideRecoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  });

  // Allow deep linking to recover password form
  if (timber.getHash() == '#recover') {
    showRecoverPasswordForm();
  }
};

timber.resetPasswordSuccess = function() {
  timber.cache.$passwordResetSuccess.show();
};

/*============================================================================
  Drawer modules
  - Docs http://shopify.github.io/Timber/#drawers
==============================================================================*/
timber.Drawers = (function () {
  var Drawer = function (id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-left'
    };

    this.$nodes = {
      parent: $('body, html'),
      page: $('#PageContainer'),
      moved: $('.is-moved-by-drawer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = $('html').hasClass('js-drawer-open');
    //this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function () {
    //Clear events just in case this is a re-init
    $('.js-drawer-open-left').off('click');
    this.$drawer.find(this.config.close).off('click');
    //Set the events
    $('.js-drawer-open-left').on('click', $.proxy(this.open, this));
    this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Notify the drawer is going to open
    timber.cache.$body.trigger('beforeDrawerOpen.timber', this);

    // Run function when draw opens if set
    if (this.config.onDrawerOpen && typeof(this.config.onDrawerOpen) == 'function') {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    // Lock scrolling on mobile
    this.$nodes.page.on('touchmove.drawer', function () {
      return false;
    });

    this.$nodes.page.on('click.drawer', $.proxy(function () {
      this.close();
      return false;
    }, this));

    // Set focus on drawer
    this.trapFocus(this.$drawer, 'drawer_focus');

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$nodes.moved.addClass('is-transitioning');
    this.$drawer.prepareTransition();

    this.$nodes.parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true;

    // Notify the drawer has opened
    timber.cache.$body.trigger('afterDrawerOpen.timber', this);
  };

  Drawer.prototype.close = function () {
    if (!this.drawerIsOpen) { // don't close a closed drawer
      return;
    }

    // Notify the drawer is going to close
    timber.cache.$body.trigger('beforeDrawerClose.timber', this);

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$nodes.moved.prepareTransition({ disableExisting: true });
    this.$drawer.prepareTransition({ disableExisting: true });

    this.$nodes.parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

    this.drawerIsOpen = false;

    // Remove focus on drawer
    this.removeTrapFocus(this.$drawer, 'drawer_focus');

    this.$nodes.page.off('.drawer');

    // Notify the drawer is closed now
    timber.cache.$body.trigger('afterDrawerClose.timber', this);
  };

  Drawer.prototype.trapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.attr('tabindex', '-1');

    $container.focus();

    $(document).on(eventName, function (evt) {
      if ($container[0] !== evt.target && !$container.has(evt.target).length) {
        $container.focus();
      }
    });
  };

  Drawer.prototype.removeTrapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.removeAttr('tabindex');
    $(document).off(eventName);
  };

  return Drawer;
})();


// Initialize Timber's JS on docready
$(timber.init);



var theme = window.theme || theme || {} ;

theme.Utilities = (function () {
  function Utilities() { }

  Utilities.prototype = {
    runAtNewDocHeight: function(func, timesPerSecond, seconds) {
      var startHeight = $(document).height();
      var repeatRate = 1000 / (timesPerSecond || 5);
      var maxRepeat = (timesPerSecond || 5) * (seconds || 5);
      this._counter = 0;
      this._doRunAtNewDocHeight(this, func, startHeight, repeatRate, maxRepeat);
    },
    _doRunAtNewDocHeight: function(self, func, startHeight, repeatRate, maxRepeat) {
      if(startHeight != $(document).height()) {
        clearTimeout(this._docHeightTimeout);
        func();
      } else {
        this._counter += 1;
        if(this._counter < maxRepeat) {
          this._docHeightTimeout = setTimeout(function() {
            self._doRunAtNewDocHeight(self, func, startHeight, repeatRate, maxRepeat);
          }, repeatRate);
        }
      }
    },
    runAfterStoppedScrolling: function(func, timesPerSecond, seconds) {
      var startTop = $(window).scrollTop();
      this._counter = 0;
      var repeatRate = 1000 / (timesPerSecond || 5);
      var maxRepeat = (timesPerSecond || 5) * (seconds || 5);
      this._doRunAfterStoppedScrolling(this, func, startTop, repeatRate, maxRepeat);
    },
    _doRunAfterStoppedScrolling: function(self, func, prevTop, repeatRate, maxRepeat) {
      var currTop = $(window).scrollTop();
      if(prevTop == currTop) {
        clearTimeout(this._docScrollTimeout);
        func();
      } else {
        this._counter += 1;
        prevTop = currTop;
        if(this._counter < maxRepeat) {
          this._docScrollTimeout = setTimeout(function() {
            self._doRunAfterStoppedScrolling(self, func, prevTop, repeatRate, maxRepeat);
          }, repeatRate);
        }
      }
    }
  }

  return new Utilities();
}());



/*
    theme.AjaxCart
    Performs ajax calls to Shopify.
*/
theme.AjaxCart = (function () {
    return {
        /***** Public Properties *****/
        // Custom event types. NOTE: Events are tied to the
        // document's body.
        eventStrs: {
            addToCartSuccess: 'theme:ajaxCart:addSuccess',
            addToCartError: 'theme:ajaxCart:addError',
            updateCartSuccess: 'theme:ajaxCart:updateSuccess',
            updateCartError: 'theme:ajaxCart:updateError',
            getCartSuccess: 'theme:ajaxCart:getCartSuccess',
            getCartError: 'theme:ajaxCart:getCartError'
        },
        /***** Public Methods *****/
        /*
            =function addToCart(variantId, qty)
            Adds qty amount of the variant that has the passed in ID
            to the cart. Also adds line properties if any are available.
            Triggers an add to cart success or error event when done.
            =Params
            (int) variantId: The ID of the variant to add
            (int) qty: The amount of the variant to add
            (jQuery object) properties: The line properties for the product
        */
        addToCart: function (variantId, qty, properties) {
            var self = this;
            var data = {
                id: variantId,
                quantity: qty
            };
            //Only do this code if we have properties to use
            if(properties && !$.isEmptyObject(properties)) {
                data["properties"] = properties;
            }
            //Perform the AJAX call
            this._doAjax('/cart/add.js', data, 
            function(resultObj) {
                $('body').trigger(self.eventStrs.addToCartSuccess, [resultObj]);
            }, function(resultObj) {
                $('body').trigger(self.eventStrs.addToCartError);
            });
        },
        /*
            =function updateCart(cartStr)
            Updates the cart to reflect the passed in string. Triggers an
            update cart succes or error event when done.
            =Params
            (string) cartStr: The string that the cart should reflect
        */
        updateCart: function(cartStr) {
            var self = this;
            this._doAjax('/cart/update.js', cartStr, function(resultObj) {
                $('body').trigger(self.eventStrs.updateCartSuccess, [resultObj]);
            }, function(resultObj) {
                $('body').trigger(self.eventStrs.updateCartError, [resultObj]);
            });
        },
        /*
            =function getCartData()
            Gets the cart object from Shopify. Triggers a get cart
            data succes or error event when done.
        */
        getCartData: function() {
            var self = this;
            this._doAjax('/cart.js', null, function(cart) {
                $('body').trigger(self.eventStrs.getCartSuccess, [cart]);
            }, function(cart) {
                $('body').trigger(self.eventStrs.getCartError, [cart]);
            });
        },
        
        /***** Private Methods *****/
        /*
            =function _doAjax(url, data, successFunc, errorFunc)
            Performs an ajax call using the passed in information
            =Params
            (string) url: The URL to post to
            (object) data: The data to post
            (function) successFunc: (optional) The function to call on
                                    success
            (function) errorFunc: (optional) The function to call on
                                  error
        */
        _doAjax: function (url, data, successFunc, errorFunc) {
            var self = this;
            $.ajax({
                type: 'POST',
                url: url,
                data: data,
                dataType: 'json',
                success: function(resultObj) {
                    if($.isFunction(successFunc)) {
                        if (resultObj.items) {
                          resultObj.items = resultObj.items.map(function(item){
                            item.variant = self._fetchVariant(item.handle, item.variant_id);
                            return item;
                          });
                        } else {
                          resultObj.variant = self._fetchVariant(resultObj.handle, resultObj.variant_id);
                        }
                        successFunc(resultObj);
                    }
                },
                error: function(resultObj) {
                    if($.isFunction(errorFunc)) {
                        errorFunc(resultObj);
                    }
                }
            });
        },
        _fetchVariant: function(productHandle, variantId) {
          var variant = null;
          $.ajax({
            type: 'GET',
            url: '/products/' + productHandle + '.js',
            dataType: 'json',
            async: false
          }).done(function(resultObj) {
            if (resultObj && resultObj.variants) {
              variant = resultObj.variants.filter(function(variant){ return variant.id == variantId});
            }
          });

          return variant[0];
        }
    };
}());


/*
    theme.Currency
    Modified version of theme.Currency provided by Shopify's
    Slate framework. Adjusts include:
      -changes how the code is made available
      -"var moneyFormat" modified to be accessible so it can
        be adjusted as needed
      -fixes a bug around setting a default "precision" value
    
*/
theme.Currency = (function () {
    return {
        moneyFormat: '${{amount}}',
        formatMoney: function (cents, format) {
            if (typeof cents === 'string') {
                cents = cents.replace('.', '');
            }
            var value = '';
            var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
            var formatString = (format || this.moneyFormat);

            function formatWithDelimiters(number, precision, thousands, decimal) {
                precision = precision === undefined ? 2 : precision;
                thousands = thousands || ',';
                decimal = decimal || '.';

                if (isNaN(number) || number == null) {
                    return 0;
                }

                number = (number / 100.0).toFixed(precision);

                var parts = number.split('.');
                var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
                var centsAmount = parts[1] ? (decimal + parts[1]) : '';

                return dollarsAmount + centsAmount;
            }

            switch (formatString.match(placeholderRegex)[1]) {
                case 'amount':
                    value = formatWithDelimiters(cents, 2);
                    break;
                case 'amount_no_decimals':
                    value = formatWithDelimiters(cents, 0);
                    break;
                case 'amount_with_comma_separator':
                    value = formatWithDelimiters(cents, 2, '.', ',');
                    break;
                case 'amount_no_decimals_with_comma_separator':
                    value = formatWithDelimiters(cents, 0, '.', ',');
                    break;
                case 'amount_no_decimals_with_space_separator':
                    value = formatWithDelimiters(cents, 0, ' ');
                    break;
            }

            return formatString.replace(placeholderRegex, value);
        }
    };
})();


/*
    theme.Variants
    
    Contains all the methods needed to initialize variant
    controls, which includes changing the variant and
    changing the quantity that will be added to the cart.
    
    =Requirements
      *The quantity field and plus and minus buttons should be
        within some targetable container set in qtyContainer
      *When there are multiple options, the select element
        for each option MUST have a selector that ends with the
        0 index of that option. For instance,
            <select id="productSelect-op1" ...>
            <select id="productSelect-op2" ...>
            <select id="productSelect-op3" ...>
        or
            <select class="prod-option1" ...>
            <select class="prod-option2" ...>
            <select class="prod-option3" ...>
    
    Related directly to:
    /snippets/variant-qty-controls.liquid
    /snippets/variant-selects.liquid
*/
theme.Variants = (function () {
    return {
        /***** Public Properties *****/
        // Custom event types. NOTE: Events are tied to the
        // section's container (selector: [data-section-id])
        eventStrs: {
            onQtyChanged: 'theme:variants:qtyChanged',
            onVariantChanged: 'theme:variants:changed'
        },
        /***** Private Properties *****/
        //Selectors used for jQuery targeting
        _selectors: {
            //Variant Selection
            multiOpRealProdSelect: '#actualProdSelect',
            multiOpAllSelects: '.multiop-select',
            multiOpSelect: '#productSelect-op',
            prodSelect: '#productSelect',
            smart: '.shopify-payment-button',
            //Quantity Controls
            qtyContainer: '#quantity-container',
            qtyField: '#quantity',
            qtyMinus: '#quantity-minus',
            qtyPlus: '#quantity-plus',
            removeItem: '#remove-item'
        },
        
        /***** Public Methods *****/
        /*
            =function init(container)
            Initializes the select events for the variation dropdowns.
            Automatically determines whether to initialize a multi-option
            select or single-option based on id based selectors.
            =Params
            (mixed) container: Value can be a jQuery selector string, jQuery
                                object, or element. The value should return the
                                container that may have variant select(s) when
                                passed to jQuery.
            (bool) initControls: (optional) If true, the quantity controls will
                                  be initialized.
        */
        init: function (container, initControls) {
            var self = this;
            var $container = $(container);
            var $swatch = $('.variant-group').data('swatch');
            // Check to see if the hidden select exists for multi-option. If it does,
            // init the multi-option selects. Otherwise, init single-option.
            var $select = $container.find(self._selectors.multiOpRealProdSelect);
            if ($select.length > 0) {
              self._initMultiOpSelect($container, $container.find(self._determineAllSelectorFromStr(self._selectors.multiOpAllSelects)));
            } else {
                self._initSingleOpSelect($container, $container.find(self._selectors.prodSelect));
            }
            if(initControls) {
                self.initQtyControls($container);
            }
          jQuery('.variant-group-multiple .swatch :radio').change(function() {
          jQuery(this).closest('.swatch').find('.swatch-element.selected').removeClass('.selected');
          var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
          var optionValue = jQuery(this).val();

        $(this).closest('.swatch-element').addClass('selected')

          jQuery(this)
            .closest('form')
            .eq(optionIndex)
            .val(optionValue)
            .trigger('change');
        });


        },
        /*
            =function initQtyControls(container)
            Initializes the events that control quantity changes
            =Params
            (mixed) container: Value can be a jQuery selector string, jQuery
                                object, or element. The value should return the
                                container that may have the quantity controls
                                when passed to jQuery
        */
        initQtyControls: function (container) {
            var self = this;
            var $container = $(container);
            //Init the plus button click event
            $container.find(this._selectors.qtyPlus).click(function (e) {
                e.preventDefault();
                $(theme.Cart._selectors.cartItemsContainerPopup).addClass('in-process');
                self._adjustQty($(self._selectors.qtyField, $(this).closest(self._selectors.qtyContainer)), 1);
            });
            //Init the minus button click event
            $container.find(this._selectors.qtyMinus).click(function (e) {
                e.preventDefault();
                $(theme.Cart._selectors.cartItemsContainerPopup).addClass('in-process');
                self._adjustQty($(self._selectors.qtyField, $(this).closest(self._selectors.qtyContainer)), -1);
            });
            //Init the change event for the quantity number field
            $container.find(this._selectors.qtyField).change(function (e) {
                e.preventDefault();
                $(theme.Cart._selectors.cartItemsContainerPopup).addClass('in-process');
                self._adjustQty($(this), 0);
            });
            // Init the remove button click event
            $container.find(this._selectors.removeItem).click(function (e) {
              e.preventDefault();
              $(theme.Cart._selectors.cartItemsContainerPopup).addClass('in-process');
              self._removeItem($(this).closest('.js-cart-item-info-container').find(self._selectors.qtyField));
            });
        },
        /*
            =function getSelectedVariant(container)
            Convenience function that will return the currently selected variant
            within the provided container. Automatically determines whether to
            check against a multi-option or single-option select. If neither are valid,
            it will return whatever input has name="id".
            =Params
            (mixed) container: Value can be a jQuery selector string, jQuery
                                object, or element. The value should return the
                                container(s) that may have variant select(s) when
                                passed to jQuery
        */
        getSelectedVariant: function (container) {
            // Check to see if the hidden select exists for multi-option. If it does,
            // return it's current selection
            var $select = $(this._selectors.multiOpRealProdSelect, container);
            if ($select.length > 0) {
                  if($select.find('option').length > 0){
                      return $select.find('option:selected');
                }else{
                    return $select.find('input:checked');
                }
            } else {
                // If it doesn't, return the single-option's selection
                $select = $(this._selectors.prodSelect);
                if ($select.length > 0) {
                    if($select.find('option').length > 0){
                      return $select.find('option:selected');
                }else{
                    return $select.find('input:checked');
                }
                } else {
                    // If neither exist, return the default input used in forms
                    return $('input[name="id"]');
                }
            }
        },
        /*
            =function getVariantQuantity(container)
            Gets the current quantity from the quantity field. Returns 1 if
            none can be found.
            =Params
            (mixed) container: Value can be a jQuery selector string, jQuery
                                object, or element. The value should return the
                                container(s) that may have variant select(s) when
                                passed to jQuery
        */
        getVariantQuantity: function(container) {
            var $qtyField = $(this._selectors.qtyField, container);
            if($qtyField.length > 0) {
                return parseInt($qtyField.val());
            } else {
                return 1;
            }
        },
        /*
            =function gatherQuantityFields(container)
            Returns all the quantity fields found within the container
            =Params
            (mixed) container: Value can be a jQuery selector string, jQuery
                                object, or element. The value should return the
                                container(s) that may have variant select(s) when
                                passed to jQuery
        */
        gatherQuantityFields: function(container) {
            return $(this._determineAllSelectorFromStr(this._selectors.qtyField), container);
        },
        /*
            =function enableControl($control)
            Enables the passed in control
            =Params
            (jQuery) $control: The control to enable
        */
        enableControl: function($control) {
            $control.prop('disabled', false);
        },
        /*
            =function disableControl($control)
            Disables the passed in control
            =Params
            (jQuery) $control: The control to disable
        */
        disableControl: function($control) {
            $control.prop('disabled', true);
        },
        /*
            =function enableAllControls()
            Enables ALL quantity controls on the page
        */
        enableAllControls: function() {
            var self = this;
            var selector = self._determineAllSelectorFromStr(this._selectors.qtyContainer);
            $(selector).each(function() {
                var $this = $(this);
                self._performOnQtyControls($this, self.enableControl);
            });
        },
        /*
            =function disableAllControls()
            Disables ALL quantity controls on the page
        */
        disableAllControls: function() {
            var self = this;
            var selector = self._determineAllSelectorFromStr(this._selectors.qtyContainer);
            $(selector).each(function() {
                var $this = $(this);
                self._performOnQtyControls($this, self.disableControl);
            });
        },
        
        /***** Private Methods *****/
        /*
            =function _initSingleOpSelect($select)
            Initializes the single-option variant select
            =Params
            (jQuery) $select: The single-option select
        */
        _initSingleOpSelect: function ($container, $select) {
            var self = this;
            $select.change(function (evt) {
                var $this = $(this);
              if($this.find('option').length > 0){
                  self._fireChangeEvent($container, self._getBaseVariantObj($this.find('option:selected')));
              }else{
                  self._fireChangeEvent($container, self._getBaseVariantObj($this.find('input:checked')));
              }
            });
        },
        /*
            =function _initMultiOpSelect($container, $select)
            Initializes the single-option variant select
            =Params
            (jQuery) $container: The container housing the select 
            (jQuery) $select: The multi-option select
        */
        _initMultiOpSelect: function ($container, $select) {
            var self = this;
            var selectLen = $select.length;
            var $swatch = $('.variant-group').data('swatch');
            $select.change(function () {
                var $this = $(this);
                //Get the option string from the selected options
                var opId = '';
                for (var i = 0; i < selectLen; ++i) {
                    var $currSelect = $container.find(self._selectors.multiOpSelect + i);
                    if ($currSelect.length > 0) {
                        if (i > 0) {
                            opId += ' / ';
                        }
                        if ($swatch){
                          opId += $currSelect.find('input:checked').val();

                      }else{
                        opId += $currSelect.find('option:selected').val();

                      }
                  }
                }
                //Properly escape quotes to keep selector string from breaking
                opId = opId.replace(/"/g, '\\"');
                opId = opId.replace("\'", "\\'");
                //Get the real variant select
                var $actualSelector = $container.find(self._selectors.multiOpRealProdSelect);
                //In that select find the option that matches the option string
                var $selection = $actualSelector.find('option[data-opid="' + opId + '"]');
                if($selection.length > 0) {
                    //Update the real variant select's value to the correct value
                    $actualSelector.val($selection.val());
                    //Prepare and fire the change event
                    var variantObj = self._getBaseVariantObj($selection);
                    variantObj.options = opId;
                    self._fireChangeEvent($container, variantObj);
                } else {
                    self._fireChangeEvent($container, null);
                }
            });
        },

        /*
            =function _adjustQty($qtyField, offset)
            Adjusts the quantity by offset in the $qtyField and keeps it
            within at or above the minimum
            =Params
            (jQuery) $qtyField: The input that is storing the quantity
            (int) offset: The amount to adjust the quantity by
        */
        _adjustQty: function($qtyInput, offset) {
            var currentVal = parseInt($qtyInput.val());
            var min = $qtyInput.attr('min');
            if (isNaN(currentVal)) {
                //If the value is somehow invalid, set it to the min
                $qtyInput.val(min);
                this._fireQtyChangeEvent(min);
            } else {
                //Add the offset and if it it below the minimum, set to min
                currentVal += offset;
                if(currentVal < min) {
                    currentVal = min;
                }
                //Update the number input with the new quantity
                $qtyInput.val(currentVal);
                this._fireQtyChangeEvent($qtyInput.mySection(), currentVal);
            }
        },
        _removeItem: function($qtyInput) {
          $qtyInput.val(0);
          this._fireQtyChangeEvent($qtyInput.mySection(), 0);
        },
        /*
            =function _determineAllSelectorFromStr(str)
            If we need to select ALL of a selector, and if it is an ID selector,
            we cannot simply pass it in as jQuery will return only the first
            object found. This function will alter the selector to return
            all elements with the same ID. If it is not an ID, it returns str
            =Params
            (string) str: The selector to check
        */
        _determineAllSelectorFromStr: function(str) {
            if(str[0] == '#') {
                return '[id="' + str.substring(1) + '"]';
            } else {
                return str;
            }
        },
        /*
            =function _performOnQtyControls($container, func)
            Will find the 3 quantity controls within the container and
            then pass them into the passed in function "func"
            =Params
            (jQuery) $container: The container that has the quantity controls
            (function) func: The function to pass the controls into
        */
        _performOnQtyControls: function($container, func) {
            func($container.find(this._selectors.qtyMinus));
            func($container.find(this._selectors.qtyField))
            func($container.find(this._selectors.qtyPlus))
        },
        /*
            =function _getBaseVariantObj($selection)
            Creates and returns an object containing the base information on
            the passed in selection. Object is used in variant change events
            =Params
            (jQuery) $selection: The selected variant
        */
        _getBaseVariantObj: function ($selection) {
            return {
                available: !$selection.data('unavailable'),
                compareAtPrice: $selection.data('compare-price'),
                id: $selection.val(),
                imageId: $selection.data('img-id'),
                price: $selection.data('base-price'),
                sku: $selection.data('sku'),
                title: $selection.data('title'),
                inventoryQuantity: $selection.data('inventory-quantity')
            };
        },
        /*
            =function _fireChangeEvent($container, variantObj)
            Fires the custom event on the element's section for variant select change.
            =Params
            (jQuery) $container: The container to trigger the event on
            (obj) variantObj: Object containing the selected variant's data to
                              be passed to the event
        */
        _fireChangeEvent: function ($container, variantObj) {
            $container.trigger(this.eventStrs.onVariantChanged, [variantObj]);
        },
        /*
            =function _fireQtyChangeEvent(newQty)
            Fires the custom event on the element's section for quantity change.
            =Params
            (jQuery) $container:  The container to trigger the event on
            (int) newQty: The new quantity
        */
        _fireQtyChangeEvent: function ($container, newQty) {
            $container.trigger(this.eventStrs.onQtyChanged, [newQty]);
        }
    };
}());


theme.Filters = (function () {
    var constants = {
        SORT_BY: 'sort_by'
    };
    var selectors = {
        filterSelection: '.coll-filter',
        sortSelection: '#SortBy',
        defaultSort: '#default-sort-by'
    };

    function Filters(container) {
        var $container = this.$container = $(container);

        Shopify.queryParams = {};
        if (location.search.length) {
            var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&');
            for (; i < aCouples.length; i++) {
              aKeyValue = aCouples[i].split('=');
              if (aKeyValue.length > 1) {
                Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
              }
            }
        }
        this.$filterSelect = $(selectors.filterSelection, $container);
        this.$sortSelect = $(selectors.sortSelection, $container);

        this.$filterSelect.on('change', this._onFilterChange.bind(this));
        this.$sortSelect.on('change', this._onSortChange);
    }

    Filters.prototype = {
        _onSortChange: function (evt) {
            Shopify.queryParams.sort_by = jQuery(this).val();
            location.search = jQuery.param(Shopify.queryParams);
        },
        _onFilterChange: function (evt) {
            var newTags = [];
            this.$filterSelect.each(function() {
                if (jQuery(this).val()) {
                    newTags.push(jQuery(this).val());
                }
            });
            var query = newTags.join('+');
            window.location.href = '/collections/' + this.$filterSelect.data('handle') + '/' + query;
        }
    };

    return Filters;
})();


/*
theme.Site

Initializes and provides site-wide functionality.
*/
theme.Site = (function () {
return {
    /***** Public Methods *****/
    /*
        =function init()
        Initializes all site-wide functionality.
    */
    init: function () {
        this._initScrollFixed();
        this._initPlugins();
        this._extendjQuery();
        this.Newsletter.init();
    },
    
    /***** Private Methods *****/
    /*
        =function _initPlugins()
        Initializes the plugins used site-wide.
    */
    _initPlugins: function() {
        //Headroom init
        $('#header').headroom({tolerance: {up: 70, down: 0}});
        //Owl Carousel init
        // $('.owl-carousel').owlCarousel();
        if(navigator.appVersion.indexOf("MSIE 9.") === -1) {
            //Scroll Reveal init
            window.sr = ScrollReveal();
            sr.reveal('.home-reveal');
        }
    },
    /*
        =function _initScrollFixed()
        Initializes scrolling fix.
    */
    _initScrollFixed: function() {
        var scrollFixedSelector = '.scroll_fixed';
        if ($(scrollFixedSelector).offset()) {
            var leftInit = $(scrollFixedSelector).offset().left,
                top = $(scrollFixedSelector).offset().top - parseFloat($(scrollFixedSelector).css('margin-top').replace(/auto/, 0));

            $(window).scroll(function (event) {
                var x = 0 - $(this).scrollLeft();
                var y = $(this).scrollTop();

                // whether that's below the form
                if (y >= top) {
                    // if so, ad the fixed class
                    $(scrollFixedSelector).addClass('fixed');
                } else {
                    // otherwise remove it
                    $(scrollFixedSelector).removeClass('fixed');
                }

                $(this.selectors.scrollFixed).offset({
                    left: x + leftInit
                });
            });
        }
    },
    /*
        =function _extendjQuery()
        Extends the jQuery object with custom functions to
        give additional functionality.
    */
    _extendjQuery: function () {
        $.fn.extend({
            /* 
                =function mySection()
                Returns the section's container that the calling element
                is in.
            */
            mySection: function () {
                return this.closest('[data-section-id]');
            },
            /* 
                =function animateCss(animationName, callBack)
                Convenience function for adding animate.css animations. Will
                cause the passed in animation to start on the calling element.
                =Params
                    (string) animationName: The animation to start
                    (function) onEndCallback: (optional) The function to call when
                                              the animation is over
            */
            animateCss: function (animationName, onEndCallback) {
                var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
                this.addClass('animated ' + animationName).one(animationEnd, function () {
                    $(this).removeClass('animated ' + animationName);
                    if ($.isFunction(onEndCallback)) {
                        onEndCallback.apply(this);
                    }
                });
            }
        });
    },

    /*
        theme.Site.Newsletter
        
        Controls the display of the newsletter modal
        and also controls the cookie used to prompt
        the user for signing up for the newsletter.
    */
    Newsletter: {
        /***** Private Properties *****/
        //Selectors used for jQuery targeting of the modals
        _modalSelectors: {
            container: '.tbm_modal-container',
            rightCol: '.tbm_modal-right-col',
            leftCol: '.tbm_modal-left-col',
            closeClickables: '.tbm_modal-close, .tbm_modal-clickable'
        },
        //Cookie indentifier
        _loftModalNewsletterCookie: '__loft_modal-newsletter-cookie',
        _bodyClickHandler: null,
        /***** Public Methods *****/
        /*
            =function init()
            Determines whether to display the modal based on the user's
            cookies for the site's newsletter. Also initializes the
            sizing and click events events. Will open the modal if
            needed.
        */
        init: function () {
        var self = this;
            //Set up the cookies
            if (cookieExpires == '-1') {
                Cookies.remove(self._loftModalNewsletterCookie, {
                    path: ''
                });
            }
            // set cookie, show popup
            if (Cookies.get(self._loftModalNewsletterCookie) != '-1') {
                setTimeout(function () {
                    self._resize();
                    $(self._modalSelectors.container).fadeIn(600);
                    self._resize();

                }, cookieModalDelay);
                Cookies.set(self._loftModalNewsletterCookie, '-1', {
                    expires: cookieExpireSet
                });
                _bodyClickHandler = function(e) {
                    if($(e.target).closest(self._modalSelectors.container).length > 0) {
                        self._closeModal();
                    }
                };
                $('body').click();
            }
            //Resize to fit the current screen
            self._resize();
            //Setup events
            $(self._modalSelectors.closeClickables).click(function () {
                self._closeModal();
                $('body').off('click', self._bodyClickHandler);
            });
            $(window).resize(function () {
                self._resize();
            });
        },
        
        /***** Private Methods *****/
        /*
            =function _resize()
            Resizes the modal.
        */
        _resize: function () {
            $(this._modalSelectors.leftCol).height($(this._modalSelectors.rightCol).height());
        },
        /*
            =function _closeModal()
            Closes the modal with a fadout effect.
        */
        _closeModal: function () {
            $(this._modalSelectors.container).fadeOut(400);
        }
    }
};
}());

$(function () {
  theme.Site.init();
  $('.quick-desc .short-description').trunk8({
    lines: 5,
    fill: '&hellip;',
    parseHTML: 'true',
    width:'auto'
  });
  $('.collection-ad-text.rte').trunk8({
    lines: 4,
    fill: '&hellip;',
    parseHTML: 'true',
    width:'auto'
  });
  initFancyBox();
  
});

function initFancyBox() {
  Fancybox.bind("[data-fancybox]", {
    Image: {
      zoom: false,
    },
    Panzoom: {
      maxScale: 2,
    },
  
    on: {
      reveal: function( instance, current ) {
        var $container = $('#quick.fancybox__content');
        var smartEnable = $('#quick').data('quicksmart');

        theme.Products.init($container);
        if(($container.closest('[data-section-id="product-template"]').length > 0) || 
           ($container.closest('[data-section-id="product-group"]').length > 0) ||
           ($container.closest('.sb_header_wrapper').length > 0)) {
          theme.Slick.initProdPhotoQuick($container);
          theme.Variants.init($container, true);
          theme.ProductPage.init($container);
          $('.fancybox-container .product-smart-wrapper').remove();
          if(smartEnable) {
            $('.fancybox-container .quick-smart-wrapper').css('display','block');
            Shopify.PaymentButton.init();
          } else {
            $('.fancybox-container .shopify-payment-button').css('display','none');
            $('.fancybox-container .quick-smart-wrapper').css('display','block');
          }
        } else {
          theme.Slick.initFeaturedCollection($container);
          theme.Variants.init($container);
        }
  
        $('.fancybox-container .product-featured-image img').off('click')
        $('.fancybox-container .product-featured-image img').removeData('magnificPopup');
        $('.fancybox-container #tabs,.fancybox-container ul.tabs').css('display','none');
        $('.fancybox-container .act-desc').css('display','none');
        $('.fancybox-container .act-desc').removeClass('large--show');
        $('.fancybox-container .quick-desc').show();
        $('.fancybox-container .quick-desc .short-description').trunk8({
          lines: 8,
          fill: '&hellip;',
          parseHTML: 'true',
          width:'auto'
        });
      },
      destroy: function () {
        $('.fancybox-container .act-desc').addClass('large--show');      
        $('.fancybox-container .quick-desc').hide();
      }
    }
  });
}

// Get IE or Edge browser version
var version = detectIE();

/**
 * detect IE
 * returns version of IE or false, if browser is not Internet Explorer
 */
function detectIE() {
  var ua = window.navigator.userAgent;

  // Test values; Uncomment to check result …

  // IE 10
  // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
  
  // IE 11
  // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
  
  // Edge 12 (Spartan)
  // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
  
  // Edge 13
  // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

  var msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  var trident = ua.indexOf('Trident/');
  if (trident > 0) {
    // IE 11 => return version number
    var rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  var edge = ua.indexOf('Edge/');
  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
  }

  // other browser
  return false;
}


  /* IE EDGE Object Fit fallback */
//  $(function(){ 
//       if ( !Modernizr.objectfit && version != false ) {
//         $('.masonryh div.masonry-collection-target, .collection-box-2, .collection-box-1, .page-list-collection-featured .content-class, .page-list-collection .content-class').each(function () {
//           var $container = $(this),            
//               imgUrl = $container.find('img').prop('src');
//           if (imgUrl) {
//             $container
//             .css('backgroundImage', 'url(' + imgUrl + ')')
//             .addClass('compat-object-fit');
//           }  
//         });
//       }       
//     });

/*
    theme.Tabs
    Controls the behavior of tabs. Switches the active
    content with a fade transition.
*/
theme.Tabs = (function () {
    return {
        /***** Private Properties *****/
        //Selectors used for jQuery targeting
        _selectors: {
            tabsContainer: '.js-tabs-container',
            tabLinks: '.js-tabs-link',
            tabContentsContainer: '.js-tabs-content-container',
            tabHeight: '.checkMyHeight',
            activeTab: '.active',
            activeContent: '.current'
        },
        //Classes used to be added/removed/checked against
        _classes: {
            checkHeight: 'checkMyHeight',
            activeTab: 'active',
            activeContent: 'current'
        },
        /*
            =function init(container)
            Initializes the click events for the tabs, which controls the fade
            animation. Also sets up the window resize event to resize the content
            =Params
            (mixed) container: Value can be a jQuery selector string, jQuery
                                object, or element. The value should return the
                                container of the cart.
        */
        init: function (container) {
            var self = this;
            var tabSpeed = 200;
            var $container = $(container);
            var $tabsContainer = $container.find(self._selectors.tabsContainer);
            var $tabCotentsContainer = $container.find(self._selectors.tabContentsContainer);
            var $tabLinks = $tabsContainer.find(self._selectors.tabLinks);
            //Set up the tab clicks
            $tabLinks.click(function (e) {
              
              
            
                var $this = $(this);
                //Get the currently active tab
                var $activeTab = $tabsContainer.find(self._selectors.activeTab);
                //Get the tab contents and their IDs
                var activeContentTab = '.js-tab-' + $activeTab.data('tab');
                var newContentTab = '.js-tab-' + $this.data('tab');
              
                //console.log(newContentTab);
              
                
                //Only switch the tabs if they aren't the same tabs
                if (activeContentTab !== newContentTab) {
                    var $activeContent = $tabCotentsContainer.find(self._selectors.activeContent);
                    
                    //console.log($activeContent);
                  
                    var $newContent = $tabCotentsContainer.find(newContentTab);
                    //Switch the active tab link
                    $activeTab.removeClass(self._classes.activeTab);
                    $this.addClass(self._classes.activeTab);
                    //Set up the content height class
                    $newContent.addClass(self._classes.checkHeight);
                    $activeContent.removeClass(self._classes.checkHeight);
                    //Resize to fit the new content
                    self._resize($tabCotentsContainer);
                    //Perform the fade transition
                    $activeContent.fadeOut(tabSpeed, function () {
                        $activeContent.removeClass(self._classes.activeContent);
                        $newContent.fadeIn(tabSpeed, function () {
                            $newContent.addClass(self._classes.activeContent);
                            //Resize to fit the new content
                            self._resize($tabCotentsContainer);
                        });
                    });
                }
                return false;
            });
            //Set up the resize event
            $(window).resize(self._resize.bind(this, $tabCotentsContainer));
        },
        _resize: function ($tabCotentsContainer) {
            $tabCotentsContainer.height($tabCotentsContainer.find(this._selectors.tabHeight).outerHeight());
        }
    };
}());
theme.Maps = (function() {
  var apiStatus = null;
  var mapsToLoad = [];

  var errors = {
    addressNoResults: 'No results for that address',
    addressQueryLimit: 'You have exceeded the Google API usage limit. Consider upgrading to a <a href=\"https:\/\/developers.google.com\/maps\/premium\/usage-limits\">Premium Plan<\/a>.',
    addressError: '"Error looking up that address',
    authError: 'There was a problem authenticating your Google Maps account.'
  };

  var selectors = {
    section: '[data-section-type="map"]',
    map: '[data-map]',
    mapOverlay: '[data-map-overlay]',
    mapType: '[data-type]'
  };

  var classes = {
    mapError: 'map-section--load-error',
    errorMsg: 'map-section__error errors text-center'
  };

  // Global function called by Google on auth errors.
  // Show an auto error message on all map instances.
  // eslint-disable-next-line camelcase, no-unused-vars
  window.gm_authFailure = function() {
    if (!Shopify.designMode) {
      return;
    }

    $(selectors.section).addClass(classes.mapError);
    $(selectors.map).remove();
    $(selectors.mapOverlay).after(
      '<div class="' +
        classes.errorMsg +
        '">' +
        theme.strings.authError +
        '</div>'
    );
  };

  function Map(container) {
    this.$container = $(container);
    this.$type = this.$container.find(selectors.mapType);
    this.$map = this.$container.find(selectors.map);
    this.key = this.$map.data('api-key');

    if (typeof this.key === 'undefined') {
      return;
    }

    if (apiStatus === 'loaded') {
      this.createMap();
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== 'loading') {
        apiStatus = 'loading';
        if (typeof window.google === 'undefined') {
          $.getScript(
            'https://maps.googleapis.com/maps/api/js?key=' + this.key
          ).then(function() {
            apiStatus = 'loaded';
            initAllMaps();
          });
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function(index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({ address: address }, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = {
    createMap: function() {
      var $map = this.$map,
          $type = this.$type;
      return geolocate($map)
        .then(
          function(results) {
            var mapOptions = {
              zoom: $map.data('zoom'),
              center: results[0].geometry.location,
              draggable: false,
              clickableIcons: false,
              scrollwheel: false,
              disableDoubleClickZoom: true,
              disableDefaultUI: true,
              mapTypeId: $map.data('type')
            };

            var map = (this.map = new google.maps.Map($map[0], mapOptions));
            var center = (this.center = map.getCenter());

            //eslint-disable-next-line no-unused-vars
            var marker = new google.maps.Marker({
              map: map,
              position: map.getCenter()
            });
            google.maps.event.addDomListener(
              window,
              'resize',
                (function() {
                google.maps.event.trigger(map, 'resize');
                map.setCenter(center);
                $map.removeAttr('style');
              })
            );
    
          
          }.bind(this)
        )
        .fail(function() {
          var errorMessage;

          switch (status) {
            case 'ZERO_RESULTS':
              errorMessage = errors.addressNoResults;
              break;
            case 'OVER_QUERY_LIMIT':
              errorMessage = errors.addressQueryLimit;
              break;
            case 'REQUEST_DENIED':
              errorMessage = errors.authError;
              break;
            default:
              errorMessage = errors.addressError;
              break;
          }

          // Show errors only to merchant in the editor.
          if (Shopify.designMode) {
            $map
              .parent()
              .addClass(classes.mapError)
              .html(
                '<div class="' +
                  classes.errorMsg +
                  '">' +
                  errorMessage +
                  '</div>'
              );
          }
        });
    },

    onUnload: function() {
      if (this.$map.length === 0) {
        return;
      }
      google.maps.event.clearListeners(this.map, 'resize');
    }
  };

  return Map;
})();


/*
    theme.Products
    
    Adjusts the shown image and price to reflect the currently
    selected variant. Also adjusts items based on avaiability.
    
    Depends on:
    theme.Currency
    theme.Slick
    theme.Variants
    
    Related directly to:
    /sections/home-featured-products.liquid
    /sections/product-template.liquid
    /snippets/jim-form.liquid
    /snippets/product-details.liquid
    /snippets/tbm-icons.liquid
    
*/
theme.Products = (function () {
    return {
        /***** Private Properties *****/
        //Selectors used for jQuery targeting
        _selectors: {
            soldOutBtnText: '.js-prod-soldout-btn-text',
            productSlides: '.simple_product .sb_header_slider',
            smart: '.smart-wrapper',
            comparePrice: '#ComparePrice',
            disableOnSoldOut: '.js-prod-disable-on-soldout',
            priceDisplays: '.js-prod-price',
            showAvailable: '.js-prod-show-available', // Elements to .show() when variant is available
            showSoldOut: '.js-prod-show-soldout', // Elements to .show() when variant is sold out
            showOnSale: '.js-prod-show-sale', // Elements to .show() when variant is on sale
            badge: '.js-prod-badge',
            quantityInfoContainer: '.remaining_stock_info',
            quantityInfo: '.remaining_stock_info .quantity'
        },
        
        /***** Public Methods *****/
        /*
            =function init(container)
            Initializes the listeners for product sections that contain an
            image, price, and cart button to update on variant related changes.
            =Params
            (mixed) container: Value can be a jQuery selector string, jQuery
                                object, or element. The value should return the
                                container that has the elements that need to be 
                                adjusted on variant changes
        */
        init: function(container) {
            var self = this;
            var $container = $(container);
            //Setup magnify popup
            // $container.find('.product-featured-image img').magnificPopup({
            //    type: 'image',
            //     mainClass: 'mfp-fade',
            //     closeOnBgClick: true,
            //     closeBtnInside: false,
            //     closeOnContentClick: true,
            //     tLoading: '',
            //     removalDelay: 200
            // });

            var atc_btn = $container.find('.add-to-cart-btn');
            var first_selected_variant_imgId;
            $(atc_btn).each(function() {
              first_selected_variant_imgId = $(this).data('variant-img-id');
              if (first_selected_variant_imgId) {
                setTimeout(function() {
                  moveSliderToSelectedImage(first_selected_variant_imgId);
                }, 5);
              }
            });
            //Set up the listener for when a new variant is selected
            $container.on(theme.Variants.eventStrs.onVariantChanged, function(e, variant) {
                if(variant) {
                    self._changeImage($container, variant);
                    self._changePrice($container, variant);
                    self._toggleVariantInfoMsg(variant);
                    self._getVariantName(variant);
                    self._updateAvailability($container, variant.available, '', variant.inventoryQuantity);
                    moveSliderToSelectedImage(variant.imageId);
                    if (window.has_b2b_customer && window.has_b2b_discount > 0) {
                      noahB2BPrice(variant);
                    }
                    $('.shopify-payment-button').show();
                    $('#ProductCurrentVariant').html( variant.id );
                } else {
                    $('.shopify-payment-button').hide();
                    self._changePrice($container, null);
                    self._updateAvailability($container, false, 'Unavailable');
                }
                self._updateHistoryState(variant);
            });
            //Set up the listener for when a new quantity is entered
            $container.on(theme.Variants.eventStrs.onQtyChanged, function(e, newQuantity) {
                var $selection = theme.Variants.getSelectedVariant($container);
                self._updatePrice($container, $selection.data('base-price'), $selection.data('compare-price'), newQuantity);
            });
        },
        
        /***** Private Methods *****/
        /*
            =function _changeImage($container, variant)
            Tells Slick to go to the correct image based on the passed in variant
            =Params
            (jQuery) $container: The container that has the Slick element to adjust
            (obj) variant: The variant object that has the image id to look for
        */
        _toggleVariantInfoMsg: function (variant) {
          $('.variant-msg .msg').css('display', 'none');
          if ($('.variant-msg .msg#variant_info_' + variant.id).text().trim() != '') {
            $('.variant-msg .msg#variant_info_' + variant.id).css('display','block');
          }
        },
        _getVariantName: function (variant) {
          if(variant) {
            var option_list;
            if (variant.options) {
              options = (variant.options).split(' / ');
              option_list = [options[0],options[1],options[2]];
            } else {
              titles = (variant.title).split(' / ');
              option_list = [titles[0],titles[1],titles[2]];
            }
            $('.variant-group .product_option_variant').each( function(index) {
              $(this).text(option_list[index])
            });
          }
        },
        _changeImage: function ($container, variant) {
            var $prod_slider = $container.find(this._selectors.productSlides);
            var newPosition = $prod_slider.find('img[data-image-id="' + variant.imageId + '"]').parent().attr('data-slick-index');
            if (newPosition !== undefined) {
                var currPos = $prod_slider.slick('slickCurrentSlide');
                if(currPos != newPosition) {
                    $prod_slider.slick('slickGoTo', newPosition);
                }
            }
        },
        /***** Private Methods *****/
        /*
            =function init($container, variant)
            Looks for the price related elements and shows/hides them based on
            the passed in variant
            =Params
            (jQuery) $container: The container that has the price elements to adjust
            (obj) variant: The variant object that has the image id to look for
        */
        _changePrice: function ($container, variant) {
            if(variant) {
                var price = variant.price;
                var compareAtPrice = variant.compareAtPrice;
                if (compareAtPrice && compareAtPrice > price) {
                    $container.find(this._selectors.showOnSale).show();
                    var $comparePrice = $container.find(this._selectors.comparePrice);
                    if ($comparePrice.length > 0) {
                        $comparePrice.show();
                    }
                } else {
                    $container.find(this._selectors.showOnSale + ', ' + this._selectors.comparePrice).hide();
                }
                this._updatePrice($container, price, compareAtPrice);
            } else {
                // The variant given doesn't exist, so tell the code to update the
                // price with some text to reflect this
                this._updatePrice($container, null);
            }
        },
        /*
            =function _updatePrice($container, price, compareAtPrice, qty)
            Looks for the price related elements and shows/hides them based on
            the passed in variant
            =Params
            (jQuery) $container: The container that has the price elements to adjust
            (int) price: The price of the variant in cents
            (int) compareAtPrice: (optional) The variant's compare at price in cents
            (int) qty: (optional) The current variant's quantity in the form
        */
        _updatePrice: function($container, price, compareAtPrice, qty) {
            //The variant exists (and thus price), so update the price correctly
            if(price !== undefined && price !== null) {
              variant_price = price;
              compare_at_price = compareAtPrice;
              var popup_product = $('.fancybox__container .product-template__container.page-width').data('mega-sale');
              if (window.on_mega_sale || popup_product) {
                if (compare_at_price > 0 ) {
                  variant_original_price = compare_at_price;
                } else {
                  variant_original_price = variant_price;
                }
                saved_percentage_value = (variant_price * window.mega_sale_percentage) / 100.0;
                variant_price = variant_price - saved_percentage_value;
                var compare_saved_percentage_value = variant_original_price - variant_price;
                var sale_percentage = window.mega_sale_percentage * 100;
                var less_discount_value = Math.round(((compare_saved_percentage_value / variant_original_price) * 100).toFixed(2));
                if (compare_saved_percentage_value < sale_percentage) {
                  $('.sb_header_slider_container .tag-sale').text(less_discount_value + '% OFF');
                } else {
                  $('.sb_header_slider_container .tag-sale').text(theme.Currency.formatMoney(compare_saved_percentage_value) + ' OFF');
                }
                $(".mega-sale-container .sale-price").html(
                  theme.Currency.formatMoney(variant_price)
                );
                $(".mega-sale-container .original-price-value").html(
                  "was&nbsp;&nbsp;".concat(`<span class="strike-through">${theme.Currency.formatMoney(variant_original_price)}</span>`)
                );
              } else {
                if (compare_at_price > variant_price) {
                  $(".mega-sale-container").addClass('show-compare-price');
                  $(".mega-sale-container .sale-price").html(
                    theme.Currency.formatMoney(variant_price)
                  );
                  $(".mega-sale-container .original-price-value").html(
                    "was&nbsp;&nbsp;".concat(`<span class="strike-through">${theme.Currency.formatMoney(compare_at_price)}</span>`)
                  );
                } else {
                  $(".mega-sale-container").removeClass('show-compare-price');
                }
              }

                //If qty wasn't passed in, get the quantity from the form
                qty = qty || theme.Variants.getVariantQuantity($container);
                var priceNum = (variant_price * qty)/100;
                variant_price = theme.Currency.formatMoney(variant_price * qty);
                //Adjust each price display with the new formatted price
                $container.find(this._selectors.priceDisplays).each(function () {
                    var $this = $(this);
                    $this.text(variant_price);
                    $this.attr('content', variant_price);
                    $this.attr('data-price', priceNum);
                });
                // If there is a compareAtPrice, adjust each price display with the 
                // formatted compare at price
                if(compareAtPrice) {
                    var $comparePrice = $container.find(this._selectors.comparePrice);
                    $comparePrice.text($comparePrice.data('compare-text') + ' ' + theme.Currency.formatMoney(compareAtPrice * qty));
                }
            } else {
                //The variant doesn't exist, so update the price to say so
                $container.find(this._selectors.comparePrice + ',' + 
                    this._selectors.showOnSale + ',' +
                    this._selectors.showSoldOut).hide();
                $container.find(this._selectors.priceDisplays).text('Unavailable');
                $('.variant-msg .msg').hide();
                $('.variant-msg .msg.not-found').show();
            }
        },
        /*
            =function _updateAvailability($container, inStock, soldOutBtnText)
            Adjusts buttons and shows/hides elements based on if the variant is in
            stock
            =Params
            (jQuery) $container: The container that has the elements to adjust
            (bool) inStock: true if the product is in stock; false otherwise
            (string) soldOutBtnText: (optional) The text to display if the variant doesn't
                                      exist. Also used to check if the variable doesn't exist.
        */
        _updateAvailability: function ($container, inStock, soldOutBtnText, inventoryQuantity) {
          var $showSoldOut = $container.find(this._selectors.showSoldOut);
          var $showAvailable = $container.find(this._selectors.showAvailable);
          var $smart = $container.find(this._selectors.smart);
          var btn_cart_text = "Add to Basket";
          if (inStock) {
            $smart.show();
            // $showSoldOut.hide();
            $showAvailable.prop('disabled', false);
            $showAvailable.removeClass("oos-variant");
            $showAvailable.find('.cart-normal').text(btn_cart_text).removeClass('warning_c');
            $container.find(this._selectors.disableOnSoldOut).prop('disabled', false);
            $showAvailable.siblings('.price_block_current').removeClass('oos-alert');
          } else {
            var $soldOutBadge = $container.find(this._selectors.showSoldOut + ' ' + this._selectors.badge);
            if(soldOutBtnText) {
              $showSoldOut = $showSoldOut.not(this._selectors.badge);
            } else {
              soldOutBtnText = 'Sold Out';
            }
            $container.find(this._selectors.soldOutBtnText).text(soldOutBtnText);
            // $showSoldOut.show();
            $smart.hide();
            $showAvailable.addClass("oos-variant");
            $showAvailable.prop('disabled', false);
            $showAvailable.find('.cart-normal').text('Out of Stock- Notify Me').addClass('warning_c');
            $showAvailable.siblings('.price_block_current').addClass('oos-alert');
            $container.find(this._selectors.showOnSale).hide();
            $container.find(this._selectors.disableOnSoldOut).prop('disabled', true);
          }

          if (inventoryQuantity > 0 && inventoryQuantity < 20) {
            $(this._selectors.quantityInfoContainer).css('display', 'flex');
            $(this._selectors.quantityInfo).html(inventoryQuantity);
          } else {
            $(this._selectors.quantityInfoContainer).hide();
          }
        },
        _updateHistoryState: function (variant) {
          if (!history.replaceState || !variant || window.location.href.indexOf('collections/addons') > -1) {
            return;
          }
    
          var newurl =
            window.location.protocol +
            '//' +
            window.location.host +
            window.location.pathname +
            '?variant=' +
            variant.id;
          window.history.replaceState({ path: newurl }, '', newurl);
        }
    };
}());


/*
    theme.ProductPage
    
    Specificly for the product page. Handles the adding of
    the product to the cart, the display of the cart
    related effects, and updates the cart count on a 
    successful add to cart.
    
    Depends on:
    theme.AjaxCart
    theme.Cart
    theme.Tabs
    theme.Variants
    
    Related to:
    /sections/product-template.liquid
*/
theme.ProductPage = (function () {
    return {
        /***** Private Properties *****/
        //Selectors used for jQuery targeting
        _selectors: {
            addToCartBtn: '.add-to-cart-btn',
            mobileAddToCartBtn: '.mobile-add-to-cart-btn',
            prodAjaxBtn: '.js-prod-ajax-btn',
            prodFormBtn: '.js-prod-form-btn',
            cartErrors: '.cart-errors'
        },
        //Classes used to be added/removed/checked against
        _classes: {
            cartExtraPad: 'cart-extra-pad',
            cartErr: 'added-to-cart-error',
            cartSuccess: 'added-to-cart-success',
            mobileSuccess: 'mobile-success',
            mobileErr:'mobile-error',
            starterKitBtn: 'starter-kit-atc-btn'
        },
        
        /***** Public Methods *****/
        /*
            =function init()
            Initializes the the ajax cart events and the click event
            for the addd to cart button
        */
        init: function(container) {
          $('.quick-smart-wrapper').css('display','none');
            var self = this;
            //Reset the event, just in case it was already set
            $('body').off(theme.AjaxCart.eventStrs.addToCartSuccess);
            $('body').off(theme.AjaxCart.eventStrs.addToCartError);

            //Set up ajax cart event
            $('body').on(theme.AjaxCart.eventStrs.addToCartSuccess, function (e, item) {
                if (window.location.href.indexOf('/cart') > -1) {
                  window.location.reload();
                } else {
                  self._displayCartSuccess(item);
                  self._updateCartData(item);
                  // theme.Cart.updateLeadTime();

                  // Height transition workaround
                  $(".cart-items").css("min-height", "inherit");
                  $(".cart-items").css("min-height", $(".cart-items").height());
                }
            });
            $('body').on(theme.AjaxCart.eventStrs.addToCartError, function () {
                self._displayCartError('There was a problem adding the product to the cart. Make sure your selection is correct and try again.');
            });
            //Setup click event for the add to cart button
            // Deduplicate any previous handlers to prevent double add.js calls
            $(self._selectors.prodAjaxBtn, container).off('click');
            $(self._selectors.prodAjaxBtn, container).on('click', function (event) {
              event.preventDefault();
              event.stopPropagation();
              if ($(this).data('processing')) {
                return false;
              }
              $(this).data('processing', true).prop('disabled', true);
              var elm = event.currentTarget;
              var hasBeddingOpened = true;
             
              $(elm).parents().each( (index,element) => {
                if ($(element).attr('class').indexOf('fancybox__container') > -1 ) {
                  hasBeddingOpened = false;
                }
              });

              if ($('.bedding-styles.bedding-choose-styles:not(.selected)').length > 0 && hasBeddingOpened) {
                // Re-enable button before opening bedding popup
                $(this).data('processing', false).prop('disabled', false);
                $('.bedding-styles.bedding-choose-styles').trigger('click');
                return false;
              }

              if ($(this).hasClass('oos-variant')) {
                // Re-enable button
                $(this).data('processing', false).prop('disabled', false);
                $(this).find('.cart-in-progress').css('display', 'none');
                $(this).find('.cart-normal').show();
                // Trigger Klaviyo back in stock if available
                var $klaviyoBtn = $('.secondary_button.klaviyo-bis-trigger');
                if ($klaviyoBtn.length > 0 && $klaviyoBtn[0]) {
                  $klaviyoBtn[0].click();
                }
                return false;
              }

              $(this).find('.cart-normal').hide();
              $(this).find('.cart-in-progress').css('display', 'flex');

              if ($(this).hasClass(self._classes.starterKitBtn)) {
                self._addStarterKitToCart.apply(this, container);
              } else {
                self._addProductToCart.apply(this, container);
              }
            });

            // Not sure why this function was here, it is adding the product without it too (Key press enter)
            // $(self._selectors.prodAjaxBtn, container).keypress(function (e) {
            //     if(e.which == 13) {
            //         self._addProductToCart.apply(this, container);
            //     }
            // });
          
            theme.Tabs.init(container);
        },
        /***** Private Methods *****/
        /*
            =function _addProductToCart()
            Adds the selected product to the cart, or displays an error 
            if the selection isn't valid
            (object) container: the product page section
        */
        _addProductToCart: function(container) {
            var $form = $(this).closest('form');
            var $selection = theme.Variants.getSelectedVariant($form);
            //Make sure we actually have a selection
            if ($selection.length > 0) {
                if ($selection.data('unavailable')) {
                    //Display an error if the product is actually unavailable
                    self._displayCartError('The selected product is not available.');
                } else {
                    //Gather the line properties, if needed
                    var props = {};
                    var $properties = $('[name^="properties["]', container);
                    if($properties.length > 0) {
                        var $this;
                        var nameAttr = '';
                        $properties.each(function() {
                            $this = $(this);
                            nameAttr = $this.attr('name');
                            nameAttr = nameAttr.replace('properties[','');
                            nameAttr = nameAttr.replace(']','');
                            if($this.attr('type') === 'radio') {
                                if($this.is(':checked')) {
                                    props[nameAttr] = $this.val();
                                }
                            } else if($this.attr('type') === 'checkbox') {
                                if($this.is(':checked')) {
                                    if(props[nameAttr]) {
                                        if($('[type="hidden"][name="properties[' + nameAttr +']"]', container).length === 1) {
                                            //If there is a hidden element of the same name, and it's the only other
                                            //element with the same name, then the hidden element is likely a default 
                                            //value. We'll override it with the checkbox value.
                                            props[nameAttr] = $this.val();
                                        } else {
                                            props[nameAttr] += ', ' + $this.val();
                                        }
                                    } else {
                                        props[nameAttr] = $this.val();
                                    }
                                }
                            } else {
                                props[nameAttr] = $this.val();
                            }
                        });
                    }
                    //Add the selected variant to the cart
                    theme.AjaxCart.addToCart($selection.val(), theme.Variants.getVariantQuantity($form), props);
                }
            } else {
                self._displayCartError('There was no product selected.');
            }
        },
        _addStarterKitToCart: function(container) {
          var self = theme.ProductPage;
          var $button = $(this);
          
          // Check if variant selection functions are available
          if (window.with_bedding && typeof window.getSelectedVariantOld !== 'function') {
            $button.data('processing', false).prop('disabled', false);
            $button.find('.cart-in-progress').css('display', 'none');
            $button.find('.cart-normal').show();
            self._displayCartError('Please wait while product options are loading...');
            return;
          }
          
          if (!window.with_bedding && typeof window.getSelectedVariant !== 'function') {
            $button.data('processing', false).prop('disabled', false);
            $button.find('.cart-in-progress').css('display', 'none');
            $button.find('.cart-normal').show();
            self._displayCartError('Please wait while product options are loading...');
            return;
          }
          
          if (window.with_bedding) { // TODO: need to change this condition here
            var variant = window.getSelectedVariantOld();
          } else {
            var variant = window.getSelectedVariant();
          }
          if (!variant) {
            // Restore button state
            $button.data('processing', false).prop('disabled', false);
            $button.find('.cart-in-progress').css('display', 'none');
            $button.find('.cart-normal').show();
            // Show error message
            self._displayCartError('Please select all required options before adding to cart.');
            return;
          }

          variantId = variant.id;
          theme.AjaxCart.addToCart(variantId, 1)
        },
        /*
            =function _updateCartData()
            Update the cart data, for example add item
        */
        _updateCartData: function(item) {
          if ($(theme.Cart._selectors.cartPopup).length > 0) {
            var old_line_item = $( theme.Cart._selectors.cartItem + "[data-id='" + item.id + "']");

            if (old_line_item.length > 0) {
              old_line_item.remove();
            }
            
            $(theme.Cart._selectors.cartItemsContainer).append(theme.Cart.getCartPopupItemHTML(item));
            theme.Cart._updateCartValues();
            if ($('.fancybox-container.fancybox-is-open').length > 0) {
              $('.fancybox-container.fancybox-is-open .fancybox-close-small').trigger('click');
            }

            var new_line_item = $( theme.Cart._selectors.cartItem + "[data-id='" + item.id + "']");
            theme.Variants.initQtyControls(new_line_item);
            theme.Cart.updateExtras();
            theme.Cart.showCartPopup(item);
          }
        },
        /*
            =function _displayCartSuccess()
            Sets up the success effect for the add to cart button
        */
        _displayCartSuccess: function (item) {
            var self = this;
            if ($('#promo-popup-extra-cross-sell .extra_cross_sell_items .cross_sell_item').length > 0 && item.product_type == 'Starter Kit') {
              $('#promo-popup-extra-cross-sell').addClass('visible');
              $(document.body).css('overflow-y', 'hidden');
            }

            $(".add-to-cart-btn[data-product-id='" + item.product_id + "'] .cart-in-progress").hide();
            $(".add-to-cart-btn[data-product-id='" + item.product_id + "'] .cart-success").css('display', 'flex');
            $(".add-to-cart-btn[data-product-id='" + item.product_id + "']").addClass('product-added');
             $(".add-to-cart-btn[data-product-id='" + item.product_id + "']").data('processing', false).prop('disabled', false);
            $(self._selectors.cartErrors).hide();
            $(self._selectors.cartErrors).empty();
            setTimeout(function(){
              $(".add-to-cart-btn[data-product-id='" + item.product_id + "'] .cart-success").hide();
              $(".add-to-cart-btn[data-product-id='" + item.product_id + "']").removeClass('product-added');
              $(".add-to-cart-btn[data-product-id='" + item.product_id + "'] .cart-normal").css('display', 'flex');
            }, 3000);
        },
        /*
            =function _displayCartError(msg)
            Sets up the error effect for the add to cart button and displays
            the error message.
            (string) msg: The error message to display
        */
        _displayCartError: function (msg) {
            var self = this;
            $(self._selectors.addToCartBtn).addClass(self._classes.cartErr);
            $(self._selectors.mobileAddToCartBtn).addClass(self._classes.mobileErr);
            $(self._selectors.addToCartBtn).data('processing', false).prop('disabled', false);
            $(self._selectors.cartErrors).show();
            $(self._selectors.cartErrors).html(msg);
            setTimeout(function () {
                $(self._selectors.addToCartBtn).removeClass(self._classes.cartErr);
                $(self._selectors.mobileAddToCartBtn).removeClass(self._classes.mobileErr);
            }, 900);
        }
    };
}());


/*
    theme.Cart
    Controls the updating of cart quantities. When a quantity
    is changed on one of the cart items, all quantity controls
    are locked until the cart is updated on Shopify's end. Will
    unlock controls on either success or error of updating the
    cart. Also contains code to adjust the cart item count and
    icon in the header.
    
    Depends on:
    theme.AjaxCart
    theme.Currency
    theme.Variants
    
    Related directly to:
    /sections/cart-template.liquid
    /sections/header.liquid (Cart item count and SVG code)
*/
theme.Cart = (function () {
    return {
        /***** Private Properties *****/
        //Selectors used for jQuery targeting
        _selectors: {
            /* Cart Selectors */
            cartItemsContainer: '.js-cart-items-container',
            cartItem: '.js-cart-item-info-container',
            cartItemPrice: '.js-cart-item-price',
            cartItemOrigPrice: '.js-cart-item-orig-price',
            hideOnEmpty: '.js-cart-hide-on-empty',
            showOnEmpty: '.js-cart-show-on-empty',
            subtotal: '.js-cart-subtotal',
            originalSubtotal: '.js-cart-original-subtotal',
            cartBtnSubtotal: '.js-cart-btn-subtotal',
            note: '#CartSpecialInstructions',
            /* Cart Item Count Icon - Header Selectors */
            cartItemIconSVG: '.js-cart-icon #cart-svg',
            cartItemIconWrapper: '.js-cart-icon',
            cartItemIconCount: '.js-cart-icon #cart-svg-count',

            cartItemIconMobileCount: '.js-cart-mobile-icon #mobile-cart-svg-count',
            
            cartItemCount: '.js-cart-count #CartCount',
            cartItemCost: '.js-cart-count #CartCost, .bk-cart-subtotal-price',

            cartPopup: '#popup-cart-page',
            headerCartIcon: '#header-cart-icon',
            popupCloseIcon: '#popup-cart-page .close-popup',
            cartItemsContainerPopup: '#popup-cart-page .cart-items',
            cartItemPopup: '#popup-cart-page .js-cart-item-info-container'
        },
        //Classes used to be added/removed/checked against
        _classes: {
            cartItemCountExtraPad: 'cart-extra-pad'
        },
        
        /***** Public Methods *****/
        /*
            =function init(container)
            Initializes the quantity controls for each cart item. Also 
            initializes the listener for the quantity change event.
            =Params
            (mixed) container: Value can be a jQuery selector string, jQuery
                                object, or element. The value should return the
                                container of the cart.
        */
        init: function (container) {
            var self = this;
            var $container = $(container);
            $container.find(self._selectors.cartItem).each(function() {
                theme.Variants.initQtyControls($(this));
            });
            $container.find('#AddToCart').click(function(e) {
                $("input#mobile-cart-submit-button" ).trigger( "click" );
            });
            $container.mySection().on(theme.Variants.eventStrs.onQtyChanged, function() {
                self._updateCart();
            });
            $('body').on(theme.AjaxCart.eventStrs.updateCartSuccess, function() {
                self._updateCartValues();
                theme.Variants.enableAllControls();
                $(self._selectors.cartItemsContainerPopup).removeClass('in-process');

                self.updateExtras();
                // self.updateLeadTime();
            });
            $('body').on(theme.AjaxCart.eventStrs.updateCartError, function() {
                theme.Variants.enableAllControls();
                setTimeout(function(){
                  $(self._selectors.cartItemsContainerPopup).removeClass('in-process');
                }, 200);
            });


            if ($(self._selectors.cartPopup).length > 0) {
              //Reset the event, just in case it was already set
              $('body').off(theme.AjaxCart.eventStrs.getCartSuccess);
              //Setup the event for getting the cart data from Shopify
              $('body').on(theme.AjaxCart.eventStrs.getCartSuccess, function(e, cart) {
                self.populateCartPopup(cart);
                self._updateCartValues();
              });
              //Get the cart data
              theme.AjaxCart.getCartData();

              $('body').on('click', self._selectors.headerCartIcon, function(){
                self.showCartPopup();
              });

              $('body').on('click', self._selectors.popupCloseIcon, function(){
                self.hideCartPopup();
              });
            
              $(document).on('click', function (e) {
                if (
                  $(e.target).closest(self._selectors.cartPopup).length === 0 &&
                  !$(e.target).is(self._selectors.headerCartIcon) &&
                  $(self._selectors.cartPopup).hasClass('is-visible') &&
                  $(e.target).closest("#ui-datepicker-div").length === 0 &&
                  $(e.target).closest(".ui-datepicker-next").length === 0 &&
                  $(e.target).closest(".ui-datepicker-prev").length === 0 &&
                  $(e.target).closest(".fancybox__container.is-animated").length === 0
                ) {
                  self.hideCartPopup();
                }
              });
            }
        },
        /*
            =function updateCartItemCount(newCount, cartTotalCost)
            Updates the display for the cart item count and its icon
            =Params
            (int) newCount: The new total of items in the cart
            (int) cartTotalCost: The total cost of the cart in cents
        */
        updateCartItemCount: function(newCount, cartTotalCost) {
            $(this._selectors.cartItemIconCount + ',' + this._selectors.cartItemCount).html(newCount);
            $(this._selectors.cartItemIconMobileCount + ',' + this._selectors.cartItemCount).html(newCount);
            $(this._selectors.cartItemCost).text(theme.Currency.formatMoney(cartTotalCost));
            if (newCount == 0) {
                $(this._selectors.cartItemIconSVG).attr({
                    color: "#231f20",
                    stroke: "#231f20"
                });
                $(this._selectors.cartItemIconSVG + ' ' + 'path').attr({
                    fill: "#231f20"
                });
                // $(this._selectors.cartItemIconCount + ',' + this._selectors.cartItemCount).hide();
                // $(this._selectors.cartItemIconMobileCount + ',' + this._selectors.cartItemCount).hide();
                // $('.header-cart-img.cart-full-close').css({"display":"none"});
                
                $('.header-cart-img.cart-empty-open').css({"display":"inline"});
                $(this._selectors.cartItemIconWrapper).removeClass('cart-show');
            } else {
              $('.header-cart-img.cart-full-close').css({"display":"inline"});
              $('.header-cart-img.cart-empty-open').css({"display":"none"});
                $(this._selectors.cartItemIconSVG).attr({
                    color: "#00a9a5",
                    stroke: "#00a9a5"
                });
                  $(this._selectors.cartItemIconSVG + ' ' + 'path').attr({
                    fill: "#00a9a5"
                });
                $(this._selectors.cartItemIconCount + ',' + this._selectors.cartItemCount).show();
                $(this._selectors.cartItemIconMobileCount + ',' + this._selectors.cartItemCount).show();
                $(this._selectors.cartItemIconWrapper).addClass('cart-show');

            }
            if (newCount > 9) {
                $(this._selectors.cartItemCount).addClass(this._classes.cartItemCountExtraPad);
            }
        },
        showCartPopup: function(item) {
          // Reset Delivery details popup in case user already entered the details
          var $delivery_details_popup = $('#delivery-date-popup-cart-page');
          $delivery_details_popup.removeClass('visible');
          $delivery_details_popup.find("#delivery-address-checkbox").prop('checked', false);
          $delivery_details_popup.find("#chkDisable").prop('checked', false);
          $delivery_details_popup.find("#date").val('');

          var self = this;
          $('html').addClass('js-drawer-open');
          $(self._selectors.cartPopup).addClass('is-transitioning');
          var hasStarterKitPopup = $('#promo-popup-extra-cross-sell').data('cross-sell-popup');
          var hasPopupOpened = $('#promo-popup-extra-cross-sell').hasClass('visible');
          var item_type;

          if (item) {
            item_type = item.product_type;
          }

          if (hasStarterKitPopup && item_type == 'Starter Kit' || hasPopupOpened) {
            $('html').removeClass('js-drawer-open');
            $('#header-cart-icon,#continue_shopping_btn,#promo-popup-extra-cross-sell .promo_cross').click(function() {
              $('html').addClass('js-drawer-open');

              setTimeout( function() {
                showedCartPopup();
              }, 250);
            });
            $('.extra_cross_sell.cross_sell_popup_wrapper').click(function (e) {
              if (e.target.isSameNode(e.currentTarget)) {
                $(this).removeClass('visible');
                $('body').css('overflow-y', 'auto');

                setTimeout( function() {
                  $('html').addClass('js-drawer-open');
                  showedCartPopup();
                }, 250);
              }
            });
          } else {
            showedCartPopup();
          }

          function showedCartPopup() {
            setTimeout(function() {
              $(self._selectors.cartPopup).removeClass('is-transitioning');
              $(self._selectors.cartPopup).addClass('is-visible');
              $(self._selectors.cartItemsContainerPopup).css("min-height", $(self._selectors.cartItemsContainerPopup).height());
            }, 50);
          }

        },
        hideCartPopup: function() {
          var self = this;
          $('.main-content').addClass('opacity-0');

          $(self._selectors.cartPopup).addClass('is-transitioning');
          $(self._selectors.cartPopup).removeClass('is-visible');

          setTimeout(function(){
            $('.main-content').removeClass('opacity-0');
            $('html').removeClass('js-drawer-open');
            $(self._selectors.cartPopup).removeClass('is-transitioning');
          }, 500);
        },
        populateCartPopup: function(cart) {
          if (cart.item_count > 0) {
            var self = this;
            var cart_html = "";
            cart.items.forEach(function(item){
              cart_html += self.getCartPopupItemHTML(item);
            });

            $(self._selectors.cartItemsContainerPopup).html(cart_html);

            $(self._selectors.cartPopup).find(self._selectors.cartItem).each(function() {
              theme.Variants.initQtyControls($(this));
            });
          }

        },
        getCartPopupItemHTML: function(item) {
          var saving = 0;
          var item_html = "";
          var hasDiscount = false;
          if (item.variant) {
            if (item.variant.compare_at_price > item.variant.price) {
              saving = item.variant.compare_at_price - item.variant.price;
            }
            if (window.has_b2b_customer && window.has_b2b_discount > 0) {
              var variantOriginalPrice = getB2BOriginalPrice(item.variant.price);
              saving = (variantOriginalPrice * 100) - item.variant.price;
            }
          }
          if (item.discounts.length > 0 && item.original_line_price != item.line_price) {
            hasDiscount = true;
          }
          var data_orig_price = 0;
          if (item.variant) {
            if (item.variant.compare_at_price) {
              data_orig_price = item.variant.compare_at_price;
            } else {
              data_orig_price = item.original_line_price/item.quantity;
            }
          }

          item_html +=  "<div class='cart-item js-cart-item-info-container' data-orig-price='" + (data_orig_price) + "' data-price='" + (item.line_price/item.quantity) + "' data-id='" + item.id + "' data-saving='" + saving + "' data-sku='" + item.sku + "' data-product-type='" + item.product_type + "'>"
          item_html +=    "<div class='product-image'>"
          item_html +=      "<a href='" + item.url + "'>"
          item_html +=        "<img src='" + item.image + "' alt='product image' />"
          item_html +=      "</a>"
          item_html +=    "</div>"
          item_html +=    "<div class='product-info'>"
          item_html +=      "<a href='" + item.url + "'>"
          item_html +=        "<h5>" + item.product_title + "</h5>"
          item_html +=      "</a>"
          if (item.variant_title) {
          item_html +=      "<p class='option'>" + item.variant_title + "</p>"
          }
          item_html +=      "<div class='cart-quantity-wrapper'>"
          item_html +=        "<div id='quantity-container' class='quantity-wrapper js-qty-wrap'>"
          item_html +=          "<input id='quantity-minus' type='button' class='qtyminus' value='-' /> "
          item_html +=          "<input id='quantity' type='text' class='qty' name='updates[]' value='" + item.quantity + "' min='0' pattern='[0-9]*' >"
          item_html +=          "<input id='quantity-plus' type='button' class='qtyplus' value='+' />"
          item_html +=        "</div>"
          item_html +=      "</div>"
          item_html +=    "</div>"
          item_html +=    "<div class='remove-option'>"
          item_html +=    "<div class='price-container'>"
          var has_compared_price = false ;
          if (item.variant) {
            if (item.variant.compare_at_price) {
              if (item.variant.compare_at_price > (item.original_line_price/item.quantity) ) {
                has_compared_price = true; 
              }
            }
          }
          if (hasDiscount) {
            item_html +=      "<span class='js-cart-item-orig-price'>" + theme.Currency.formatMoney(item.original_line_price) + "</span>"
          } else if (data_orig_price > 0 &&  has_compared_price ){
            item_html +=      "<span class='js-cart-item-orig-price compared'>" + theme.Currency.formatMoney(item.variant.compare_at_price) + "</span>"
          }
          item_html +=      "<h5 class='js-cart-item-price'>" + theme.Currency.formatMoney(item.line_price) + "</h5>"
          item_html +=    "</div>"
          item_html +=      "<img id='remove-item' class='trash-icon' src='https://cdn.shopify.com/s/files/1/0068/1728/4155/files/active_2x_e5d94e01-b02d-4cd1-8c28-6d4c577ec3b5.png?v=1606475631' alt='remove' />"
          item_html +=    "</div>"
          item_html +=  "</div>"

          return item_html;
        },
        updateLeadTime: function(){
          $(".ps-lead-time-message").hide();
          var sku_in_cart = [];
          var cb_lead_time = 0;
          $(".cart-item.js-cart-item-info-container").each(function(){
            sku_in_cart.push($(this).data('sku'));
            if ($(this).data('product-type') == "customized-box") {
              cb_lead_time = window.cb_lead_time_cms;
            }
          });

          var ps_lead_time = 0;
          for (var i = 0; i < window.ps_lead_times.length; i++) {
            for (var j=0; j < sku_in_cart.length; j++) {
              if (sku_in_cart[j].indexOf(window.ps_lead_times[i].sku) > -1) {
                $("#" + window.ps_lead_times[i].sku).show();
                if (window.ps_lead_times[i].lead_time > ps_lead_time) {
                  ps_lead_time = window.ps_lead_times[i].lead_time;
                }
              }
            }
          }
          
          window.extended_lead_time = 0;
          if (cb_lead_time > window.extended_lead_time) { window.extended_lead_time = cb_lead_time; }
          if (overall_lead_time > window.extended_lead_time) { window.extended_lead_time = overall_lead_time; }
          if (ps_lead_time > window.extended_lead_time) { window.extended_lead_time = ps_lead_time; }

          window.initializeDeliveryDatePicker();
        },
        updateExtras: function() {
          $.ajax({
            type: 'GET',
            url: '/?section_id=popup-cart-extras',
            success: function(resultObj) {
              $("#ajax-cart-extras-container").html(resultObj);
              initFancyBox();
            },
            error: function(resultObj) {
              console.log("Unable to refresh Ajax cart's extras");
            }
          });
        },
        
        /***** Private Methods *****/
        /*
            =function _updateCart()
            Begins the process of updating the cart data on Shopify,
            and then on the page itself. Disables quantity controls,
            sets up the listeners for the ajax calls, and then starts
            the ajax call to update the cart.
        */
        _updateCart: function() {
            theme.Variants.disableAllControls();
            theme.AjaxCart.updateCart(this._getCartValsStr());
        },
        /*
            =function _updateCartValues()
            Goes through the items in the cart and updates their price
            displays while determining the new cart total cost and item count.
        */
        _updateCartValues: function () {
            var self = this;
            var total = 0, totalOriginal = 0, qty = 0,
                totalQty = 0, newPrice = 0, totalSavings = 0, savings = 0;
            var $this, $productInfo;
            // Goes through all quantity fields and updates their corresponding
            // product's price display. Also tallies the new cart total
            // and new cart price
            theme.Variants.gatherQuantityFields().each(function () {
                $this = $(this);
                qty = parseInt($this.val());
                if(qty > 0) {
                    $productInfo = $this.closest(self._selectors.cartItem);
                    newPrice = qty * $productInfo.data('price');
                    savings = qty * $productInfo.data('saving');
                    total += newPrice;
                    totalQty += qty;
                    totalSavings += savings;
                    if ($productInfo.data('orig-price')) {
                      var newOrigPrice = qty * $productInfo.data('orig-price');
                      totalOriginal += newOrigPrice;
                      $productInfo.find(self._selectors.cartItemOrigPrice).text(theme.Currency.formatMoney(newOrigPrice));
                    } else {
                      totalOriginal += newPrice;
                    }
                    $productInfo.find(self._selectors.cartItemPrice).text(
                    theme.Currency.formatMoney(newPrice));
                } else {
                    var $removedItem = $this;
                    $removedItem.closest(self._selectors.cartItem).addClass('removed-item');

                    var itemsHeight = $(".cart-items").height();
                    var itemHeight = $removedItem.closest(self._selectors.cartItem).outerHeight();
                    var diff = itemsHeight - itemHeight;

                    setTimeout(function(){
                      $removedItem.closest(self._selectors.cartItem).css("visibility", "hidden");
                      $removedItem.closest(self._selectors.cartItem).remove();
                      $(".cart-items").css("min-height", diff);
                    }, 750);
                }
            });
            //Hide the cart and display empty cart if empty. Otherwise, update price
            if (totalQty == 0) {
                $(self._selectors.showOnEmpty).show();
                $(self._selectors.hideOnEmpty).hide();
            } else {
                $(self._selectors.showOnEmpty).hide();
                $(self._selectors.hideOnEmpty).show();

                var totalFormatted = theme.Currency.formatMoney(total);
                $(self._selectors.subtotal).text(totalFormatted);
                $(self._selectors.cartBtnSubtotal).text('Total: ' + totalFormatted);

                if (totalOriginal > total) {
                  var totalOriginalFormatted = theme.Currency.formatMoney(totalOriginal);
                  $(self._selectors.originalSubtotal).text(totalOriginalFormatted);
                  $(self._selectors.originalSubtotal).show();
                } else {
                  $(self._selectors.originalSubtotal).hide();
                }
            }
            var titleCouponCode = Cookies.get("discount_code");
            if(titleCouponCode !== undefined) {
              $('.discount-applied-message').show();
            } else {
              if (totalSavings > 0) {
                if (window.active_mega_sale) {
                  totalSavings = totalOriginal - total;
                }
                $('.discount-value .amount').text(theme.Currency.formatMoney(totalSavings));
                $('.discount-value').show();
              } else {
                $('.discount-value').hide();
              }
            }
            self.updateCartItemCount(totalQty, total);
        },
        /*
            =function _getCartValsStr()
            Returns a string representation of the cart to be used in
            the ajax calls.
        */
        _getCartValsStr: function () {
            var self = this;
            var toReturn = '';
            var id, $this, $productInfo;
            //Gather all the variants and their qunatities
            theme.Variants.gatherQuantityFields().each(function () {
                $this = $(this);
                $productInfo = $this.closest(self._selectors.cartItem);
                id = $productInfo.data('id');
                if (toReturn != '') {
                    toReturn += '&';
                }
                toReturn += 'updates[' + id + ']=' + $this.val();
            });
            //Get the cart note
            // var note_str = $(self._selectors.note).val();
            // if (note_str != '') {
            //     if (toReturn != '') {
            //         toReturn += '&';
            //     }
            //     toReturn += 'note=' + note_str;
            // }
            return toReturn;
        }
    };
}());

(function () {

//Misc
  theme.HashScrolling = function () {
    $('a[href*="#"]:not([href="#"])').not('.js-tabs-link').click(function () {
      if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        if (target.length) {
          $('html, body').animate({
              scrollTop: target.offset().top-130
          }, 1000);
          return false;
        }
      }
    });
  };


//Slick init
  theme.Slick = {
    _selectors: {
      slidesContainer: '.js-slides-container',
      prodThumbSquare: '.product__thumbs--square',
      prodSlides: '.product__slides',
      // variantImgSlider: '.variant-image-slider',
      blogSlider: '.blog-slider'
    },
    _prodPhotoConfig: {
      dots: true,
      infinite:false,
      // customPaging: function (slider, i) {
      //     var thumb = $(slider.$slides[i]).data('thumb');
      //     return '<img src="' + thumb + '">';
      // },
      adaptiveHeight: true,
      responsive: [{
          breakpoint: 768,
          settings: {
              adaptiveHeight: true
          }
      }]
    },
    _prodPhotoQuickConfig: {
      dots: true,
      adaptiveHeight: true,
      responsive: [{
          breakpoint: 768,
          settings: {
              adaptiveHeight: true
          }
      }]
    },
    _generalConfig: {
      dots: true,
      arrows: false,
      adaptiveHeight: false,
      autoplay: false,
      speed: 700,
      responsive: [{
          breakpoint: 768,
          settings: {
              adaptiveHeight: true
          }
      }]
    },
    _blogConfig: {
      dots: true,
      arrows: true,
      adaptiveHeight: true,
      responsive: [{
          breakpoint: 768,
          settings: {
              adaptiveHeight: true
          }
      }]
    },
    _initSlick: function($container, slidesSelector, config) {
      //Get the container
      var $slidesContainer = $container.find(slidesSelector);
      //Only init if we have a container
      if($slidesContainer.length > 0) {
          //Init the container's Slick
          $slidesContainer.slick(config);
          //Set resize event for when the window is resized
          $(window).resize(function() {
              $slidesContainer.slick('resize');
          });
          setTimeout(function() {
              //Force a post-init resize to try to initially set the size
              $slidesContainer.slick('resize');
              //Have a resize run after the doc height changes, if needed
              theme.Utilities.runAtNewDocHeight(function() { 
                  $slidesContainer.slick('resize');
              });
          }, 250);
      }
    },
    _initSlickWithThumbnails: function($container) {
      var headerSlider = $container.find('.sb_header_slider');
      headerSlider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        infinite: true,
        asNavFor: '.sb_header_slider_bottom'
      });

      var sb_header_slider_bottom = {
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.sb_header_slider',
        speed: 500,
        focusOnSelect: true,
        centerMode: true,
        infinite: true,
        vertical: true,
        responsive: [
          {
            breakpoint: 1600,
            settings: {
              variableWidth: true,
              vertical: false
            }
          },
          {
            breakpoint: 930,
            settings: {
              vertical: false,
              dots: false
            }
          }, 
          {
            breakpoint: 1200,
            settings: {
              vertical: false,
              variableWidth: true
            }
          },
          {
            breakpoint: 480,
            settings: {
              vertical: false,
              variableWidth: true
            }
          }
        ]
      };
      $container.find('.sb_header_slider_bottom').slick(sb_header_slider_bottom);
    },
    _uninitSlickWithThumbnails: function() {
      $('.sb_header_slider').slick('unslick');
      $('.sb_header_slider_bottom').slick('unslick');
    },
    /* Initializers */
    initFeaturedCollection: function(container) {
      this._initSlick($(container), this._selectors.slidesContainer, this._generalConfig);
    },
    initProdPhoto: function(container) {
      var $container = $(container);
      // this._prodPhotoConfig.appendDots = $container.find(this._selectors.prodThumbSquare);
      // this._initSlick($container, this._selectors.prodSlides, this._prodPhotoConfig);
      this._initSlickWithThumbnails($container);
    },
    initProdPhotoQuick: function(container) {
      var $container = $(container);
      // this._prodPhotoQuickConfig.appendDots = $container.find(this._selectors.prodThumbSquare);
      // this._initSlick($container, this._selectors.prodSlides, this._prodPhotoQuickConfig);
      this._initSlickWithThumbnails($container);
    },
    // initVariant: function(container) {
    //   var $container = $(container);
    //   this._initSlick($container, this._selectors.variantImgSlider, this._generalConfig);
    // },
    initMobileBlog: function(container) {
      var $container = $(container);
      this._initSlick($container, this._selectors.blogSlider, this._blogConfig);
    },
    /* Uninitializers */
    _unslick: function($slidesContainer) {
      $slidesContainer.slick('unslick');
    },
    uninitFeaturedCollection: function(container) {
      this._unslick($(this._selectors.slidesContainer, container));
    },
    uninitProdPhoto: function(container) {
      // this._unslick($(this._selectors.prodSlides, container));
      this._uninitSlickWithThumbnails();
    },
    // uninitVariant: function(container) {
    //   this._unslick($(this._selectors.variantImgSlider, container));
    // },
    unintMobileBlog: function(container) {
      this._unslick($(this._selectors.blogSlider, container));
    },
    /* Slick Controls */
    _gotoSlide: function($slidesContainer, ndx) {
      $slidesContainer.slick('slickGoTo', ndx);
    },
  };
}());


/*
    theme.Navigation
    
    Container and controller of all navgiation code. This section 
    contains very basic initializations, but also has many of the 
    selectors used in other sections of the navigation code.
    
    Depends on:
    timber
*/
theme.Navigation = (function () {
  return {
    /***** Private Properties *****/
    //Selectors used for jQuery targeting
    _selectors: {
      id: '#AccessibleNav',
      dim: '.dim',
      openedNav: '#AccessibleNav .nav-hover',
      closeOnMouseLeave: '.main-menu-dropdown, .site-nav--has-dropdown',
      nextNav: ".site-header .header-icons",
      topLevelMenuItems: '.site-nav--has-dropdown',
      childNavLinks: '.child-site-nav__link',
      subMenuDiv: '.child-div',
      sectionHeaderMenuItems: '.nav-section-header',
      bottomLevelMenuItems: '.grandchild-link .site-nav__link',
      siteHeaderId: '#header',
      mainMenuDropdown: '.main-menu-dropdown',
      generalMenu: '.nav-menu-js',
      singleDropdown: '.single-dropdown',
    },
    //Classes used to be added/removed/checked against
    _classes: {
      hover: 'nav-hover',
      navBg: 'mega-nav-bg',
    },
    //Event handler for scrolling the window
    _scrollHandler: null,

    /***** Public Methods *****/
    /*
    =function init()
    */
    init: function () {
      var self = this;
      self._scrollHandler = self.exitNav.bind(self);
      var navUL = $('#AccessibleNav').height(),
        navRows = navUL / 37,
        singleDMenu = false,
        multiNav = false;

      if ($(self._selectors.singleDropdown).length > 0) {
        var singleDMenu = true;
      }
      if (navRows > 1.2) {
        var multiNav = true;
        $('#AccessibleNav').addClass('multinav');
      }

      if (!multiNav || singleDMenu || true) {
        $('#AccessibleNav > .site-nav--active').mouseenter(function () {
          if ($('.search-dropdown').hasClass('searching') == false && !$('#AccessibleNav').hasClass('multinav')) {
            self.exitNav();
          }
        });
        // If single row of link OR single dropdown    
        var firstLevelInterval = null;
        $(self._selectors.topLevelMenuItems).mouseenter( function() {
          // Close all open elements
          var thisEvent = $(this)
          firstLevelInterval = setInterval( () => {
            if ($('.main-menu-dropdown:hover').length != 0 || $('#AccessibleNav > .site-nav--has-dropdown:hover').length != 0) {

              $(self._selectors.topLevelMenuItems).removeClass(self._classes.hover)
              $(".main-menu-dropdown").removeClass("active");
              $(".main-menu-dropdown").removeClass("second_column_hidden");

              if (singleDMenu) {
                // Add navBg to single dropdown link
                $(thisEvent).addClass(self._classes.navBg);
              } else {
                // Add navBg to entire header for mega-menu
                $(self._selectors.siteHeaderId).addClass(self._classes.navBg);
              } 
              $(thisEvent).addClass(self._classes.hover);

              $(".main-menu-dropdown-container").addClass("opened");

              var child_nav_id = $(thisEvent).data("menu-id");
              var menu_holder = $(".main-menu-dropdown#" + child_nav_id);
              menu_holder.addClass("active");
              if (menu_holder.find(".fourth_level").data("second-col-hidden") == true) {
                menu_holder.addClass("second_column_hidden");
              }

              var color = menu_holder.find(".second_level_left li:first-child a").data("menu-color");
              var supported_colors = ["blue", "coffee", "plum", "forest"];
              supported_colors.forEach(function (sc) {
                if (sc != color) {
                  menu_holder.removeClass(sc);
                }
              });
              menu_holder.addClass(color);
              
              menu_holder.find(".second_level_left li a").removeClass("active");
              menu_holder.find(".third_level .tabcontent").hide();
              menu_holder.find(".third_level .tabcontent .second-col-navs li a ").removeClass("active");
              menu_holder.find(".third_level .tabcontent .fourth_level .fourth_level_tabcontent").hide();
              menu_holder.find(".second_level_left li:first-child a").addClass("active");
              menu_holder.find(".third_level .tabcontent:first-child").css("display", "flex");
              setTimeout(function() {
                if ($(".third_level .tabcontent").hasClass("ltr-transition")) {
                  menu_holder.find(".third_level .tabcontent:first-child").addClass("fade-in-transition");
                } else {
                  menu_holder.find(".third_level .tabcontent:first-child").addClass("ltr-transition");
                }
              }, 50)
              menu_holder.find(".third_level .tabcontent:first-child .second-col-navs li:first-child a ").addClass("active");
              menu_holder.find(".third_level .tabcontent:first-child .fourth_level .fourth_level_tabcontent:first-child").css('display', 'flex');

              $(self._selectors.dim).show();
              setTimeout(function() {
                $(self._selectors.dim).css('opacity',1);
                $(self._selectors.dim).css('transition','opacity .6s ease-in-out')
              }, 50);
              $(window).scroll(self._scrollHandler);
              clearInterval(firstLevelInterval)
            }
          }, 150)
        });

        if (!singleDMenu) {
          $(self._selectors.topLevelMenuItems).mouseleave(function () {
            clearInterval(firstLevelInterval)
            console.log("hello ---->");
            setTimeout(function () {
              if ($('.main-menu-dropdown:hover').length == 0 && $('#AccessibleNav > .site-nav--has-dropdown:hover').length == 0) {
                self.exitNav();
              }
            }, 500);
          });
          $(".main-menu-dropdown-container").mouseleave(function () {
            console.log("hello 1 ---->");
            clearInterval(firstLevelInterval)
            setTimeout(function () {
              if ($('.main-menu-dropdown:hover').length == 0 && $('#AccessibleNav > .site-nav--has-dropdown:hover').length == 0) {
                self.exitNav();
              }
            }, 500);
          });
        }

        if (singleDMenu) {
          // Remove single menu hover and exit nav
          $(self._selectors.closeOnMouseLeave).mouseleave(function () {
            $(this).removeClass(self._classes.navBg);
            self.exitNav();
          });
        }

        $(self._selectors.siteHeaderId).mouseleave(function () {
          if ($('.search-dropdown').hasClass('searching') == false && $('#searchInput:hover').length == 0 && $('main-menu-dropdown:hover').length == 0 && !$('#AccessibleNav').hasClass('multinav')) {
            self.exitNav();
          }
        });
      } else {
        $(self._selectors.topLevelMenuItems, self._selectors.id, '#AccessibleNav > li').unbind("mouseenter mouseleave");
        $(self._selectors.topLevelMenuItems).click(function (e) {
          return false;
        });
        $(self._selectors.childNavLinks).click(function (e) {
          e.stopPropagation();
          return true;
        });
        $(self._selectors.topLevelMenuItems, self._selectors.id).click(function () {
          theme.Search._closeSearch($('[data-section-type="header"]'));
          self.exitNav();
          $(self._selectors.siteHeaderId).addClass(self._classes.navBg);
          $(this).addClass(self._classes.hover);
          $(self._selectors.dim).show();
          $(window).scroll(self._scrollHandler);
        });
        $(window).click(function () {
          if ($(self._selectors.topLevelMenuItems, self._selectors.id).hasClass(self._classes.hover)) {
            self.exitNav();
          }
        });
      }
      $(window).resize(function () {
        if ($(window).width() > 768) {
          var naviUL = $('#AccessibleNav').height(),
            naviRows = naviUL / 37,
            singleDMenus = false,
            multiNavi = false;

          if ($(self._selectors.singleDropdown).length > 0) {
            var singleDMenus = true;
          }
          if (naviRows > 1.2) {
            var multiNavi = true;
            $('#AccessibleNav').addClass('multinav');
          } else {
            $('#AccessibleNav').removeClass('multinav');
          }

          if (!multiNavi || singleDMenus || true) {
            if (!multiNavi) {
              $('#AccessibleNav > .site-nav--active').mouseenter(function () {
                if ($('.search-dropdown').hasClass('searching') == false && !$('#AccessibleNav').hasClass('multinav')) {
                  self.exitNav();
                }
              });
            }
            // If single row of link OR single dropdown                       
            $(self._selectors.topLevelMenuItems).mouseenter(function () {
              // Close all open elements
              theme.Search._closeSearch($('[data-section-type="header"]'));
              $(self._selectors.topLevelMenuItems).removeClass(self._classes.hover);

              if (singleDMenus) {
                // Add navBg to single dropdown link
                $(this).addClass(self._classes.navBg);
              } else {
                // Add navBg to entire header for mega-menu
                $(self._selectors.siteHeaderId).addClass(self._classes.navBg);
              }
              $(this).addClass(self._classes.hover);
              $(self._selectors.dim).show();
              $(window).scroll(self._scrollHandler);
            });
            if (!singleDMenus) {
              $(self._selectors.topLevelMenuItems).mouseleave(function () {
                setTimeout(function () {
                  if ($('.main-menu-dropdown:hover').length == 0 && $('#AccessibleNav > li:hover').length == 0) {
                    self.exitNav();
                  }
                }, 500);
              });
            }

            if (singleDMenus) {
              // Remove single menu hover and exit nav
              $(self._selectors.closeOnMouseLeave).mouseleave(function () {
                $(this).removeClass(self._classes.navBg);
                self.exitNav();
              });
            }
            $(self._selectors.siteHeaderId).mouseleave(function () {
              if ($('.search-dropdown').hasClass('searching') == false && $('#searchInput:hover').length == 0 && $('main-menu-dropdown:hover').length == 0 && !$('#AccessibleNav').hasClass('multinav')) {
                self.exitNav();
              }
            });
          } else {
            $(self._selectors.topLevelMenuItems, self._selectors.id, '#AccessibleNav > .site-nav--active').unbind("mouseenter mouseleave");
            $(self._selectors.topLevelMenuItems).click(function (e) {
              return false;
            });
            $(self._selectors.childNavLinks).click(function (e) {
              e.stopPropagation();
              return true;
            });
            $(self._selectors.topLevelMenuItems, self._selectors.id).click(function () {
              theme.Search._closeSearch($('[data-section-type="header"]'));
              self.exitNav();
              $(self._selectors.siteHeaderId).addClass(self._classes.navBg);
              $(this).addClass(self._classes.hover);
              $(self._selectors.dim).show();
              $(window).scroll(self._scrollHandler);
            });
            $(window).click(function () {
              if ($(self._selectors.topLevelMenuItems, self._selectors.id).hasClass(self._classes.hover)) {
                self.exitNav();
              }
            });
          }
        }
      });

      //Init keyboard accessibility
      this.Keyboard.init();
      //Init the mobile nav
      this.Mobile.init();
      //Init the touch menu
      this.TouchMenu.init();
    },
    /*
    =function displayOrHideSharedElements()
    Displays the shared elements between the nav and search, 
    such as background dims. Hides them if "hide" is true.
    =Params
    (bool) hide: (optional) If true, the shared elements are hidden
    */
    displayOrHideSharedElements: function (hide) {
      if (hide) {
        $(this._selectors.dim).css('opacity',0);
        $(this._selectors.dim).css('transition','opacity .6s ease-in-out');
        setTimeout(function() {
          $('.dim').hide()
        }, 50);
        $(this._selectors.siteHeaderId).removeClass(this._classes.navBg);
      } else {
        $(this._selectors.dim).show();
        setTimeout(function() {
          $('.dim').css('opacity',1);
          $('.dim').css('transition','opacity .6s ease-in-out');
        }, 50);
        $(this._selectors.siteHeaderId).addClass(this._classes.navBg);
      }
    },
    /*
    =function exitNav()
    Completely hides all aspects of the nav, essentially closing it.
    */
    exitNav: function () {
      var $mainNavBar = $(this._selectors.id);
      this.displayOrHideSharedElements($mainNavBar.mySection(), true);
      $mainNavBar.find(this._selectors.topLevelMenuItems).removeClass(this._classes.navBg);
      // $mainNavBar.find(this._selectors.topLevelMenuItems).removeClass(this._classes.hover);

      $(".main-menu-dropdown-container").removeClass("opened");
      $(".main-menu-dropdown").removeClass("active");
      $(".site-nav--has-dropdown").removeClass("nav-hover");
      $(".third_level .tabcontent").removeClass("fade-in-transition");
      $(".third_level .tabcontent").removeClass("ltr-transition");

      $mainNavBar.find(this._selectors.mainMenuDropdown + ', ' + this._selectors.singleDropdown).css('display', '');
      $(window).off('scroll', this._scrollHandler);
    },
    /*
    =function initTimber()
    Some of the theme's functionality relies on timber. This
    function calls the appropriate timber functions to fully
    initialize the navigation. Used by the sections initialization
    code.
    */
    initTimber: function () {
      timber.cacheSelectors();
      timber.drawersInit();
      timber.mobileNavToggle();
    },

    /*
      theme.Navigation.Keyboard
      Initiates the controls needed to navigate the main menu.
    */
    Keyboard: {
      /***** "Parent" References *****/
      _selectors: null,
      _classes: null,
      _scrollHandler: null,

      /***** Public Methods *****/
      /*
      =function init()
      */
      init: function () {
        var self = this;
        //Init the "parent" references
        self._selectors = theme.Navigation._selectors,
          self._classes = $.extend(theme.Navigation._classes, {
            subMenuDiv: 'child-div'
          })
        self._scrollHandler = theme.Navigation._scrollHandler;

        //Close the nav if ESC is pressed
        $(document).keyup(function (e) {
          if (e.keyCode === 27) {
            theme.Navigation.exitNav();
            return false;
          }
        });

        //Setup the keydown events
        $(self._selectors.topLevelMenuItems, self._selectors.id).each(function () {
          var $this = $(this);
          //Keydown event handler for top level menu items
          $this.keydown(function (e) {
            //If the input is one of the arrow keys, react to it
            if (37 <= e.keyCode && e.keyCode <= 40) {
              e.preventDefault();
              var $this = $(this);
              switch (e.keyCode) {
                case 38: //Up - Close the nav
                  self._closeMainNav($(this));
                  break;
                case 40: //Down - Open the nav
                  //If the nav is already opened, focus the first available menu item or header
                  if ($this.hasClass(self._classes.hover)) {
                    self._focusFirstAvailableSubMenu($this);
                  } else {
                    self._openMainNav($(this));
                  }
                  break;
                case 37: //Left - Move to the nav on the left
                case 39: //Right - Move to the nav on the right
                  self._openAdjacentNav($this, e.keyCode == 37, $this.hasClass(self._classes.hover));
                  break;
              }
            }
          });
          //Keydown event handler for menu section headers
          $this.find(self._selectors.sectionHeaderMenuItems).keydown(function (e) {
            if (37 <= e.keyCode && e.keyCode <= 40) {
              e.preventDefault();
              e.stopPropagation();
              switch (e.keyCode) {
                case 38: //Up - Focus the top level nav for this menu
                  var $topNav = $(this).closest(self._selectors.topLevelMenuItems);
                  $topNav.children('a').focus();
                  break;
                case 40: //Down - Go to the first bottom level menu item
                  $(this).parent().find(self._selectors.bottomLevelMenuItems + ':first').focus();
                  break;
                case 37: //Left - Focus the menu title to the left
                case 39: //Right - Focus the menu title to the right
                  self._focusNextTitle($(this).parent(), e.keyCode == 37);
                  break;
              }
            }
          });

          $this.find(self._selectors.bottomLevelMenuItems).keydown(function (e) {
            if (37 <= e.keyCode && e.keyCode <= 40) {
              e.preventDefault();
              e.stopPropagation();
              var $this = $(this);
              var myIndex = $this.parent().index();
              switch (e.keyCode) {
                case 38: //Up - Focus the menu item above this one
                case 40: //Down - Focus the menu item below this one
                  self._focusSiblingMenuItem($this.parent(), e.keyCode == 38);
                  break;
                case 37: //Left - Focus the menu item to the left of this one
                case 39: //Right - Focus the menu item to the right of this one
                  self._focusAdjacentMenuItem($this.closest(self._selectors.subMenuDiv), e.keyCode == 37, myIndex)
                  break;
              }
            }
          });
        });
      },
      /*
        =function _focusFirstAvailableSubMenu($nav)
        Finds the first focusable item in $nav and focuses it
        =Params
        (jQuery) $nav - The nav container to search in
      */
      _focusFirstAvailableSubMenu: function ($nav) {
        var toFocus = $nav.find(this._selectors.sectionHeaderMenuItems + ':first');
        if (toFocus && toFocus.length > 0) {
          toFocus.focus();
        } else {
          $nav.find(this._selectors.bottomLevelMenuItems + ':first').focus();
        }
      },
      /*
        =function _openMainNav($nav, ignoreFocus)
        Opens and displays the $nav passed in
        =Params
        (jQuery) $nav - The nav container to display
        (bool) ignoreFocus - (optional) If true, focuses closest sub menu 
                              item. Otherwise it focuses the top level menu 
                              item.
      */
      _openMainNav: function ($nav, ignoreFocus) {
        //Set styles for outside of the nav
        theme.Navigation.displayOrHideSharedElements();
        //Open the nav itself
        $nav.find(this._selectors.mainMenuDropdown).show();
        $nav.addClass(this._classes.hover);
        //Focus the first element
        if (!ignoreFocus) {
          this._focusFirstAvailableSubMenu($nav);
        } else {
          $nav.children('a').focus();
        }
        $(window).scroll(this._scrollHandler);
      },
      /*
        =function _closeMainNav($nav)
        Closes the $nav passed in.
        =Params
        (jQuery) $nav - The nav container to close
      */
      _closeMainNav: function ($nav) {
        //Unset styles for outside of the nav
        theme.Navigation.displayOrHideSharedElements($nav.mySection(), true);
        //Close the nav itself
        $nav.find(this._selectors.mainMenuDropdown).hide();
        $nav.removeClass(this._classes.hover);
        $(window).off('scroll', theme.Navigation._scrollHandler);
      },
      /*
        =function _getAdjacentElement($nav, goLeft, selector)
        Get the adjacent element matching the selector of the 
        passed in element $nav.
        =Params
        (jQuery) $nav - The element to get the adjacent of
        (bool) goLeft - If true, get the "previous" element. Otherwise
                        get the "next" element
        (string) selector - The element to search for
      */
      _getAdjacentElement: function ($nav, goLeft, selector) {
        if (goLeft) {
          return $nav.prev(selector);
        } else {
          return $nav.next(selector);
        }
      },
      /*
        =function _openAdjacentNav($nav, goLeft, ignoreFocus)
        Opens the nav adjacent to the current one
        =Params
        (jQuery) $nav - The currently opened menu nav
        (bool) goLeft - If true, get the "previous" menu nav. 
                        Otherwise get the "next" one
        (bool) ignoreFocus - (optional) If true, focuses closest sub menu 
                              item. Otherwise it focuses the top level menu 
                              item.
        */
      _openAdjacentNav: function ($nav, goLeft, ignoreFocus) {
        var $adjacent = this._getAdjacentElement($nav, goLeft, this._selectors.topLevelMenuItems);
        if ($adjacent.length > 0) {
          this._closeMainNav($nav);
          this._openMainNav($adjacent, ignoreFocus);
        }
      },
      /*
        =function _focusNextTitle($nav, goLeft)
        Focuses the menu title adjacent to the current one
        =Params
        (jQuery) $nav - The currently focused menu title
        (bool) goLeft - If true, focus the menu title to the left.
                        Otherwise focus the one on the right
      */
      _focusNextTitle: function ($nav, goLeft) {
        var $adjacent = this._getAdjacentElement($nav, goLeft, this._selectors.subMenuDiv);
        if ($adjacent.length > 0) {
          $adjacent.find(this._selectors.sectionHeaderMenuItems).focus();
        } else {
          this._openAdjacentNav($nav.closest(this._selectors.topLevelMenuItems), goLeft);
        }
      },
      /*
        =function _focusSiblingMenuItem($nav, goUp)
        Focuses the menu item above or below one
        =Params
        (jQuery) $nav - The currently focused menu item
        (bool) goUp - If true, focus the menu item above $nav. 
                      Otherwise get the one below
      */
      _focusSiblingMenuItem: function ($nav, goUp) {
        var $sibling;
        if (goUp) {
          $sibling = $nav.prev();
          if ($sibling.length > 0) {
            $sibling.children('a').focus();
          } else {
            var $closestTitle = $nav.closest(this._selectors.subMenuDiv).children('a');
            if ($closestTitle.length > 0) {
              $closestTitle.focus();
            } else {
              $nav.closest(this._selectors.topLevelMenuItems).children('a').focus();
            }
          }
        } else {
          $sibling = $nav.next();
          if ($sibling.length > 0) {
            $sibling.children('a').focus();
          }
        }
      },
      /*
        =function _performAdjacentMenuItemFocus($adjacentList, index)
        Performs the actual focusing of the adjacement menu element
        =Params
        (jQuery) $adjacentList - The list that contains the menu item to focus
        (int) index - The index to focus in the adjacent list
      */
      _performAdjacentMenuItemFocus: function ($adjacentList, index) {
        var $menuItems;
        if ($adjacentList.hasClass(this._classes.subMenuDiv)) {
          $menuItems = $adjacentList.find(this._selectors.bottomLevelMenuItems);
        } else {
          $menuItems = $adjacentList;
        }
        index = $menuItems.length - 1 < index ? $menuItems.length - 1 : index;
        $menuItems.eq(index).focus();
      },
      /*
        =function _focusSiblingMenuItem($nav, goUp)
        Focuses the menu item above or below one
        =Params
        (jQuery) $nav - The currently focused menu item
        (bool) goUp - If true, focus the menu item above $nav. 
                      Otherwise get the one below
      */
      _focusAdjacentMenuItem: function ($nav, goLeft, index) {
        var $adjacentList = this._getAdjacentElement($nav, goLeft, this._selectors.subMenuDiv + ',' + this._selectors.bottomLevelMenuItems);
        if ($adjacentList.length > 0) {
          this._performAdjacentMenuItemFocus($adjacentList, index);
        } else {
          this._openAdjacentNav($nav.closest(this._selectors.topLevelMenuItems), goLeft);
          /*if(!$nav.is(':focus')) {
                var $newNav = $(':focus', $nav.closest(this._selectors.id));
                this._performAdjacentMenuItemFocus($newNav, index);
            }*/
        }
      },
    }, //END Keyboard
    initMobileNav: function () {
      window.docSpacing = function docSpacing() {
        // Init header height script
        var hHeight = $("#header").height(),
          hPosition = $("#header").data('position'),
          mobileSticky = $(".mobile-cart-buttons").data('sticky'),
          mobileLocation = $(".sticky-footer").data("mobile"),
          mobileNavDiv = $('.sticky-footer'),
          mobilehHeight = $(".sticky-footer").outerHeight(),
          mobileProdBtns = $('.product-top-buttons'),
          mobilePromoDiv = $('.mobile-promo'),
          mobilePromo = $('.mobile-promo').height(),
          deskPromo = $('.desk-promo').height(),
          mobileCartBtns = $(".cart-top-buttons"),
          hSubHeader = $($(".subheader-menu")[0]).height(),
          hSubHeaderMobile = $($(".subheader-menu")[1]).height();

        // Set main menu dropdown to always append below header
        $('.main-menu-dropdown').css("top", hHeight - hSubHeader);

        if (window.innerWidth > 1200) {
          // If desktop 
          if (hPosition) {
            // If sticky header
            $('main.main-content').css('margin-top', hHeight);
          } else {
            $('main.main-content').css('margin-top', 'initial');
          }
          $('main.main-content').css('padding-top', 0);
          $('body').css('margin-bottom', 0);
          $('#PageContainer').css({
            'margin-top': '0',
            'padding-top': 0
          });
        } else if ($('body').hasClass('template-product') || $('body').hasClass('template-cart')) {
          // If product or cart page
          if ($('body').hasClass('template-product') && !(mobileSticky) && window.innerWidth < 1201) {
            // If product page without sticky add to cart buttons (mobile)
            if (mobileLocation == 'top') {
              // If mobile nav is on top
              $('main.main-content').css('margin-top', mobilehHeight + mobilePromo + hSubHeaderMobile - 4);
              $('main.main-content').css('margin-bottom', 0);
              $('main.main-content').css('padding-top', 0);
              $('body').css('margin-bottom', 0);
              mobileNavDiv.css('bottom', 'initial');
            } else {
              if (mobilePromo) {
                // if product promo bar is turned on
                $('main.main-content').css('margin-top', mobilePromo);
                $('main.main-content').css('padding-top', '4%');
              } else {
                $('main.main-content').css('margin-top', '4%');
                $('main.main-content').css('padding-top', 0);
              }
              $('body').css('margin-bottom', mobilehHeight);
              mobileNavDiv.css('top', 'initial');
            }
          } else if ($('body').hasClass('template-product') && mobileSticky && window.innerWidth < 1201) {
            // If product page with sticky add to cart buttons (mobile)
            if (mobileLocation == 'top') {
              var newHeight = mobilehHeight + mobileProdBtns.outerHeight() + mobilePromo;
              $('main.main-content').css('margin-top', newHeight);
              $('main.main-content').css('margin-bottom', 0);
              $('main.main-content').css('padding-top', 0);
              mobileProdBtns.css("top", mobilehHeight + mobilePromo);
              $('body').css('margin-bottom', 0);
              mobileNavDiv.css('bottom', 'initial');
            } else {
              if (mobileProdBtns.outerHeight() != 0) {
                mobileProdBtns.css("padding-top", '15px');
              }

              if ((mobileProdBtns.outerHeight() + mobilePromo) == 0) {
                $('main.main-content').css('margin-top', '4%')
              } else {
                $('main.main-content').css('margin-top', mobileProdBtns.outerHeight() + mobilePromo);

              }
              mobileProdBtns.css("top", 0 + mobilePromo);
              $('body').css('margin-bottom', mobilehHeight);
              mobileNavDiv.css('top', 'initial');
            }
          }
          if ($('body').hasClass('template-cart') && window.innerWidth < 1201) {
            // If cart page
            if (mobileLocation == 'top') {
              var newCartHeight = mobilehHeight + mobileCartBtns.outerHeight() + mobilePromo;
              $('main.main-content').css('margin-top', newCartHeight - 4);
              $('main.main-content').css('margin-bottom', 0);
              $('body').css('margin-bottom', 0);
              mobileCartBtns.css("top", "92%");
              mobileNavDiv.css('bottom', 'initial');
            } else {
              $('main.main-content').css('margin-top', mobileCartBtns.outerHeight() + mobilePromo);
              $('body').css('margin-bottom', mobilehHeight);
              mobileCartBtns.css("top", "92%");
              mobileNavDiv.css('top', 'initial');
            }
          }

        } else if ($('body').hasClass('template-article') && window.innerWidth < 1201) {
          if (mobileLocation == 'top') {
            // If mobile nav is on top
            mobilePromoDiv.css('top', 0);
            mobileNavDiv.css('bottom', 'initial');
            $('main.main-content').css('margin-top', 0);
            $('#PageContainer').css({
              'margin-top': mobilehHeight + mobilePromo,
              'margin-bottom': '4%',
              'padding-top': 0
            });
            $('body').css('margin-bottom', 0);

          } else {
            if (mobilePromo) {
              // if product promo bar is turned on
              $('main.main-content').css('margin-top', '4%');
              $('#PageContainer').css('margin-top', mobilePromo);

              mobilePromoDiv.css('top', 0);
            } else {
              $('main.main-content').css('margin-top', '4%');
              $('#PageContainer').css({
                'margin-top': 0,
                'padding-top': 0
              });
            }
            $('#PageContainer').css('margin-bottom', '4%');
            $('body').css('margin-bottom', mobilehHeight);
            mobileNavDiv.css('top', 'initial');
          }
        } else {
          // If any other page
          if (window.innerWidth < 1201) {
            if (mobileLocation == 'top') {
              $('main.main-content').css('margin-top', mobilehHeight + mobilePromo + hSubHeaderMobile - 4);
              // $('main.main-content').css('margin-bottom', '4%');
              $('body').css('margin-bottom', 0);
              mobileNavDiv.css('bottom', 'initial');
            } else {
              if (mobilePromo) {
                // if product promo bar is turned on
                $('main.main-content').css('margin-top', mobilePromo);
                $('main.main-content').css('padding-top', '4%');
              } else {
                $('main.main-content').css('margin-top', '4%');
                $('main.main-content').css('padding-top', 0);
              }
              $('body').css('margin-bottom', mobilehHeight);
              mobileNavDiv.css('top', 'initial');
            }
          }
        }
      }

      docSpacing();
      //Run on resize
      $(window).resize(function () {
        docSpacing();
      });
    },
    /*
      theme.Navigation.Mobile
    */
    Mobile: {
      _selectors: null,
      _animations: {
        swapEnterAnim: 'slideInRight',
        swapExitAnim: 'slideOutLeft',
        goBackEnterAnim: 'slideInLeft',
        goBackExitAnim: 'slideOutRight'
      },
      _prevNavs: [],
      /***** Public Methods *****/
      /*
        =function init()
      */
      init: function () {
        var self = this;
        //Init "Parent" ref
        self._selectors = $.extend(theme.Navigation._selectors, {
          goBack: '.go-back',
          mobileNavHasSublist: '.mobile-nav__has-sublist',
          mobilNavLinkGroup: '.mobile-nav__link-group',
          navDrawerId: '#NavDrawer'
        });

        self._prevNavs = [];
        $(this._selectors.mobileNavHasSublist + ' [type="button"]').click(function (e) {
          var $closest_li = $(this).closest('li');
          var div_id = $closest_li.attr('id');
          div_id = '#' + div_id.substring(0, div_id.lastIndexOf('-')) + '-mnav';
          self._swapInNav($(div_id));
        });

        $(this._selectors.mobilNavLinkGroup + ' ' + this._selectors.goBack).click(function (e) {
          self._goBackNav();
        });

        if (self._prevNavs.length == 0) {
          var mainMenuNav = $(self._selectors.navDrawerId + ' .js-mobile-nav-mm');
          if (mainMenuNav.length == 0) {
            mainMenuNav = $(self._selectors.navDrawerId + ' ' + self._selectors.mobilNavLinkGroup + ':first');
          }
          self._prevNavs.push(mainMenuNav);
        }
      },
      initFooter: function (container) {
        var self = this;
        //Re-init timber
        theme.Navigation.initTimber();
        //Reset the close handler
        $('body').off('afterDrawerClose.timber', self._timberDrawerCloseHandler.bind(this));
        $('body').on('afterDrawerClose.timber', self._timberDrawerCloseHandler.bind(this));
      },

      /***** Private Methods *****/
      _timberDrawerCloseHandler: function (e) {
        var self = this;
        setTimeout(function () {
          self._currNav().hide();
          self._prevNavs.length = 0;
          var mainMenuNav = $(self._selectors.navDrawerId + ' .js-mobile-nav-mm');
          if (mainMenuNav.length == 0) {
            mainMenuNav = $(self._selectors.navDrawerId + ' ' + self._selectors.mobilNavLinkGroup + ':first');
          }
          self._prevNavs.push(mainMenuNav);
          self._currNav().show();
        }, 500);
      },
      /*
        =function _currNav()
        Get the currently displayed navigation
      */
      _currNav: function () {
        return this._prevNavs[this._prevNavs.length - 1];
      },
      /*
        =function _swapInNav()
        Hides the previous navigation and displays the new one
        =Params
        (object) newNav: The new navigation to display
      */
      _swapInNav: function (newNav) {
        var curr = this._currNav();
        if (curr != newNav) {
          curr.animateCss(this._animations.swapExitAnim, function () {
            curr.hide();
          });
          newNav.show();
          newNav.animateCss(this._animations.swapEnterAnim);
          this._prevNavs.push(newNav);
        }
      },
      /*
        =function _goBackNav()
        Hides the current navigation and then displays the previous one
      */
      _goBackNav: function () {
        var curr = this._prevNavs.pop();
        curr.animateCss(this._animations.goBackExitAnim, function () {
          curr.hide();
        });
        var newNav = this._currNav();
        newNav.show();
        newNav.animateCss(this._animations.goBackEnterAnim);
      }
    }, //END Mobile

    /*
    theme.Navigation.TouchMenu
    */
    TouchMenu: {
      _selectors: null,
      _classes: null,
      init: function () {
        if ($('html').hasClass('supports-touch')) {
          var self = this;
          self._classes = $.extend(theme.Navigation._classes, {
            showMenu: 'showMenu',
            supportsTouch: 'supports-touch'
          });

          self._selectors = $.extend(theme.Navigation._selectors, {
            showMenu: '.showMenu',
            topLevelNavLinks: 'site-nav--has-dropdown_link',
            childNavLinks: '.child-site-nav__link'
          });

          var winW = $(window).width();
          // prevent clicks
          $(self._selectors.topLevelMenuItems).click(function (e) {
            return false;
          });
          $(self._selectors.childNavLinks).click(function (e) {
            e.stopPropagation();
            return true;
          });
          $(self._selectors.topLevelMenuItems).click('touchend', function () {
            //hide current menu
            $(self._selectors.topLevelMenuItems + self._selectors.showMenu).removeClass(self._classes.showMenu);
            self._hideMenu();
            //show current menu
            $(this).addClass(self._classes.showMenu);
            self._showMenu();
          });
          $(window).click(function () {
            self._hideMenu();
          });
          // hide menu on scroll
          $(window).scroll(function () {
            self._hideMenu();
          });
          // hide on clicking dim
          $(self._selectors.dim).click(function () {
            self._hideMenu();
          });
        }
      },
      _showMenu: function () {
        $(this._selectors.dim).show();
        //$(this._selectors.showMenu + '>' + this._selectors.mainMenuDropdown).show();            
        $(this._selectors.showMenu + '>' + this._selectors.generalMenu).show();
        $(this).addClass(this._classes.hover);
        $(this._selectors.siteHeaderId).addClass(this._classes.navBg);
        $(this).find(this._selectors.sectionHeaderMenuItems + ':first').focus();
      },
      _hideMenu: function () {
        $(this._selectors.dim).hide();
        //$(this._selectors.mainMenuDropdown).hide();
        $(this._selectors.generalMenu).hide();
        $(this).removeClass(this._classes.hover);
        $(this._selectors.siteHeaderId).removeClass(this._classes.navBg);
        $(this).find(this._selectors.sectionHeaderMenuItems + ':first').blur();
        $(this._selectors.showMenu).removeClass(this._classes.showMenu);
      }
    } //END TouchMenu
  };
}());


/*
    theme.Search
    
    Controls the search form's display and submission.
    
    Depends on:
    theme.Navigation    
*/
theme.Search = (function () {
    return {
        /***** Private Properties *****/
        //Selectors used for jQuery targeting
        _selectors: $.extend(theme.Navigation._selectors, {
            //Search viewing controls
            openSearch: '.js-search-open',
            mobileSearchOpen: '.js-mobile-search-open',
            mobileSearchExit: '.js-mobile-search-exit',
            //Containers
            searchWrapper: '#search-wrapper',
            searchContainer: '.js-search-dropdown',
            searchContainerMobile: '.js-mobile-search-dropdown',
            stickyHeader: '.sticky-header',
            //Inputs
            searchTextInput: '.js-search-query',
            searchTypeSelect: '.js-search-type',
            searchVendorSelect: '.js-search-vendor',
            searchProdTypeSelect: '.js-search-product-type',
            searchNavSubmit: '.js-search-submit',
            searchBaseSubmit: '.js-base-search'
        }),
        //Classes used to be added/removed/checked against
        _classes: $.extend(theme.Navigation.classes, {
            mobileSearchActive: 'mobile-search-active',
            searchIsOpen: 'search-is-open',
            searching: 'searching'
        }),
        //Event Handlers
        _bodyClickHandler: null,
        _scrollHandler: null,
        
        /***** Public Methods *****/
        /*
            =function init(container)
            Initializes the event handlers used by search. 
        */
        init: function(container) {
            var self = this;
            // Used when the search is open. If any click occurs and it's not within
            // the search, close the search.
            self._bodyClickHandler = function(evt) {
                if ($(evt.target).closest(self._selectors.searchWrapper).length === 0) {
                    self._closeSearch($('[data-section-type="header"]'));
                }
            };
            //When opened, we want the window scrolling to close it.
            self._scrollHandler = self._closeSearch.bind(self, $('[data-section-type="header"]'));
        },
        initSearchPage: function(container) {
            $('[name="q"]', container).focus(function() {
                $('body').addClass('fixfixed');
            });
            $('[name="q"]', container).blur(function() {
                $('body').removeClass('fixfixed');
            });
        },
        /*
            =function initHeader(container)
            Initializes the events for the header's search for both desktop and
            mobile. Also contains the events for searching with filters.
            =Params
            (mixed) container: Value can be a jQuery selector string, jQuery
                                object, or element. The value should return the
                                container that may have the main search form
        */
        initHeader: function(container) {
            var self = this;
            var $container = $(container);
            var isAndroid = navigator.userAgent.indexOf("Android") > -1;
            if(isAndroid) {
                $('#searchInputMobile', container).focus(function(){
                  $('body').addClass("fixfixed");
                });

                $('#searchInputMobile', container).blur(function(){
                  $('body').removeClass("fixfixed");
                });
            }
            $container.find(self._selectors.openSearch).click(
                function (e) {
                    e.stopPropagation();
                    if($container.find(self._selectors.searchContainer).hasClass(self._classes.searching)) {
                        self._closeSearch($container);
                    } else {
                        self._openSearch($container);
                    }
                }
            );
            $container.find(self._selectors.mobileSearchOpen).click(function () { self._openMobileSearch($container); });
            $container.find(self._selectors.mobileSearchExit).click(function () { self._closeMobileSearch($container); });
            //Search submission
            $container.find(self._selectors.searchNavSubmit).click(function (e) {
                e.preventDefault();
                var $container = $(this).closest('form');

                //Get the base search text
                var searchText = $(self._selectors.searchTextInput, $container).val();
                var searchQuery = "q=" + (searchText === '' ? '**' : encodeURIComponent(searchText));
                
                //Gather the filters
                var searchFilters = '';
                var typeSelection = $(self._selectors.searchTypeSelect + ' option:selected', $container).val();
                var vendorSelection = $(self._selectors.searchVendorSelect + ' option:selected', $container).val();
                var productType = $(self._selectors.searchProdTypeSelect + ' option:selected', $container).val();

                if (vendorSelection && vendorSelection !== '') {
                    searchFilters += " vendor:" + encodeURIComponent(vendorSelection);
                }
                if (productType && productType !== '') {
                    if(searchFilters != '') searchFilters += ' '
                    searchFilters += 'product_type:' + encodeURIComponent(productType);
                }
                if (typeSelection && typeSelection !== '') {
                    searchFilters += '&type=' + encodeURIComponent(typeSelection);
                }
                if(searchFilters != '') {
                    searchQuery += '??' + searchFilters;
                }

                window.location.href = '/search?' + searchQuery;
            });
        },
        initBanner: function (container) {
            this.initBaseSearch(container);
            this.initOpenSearches(container);
        },

        initBaseSearch: function(container) {
            var $container = $(container);
            $container.find(this._selectors.searchBaseSubmit).click(function(e) {
                e.preventDefault();
                var $form = $(this).closest('form');
                var searchQuery = $form.find('input[name="q"]').val();
                searchQuery = 'q=' + (searchQuery === '' ? '**' : encodeURIComponent(searchQuery));
                window.location.href = '/search?' + searchQuery;
            });
        },

        /*
            =function initFooter(container)
            Initializes the events to open the search in the footer
            =Params
            (mixed) container: Value can be a jQuery selector string, jQuery
                                object, or element. The value should return the
                                container that may have the sticky footer that
                                opens the search on mobile.
        */
        initFooter: function(container) {
            var self = this;
            $(self._selectors.mobileSearchOpen, container).click(function () {
                self._openMobileSearch(container);
            });
        },
        /*
            =function initOpenSearches(container)
            Initializes the events for the open buttons for mobile used primarily
            by the mobil banners.
            =Params
            (mixed) container: Value can be a jQuery selector string, jQuery
                                object, or element. The value should return the
                                container that may have a banner with a search
                                button.
        */
        initOpenSearches: function (container) {
            var self = this;
            $(self._selectors.mobileSearchOpen, container).each(function () {
                $(this).click(function () {
                    self._openMobileSearch($('[data-section-type="header"]:first'));
                });
            });
        },
        /***** Private Methods *****/
        /*
            =function _openSearch()
            Opens the desktop search.
        */
        _openSearch: function ($container) {
            var self = this;
            theme.Navigation.displayOrHideSharedElements();

            $(self._selectors.searchContainer, $container).addClass(self._classes.searching);
            $('.site-nav--has-dropdown').hide();
            $('body').click(self._bodyClickHandler);
            setTimeout(function() {
                theme.Utilities.runAfterStoppedScrolling(function() {
                    $(window).scroll(self._scrollHandler);
                });
            }, 100);
            //$(window).scroll(this._scrollHandler);
        },
        /*
            =function _closeSearch()
            Closes the desktop search.
        */
        _closeSearch: function ($container) {
            theme.Navigation.displayOrHideSharedElements(true);
            $(this._selectors.searchContainer, $container).removeClass(this._classes.searching);
            $('.site-nav--has-dropdown').show();
            $('body').off('click', this._bodyClickHandler);
            $(window).off('scroll', this._scrollHandler);
        },
        /*
            =function _openMobileSearch()
            Opens the mobile search.
        */
        _openMobileSearch: function ($container) {
            $(this._selectors.searchContainerMobile, $container).addClass(this._classes.mobileSearchActive).show().animateCss('slideInUp');
            $(this._selectors.stickyHeader, $container).addClass(this._classes.searchIsOpen);
            $('body').addClass(this._classes.searchIsOpen);
        },
        /*
            =function _closeMobileSearch()
            Closes the mobile search.
        */
        _closeMobileSearch: function ($container) {
            // Set to variables to be used within 
            // the anonymous function block
            var mobileSearchActive = this._classes.mobileSearchActive;
            var searchIsOpen = this._classes.searchIsOpen;
            var stickyHeader = this._selectors.stickyHeader;
            $(this._selectors.searchContainerMobile, $container).animateCss('slideOutDown', function() { 
                $(this).removeClass(mobileSearchActive);
                $(stickyHeader, $container).removeClass(searchIsOpen);
            });
            $('body').removeClass(searchIsOpen);
        }
    };
}());
//Add the init code to $.ready
$(function() {
    theme.Search.init();
});


/*
Functionality pulled from the theme Debut, slightly
modified for our theme.
*/
theme.SectionManager = function SectionManager() {
    this.constructors = {};
    this.sections = [];

    $(document)
      .on('shopify:section:load', this._onSectionLoad.bind(this))
      .on('shopify:section:unload', this._onSectionUnload.bind(this))
      .on('shopify:block:select', this._onBlockSelect.bind(this))
      .on('shopify:block:deselect', this._onBlockDeselect.bind(this));

};
theme.SectionManager.prototype = {
    _findSectionIndex: function(sectionId) {
        return this.sections.findIndex(function (element) {
            return element.id === parseInt(sectionId);
        });
    },
    _runEventFunction: function(func, evt) {
        if (func && typeof func === 'function') {
            func(evt);
        }
    },
    _createSection: function (container, constructor) {
        var $container = $(container);
        var type = $container.data('section-type');
        constructor = constructor || this.constructors[type];

        if (!constructor) {
            return;
        }

        var newInstance = new constructor(container);
        newInstance.id = $container.data('section-id');
        this.sections.push(newInstance);
    },
    _onSectionLoad: function (evt) {
        var container = $('[data-section-id]', evt.target)[0];
        if (container) {
            this._createSection(container);
        }
    },
    _onSectionUnload: function (evt) {
        var instanceNdx = this._findSectionIndex(evt.originalEvent.detail.sectionId)
        if (instanceNdx !== -1) {
            this._runEventFunction(this.sections[instanceNdx].onUnload, evt);
            this.sections.splice(instanceNdx, 1);
        }
    },
    _onBlockSelect: function(evt) {
        var instanceNdx = this._findSectionIndex(evt.originalEvent.detail.sectionId)
        if (instanceNdx !== -1) {
            this._runEventFunction(this.sections[instanceNdx].onBlockSelect, evt);
        }
    },
    _onBlockDeselect: function(evt) {
        var instanceNdx = this._findSectionIndex(evt.originalEvent.detail.sectionId)

        if (instanceNdx !== -1) {
            this._runEventFunction(this.sections[instanceNdx].onBlockDeselect, evt);
        }
    },
    register: function (type, constructor) {
        this.constructors[type] = constructor;
        $('[data-section-type=' + type + ']').each(function (index, container) {
            this._createSection(container, constructor);
        }.bind(this));
    }
};

//Theme sections
theme.Sections = {};
theme.Sections.Banner = function (container) {
  var $win = $(window);
      // Parallax
    var $parallax = $('.section-parallax .section__image');

    if ($parallax) {
      $parallax.each(function() {
        var $this         = $(this);
        var startValue = -400;
        var parallaxValue = startValue - (50 - (startValue - 50));
        
        $win
          .on('scroll', function() {
            var winST        = $win.scrollTop();
            var elementOT        = $this.offset().top;
            var elementOB        = $this.offset().top + $this.outerHeight();
            var winHeight        = $win.outerHeight();
            var winSB            = winST + winHeight;
            var scrollVisibility = elementOB - (elementOT - winHeight);

            if (winSB > elementOT && winST < elementOB) {
              $this.css({
                'transform' : 'translate3d(0px, ' + (startValue - (parallaxValue * ((winST - (elementOT - winHeight)) / scrollVisibility))) + 'px, 0px)'
              });
            }
          });
      });
    }
  
    $('.section-parallax').addClass('loaded');
    var self = this;
    $(window).resize(self.resize);
    setTimeout(function() {
        self.resize();
    }, 500);
  theme.Search.initBanner(container);

  /*
    var checkIfiPad = navigator.userAgent.match(/iPad/i);
    if (checkIfiPad != null) {
      $('.banner-content').css('background-attachment', 'scroll');
    }
    */
};
theme.Sections.Banner.prototype = {
    resize: function() {
        setTimeout(function() {
            $(window).trigger('resize.px.parallax');
            $(window).trigger('scroll');
        }, 375);
    },
    reset: function() {
        self._oldHeight = $(document).height();
        self._stopper = 0;
    },
    onLoad: function(evt) {
          $('.section-parallax').addClass('loaded');
    }
};

theme.Sections.Blog = function(container) {
    (function() {
        var $filterBy = $('#BlogTagFilter');
        if ($filterBy.length > 0) {
            $filterBy.on('change', function() {
                location.href =  $(this).val();
            });
        }
    })();

    theme.Tabs.init(container);
    theme.Slick.initMobileBlog(container);
};
theme.Sections.Blog.prototype = {
    onUnload: function(evt) {
        theme.Slick.unintMobileBlog($('[data-section-id]', evt.target)[0]);
    }
}

theme.Sections.Cart = function(container) {
    theme.Cart.init(container);
};

theme.Sections.Maps = function(container) {
    theme.Maps();
};

theme.Sections.FeaturedCollection = function(container) {
    theme.Slick.initFeaturedCollection(container);
};
theme.Sections.FeaturedCollection.prototype = {
    onUnload: function(evt) {
        theme.Slick.uninitFeaturedCollection($('[data-section-id]', evt.target)[0]);
    },
};

theme.Sections.Footer = function(container) {
    theme.Search.initFooter(container);
    theme.Navigation.Mobile.initFooter(container);
};

theme.Sections.Header = function (container) {
    theme.Navigation.init(container);
    theme.Navigation.initTimber(container);
    theme.Navigation.initMobileNav(container);
    theme.Search.initHeader(container);
};

theme.Sections.Instafeed = function (container) {
    var $container = $(container);
    var loft_instaTok = $container.data('insta-token');
    if (loft_instaTok && loft_instaTok !== '') {
        var target_id = $container.attr('id');
        var limit = $container.data('amount');
        var images = $container.data('images');
        var imageOutput;
        if (images == 3) {
            imageOutput = '<a href="{{link}}" target="_blank" data-bgset="{{image}}" data-sizes="auto" data-parent-fit="cover" style="background-image: url({{model.images.low_resolution.url}});" class=" lazyload instagram--square flex-item width--large-3 width--medium-3"><img src="//unitestudents.unikitout.com/cdn/shop/t/9/assets/instagram-feed.svg?v=63193639921674605461784584189"><h2 class="insta-two">{{model.short_caption}}</h2></a>';
        } else {
            imageOutput = '<a href="{{link}}" target="_blank" data-bgset="{{image}}" data-sizes="auto" data-parent-fit="cover" style="background-image: url({{model.images.low_resolution.url}});"  class="lazyload instagram--square flex-item width--large-4 width--medium-6"><img src="//unitestudents.unikitout.com/cdn/shop/t/9/assets/instagram-feed.svg?v=63193639921674605461784584189"><h2 class="insta-two">{{model.short_caption}}</h2></a>';
        }

        var userFeed = new Instafeed({
            get: 'user',
            userId: 'self',
            accessToken: loft_instaTok,
            sortBy: 'most-recent',
            resolution: 'standard_resolution',
            limit: limit,
            filter: function (image) {
                var MAX_LENGTH = 100;
                if (image.caption && image.caption.text) {
                    if(image.caption.text.length > MAX_LENGTH) {
                        //Fit an ellipses to the end
                        var i = MAX_LENGTH - 3;
                        for(; i >= 0; --i) {
                            if(image.caption.text[i] === ' ') {
                                break;
                            }
                        }
                        if(i <= 0) {
                            image.short_caption = image.caption.text.slice(0, MAX_LENGTH);
                        } else {
                            image.short_caption = image.caption.text.slice(0, i) + '...';
                        }
                    } else {
                        image.short_caption = image.caption.text;
                    }
                } else {
                    image.short_caption = "";
                }
                // ensure the filter doesn't reject any images
                return true;
            },
            template: imageOutput,
            target: target_id
        });
        userFeed.run();
    }
};

theme.Sections.ProductTemplate = function (container) {
  var $mainContainer = $(container);    
  if(($mainContainer.closest('[data-section-id="product-template"]').length > 0)
      || ($mainContainer.closest('[data-section-id="product-group"]').length > 0)
      || ($mainContainer.closest('[data-section-id="bundle"]').length > 0)
      || ($mainContainer.closest('.sb_header_wrapper').length > 0)){

    theme.Products.init(container);
    theme.Slick.initProdPhoto(container);
    // theme.Slick.initVariant(container);
    theme.Variants.init(container, true);
    theme.ProductPage.init(container);
    theme.ProductPage.init($("#whats-in-the-box")[0]);
  } else {
    $mainContainer.find('.desktop-featured-product').each(function() {
        var $container = $(this);
        theme.Products.init($container);
        theme.Slick.initFeaturedCollection($container);
        theme.Variants.init($container);
    });
  }
  theme.Navigation.initMobileNav();
};

theme.Sections.ProductTemplate.prototype = {
    onUnload: function(evt) {
        var container = $('[data-section-id]', evt.target)[0];
        theme.Slick.uninitFeaturedCollection(container);
        theme.Slick.uninitProdPhoto(container);
        // theme.Slick.uninitVariant(container);
    }
};

theme.Sections.SearchTemplate = function(container) {
    theme.Search.initBaseSearch(container);
    theme.Search.initSearchPage(container);
};

$(function() {
    var sections = new theme.SectionManager();
    sections.register('instafeed', theme.Sections.Instafeed);
    sections.register('header', theme.Sections.Header);
    sections.register('product', theme.Sections.ProductTemplate);
    sections.register('banner', theme.Sections.Banner);
    sections.register('blog', theme.Sections.Blog);
    sections.register('blogs', theme.Sections.Blog);
    sections.register('cart', theme.Sections.Cart);
    sections.register('map', theme.Maps);
    sections.register('collection', theme.Filters);
    sections.register('featured-collection', theme.Sections.FeaturedCollection);
    sections.register('search-template', theme.Sections.SearchTemplate);
    // sections.registerBundleTemplate('bundle', theme.Sections.ProductTemplate);
});

$(document).ready( function() {
  var emailname = 'there';
  var url_string = window.location.href;

  function getUrlParams() {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi,    
    function(m,key,value) {
      vars[key] = value;
    });
    return vars;
  }

  setTimeout(function(){
    var clarity_cookie = window.Cookies('_clck');
    if (clarity_cookie) {
      var clarity_id = clarity_cookie.split('|')[0];
      if (clarity_id) {
        localStorage.setItem("clarityId", clarity_id);
      }
    }
  }, 4000);

  var urlParams = getUrlParams();
  
  // Ul flow 
  var partner = urlParams['partner'];
  if (partner == 'universityliving') {
    var email = urlParams["email"];
    if (email) {
      email = email.replace('%40','@');
    }
    var firstName = urlParams["first_name"];
    var lastName = urlParams["last_name"];
    var orderId = urlParams["order_id"];
    var phone = urlParams["phone"];

    localStorage.setItem("email", email || ''); 
    localStorage.setItem("first_name", firstName || '');
    localStorage.setItem("last_name", lastName || '');
    localStorage.setItem("transaction_ID", orderId || '');
    localStorage.setItem("phone", phone || '');
    localStorage.setItem("partner", partner || '');
  }
  // end UL flow 
  var email = urlParams["email"];
  if(email) {
    emailname = email;
    localStorage.setItem("emailname", emailname);
  }
  console.log(emailname);
  
  if(localStorage.getItem("emailname")) {
    jQuery(".announcement-bar__message").html(localStorage.getItem("emailname"));
  } else {
    jQuery(".announcement-bar__message").html(emailname);  
  }
});       

// header disappears when scrolling
$(document).ready(function(){
  var mobileHeaderEl = $(".mobile-header");
  if (mobileHeaderEl.length > 0) {
    var mobile_header_headroom  = new Headroom(mobileHeaderEl[0], {tolerance: {up: 70, down: 0}});
    mobile_header_headroom.init();
  }

  var cart_top_buttons = $(".cart-top-buttons");
  if (cart_top_buttons.length > 0) {
    var cart_top_buttons_headroom  = new Headroom(cart_top_buttons[0], {tolerance: {up: 70, down: 0}});
    cart_top_buttons_headroom.init();
  }
});

// Specifications popup JS starts
$(document).ready(function(){
  $('.check-specifications').click(function(){
    showSpecificationsPopup();
  });

  $('#specifications-popup .close').click(function(){
    hideSpecificationsPopup();
  });

  $(document).on('click', function (e) {
    if (
      $(e.target).closest("#specifications-popup").length === 0 &&
      !$(e.target).is(".check-specifications") &&
      $("#specifications-popup").hasClass('is-visible')
    ) {
      hideSpecificationsPopup();
    }
  });

  function showSpecificationsPopup() {
    $('html').addClass('js-drawer-open');
    $('#specifications-popup').addClass('is-transitioning');
  
    setTimeout(function(){
      $('#specifications-popup').removeClass('is-transitioning');
      $('#specifications-popup').addClass('is-visible');  
    }, 50);
  }
  
  function hideSpecificationsPopup() {
    $('html').removeClass('js-drawer-open');
    $('#specifications-popup').addClass('is-transitioning');
    $('#specifications-popup').removeClass('is-visible');
  
    setTimeout(function(){
      $('#specifications-popup').removeClass('is-transitioning');
    }, 500);
  }
});
// Specifications popup JS ends

// Survey popup JS starts
$(document).ready(function(){
  $('body').on('click', '.take-survery, .customiser-need-help-btn', function(){
    showSurveyPopup();
  });

  $('#survey-popup .close').click(function(){
    hideSurveyPopup();
  });

  window.showSurveyPopup = function showSurveyPopup() {
    $('html').addClass('js-drawer-open');
    $('#survey-popup').addClass('is-transitioning');
  
    setTimeout(function(){
      $('#survey-popup').removeClass('is-transitioning');
      $('#survey-popup').addClass('is-visible');  
    }, 50);
  }
  
  function hideSurveyPopup() {
    $('html').removeClass('js-drawer-open');
    $('#survey-popup').addClass('is-transitioning');
    $('#survey-popup').removeClass('is-visible');
  
    setTimeout(function(){
      $('#survey-popup').removeClass('is-transitioning');
    }, 500);
  }
});
// Survey popup JS ends

// Header change tabs on hover JS starts
function escapeSpecialCharacters(str) { 
  return str.replace(/([;&,\.\+\*\~':"\!\^#$%@\[\]\(\)=>\|])/g, '\\$1'); 
}

var secondLevelInterval = null, thirdLevelInterval = null;
function changeHeaderTabsSecondLevel(evt, third_level_content) {
  var event_target = evt.currentTarget;
  secondLevelInterval = setInterval(function() {
    if (!$(event_target).hasClass("active")) {
      var menu_holder = $(event_target).closest('.nav-menu-js.main-menu-dropdown');
      var color = $(event_target).data("menu-color");

      // Remove unnecessary classes
      var supported_colors = ["blue", "coffee", "plum", "forest"];    
      supported_colors.forEach(function(sc){
        if (sc != color) {
          menu_holder.removeClass(sc);
        }
      });
      menu_holder.removeClass("second_column_hidden");
      $(".third_level .tabcontent").hide();
      $(".third_level .tabcontent").removeClass("fade-in-transition");
      $(".second_level .tablinks, .third_level .tablinks").removeClass("active");
      $(".fourth_level_tabcontent").hide();
      

      // add necessary classes
      menu_holder.addClass(color);
      menu_holder.find(".third_level .tabcontent#" + third_level_content).css("display", "flex");
      menu_holder.find(".third_level .tabcontent#" + third_level_content).addClass("fade-in-transition");
      menu_holder.find(".third_level .tabcontent#" + third_level_content + " .second-col-navs li:first-child a").addClass("active");
      if (menu_holder.find(".third_level .tabcontent#" + third_level_content + " .fourth_level").data("second-col-hidden") == true) {
        menu_holder.addClass("second_column_hidden");
      }
      menu_holder.find(".third_level .tabcontent#" + third_level_content + " .fourth_level .fourth_level_tabcontent:first-child").css('display', 'flex');
      $(event_target).addClass("active");
    }
  }, 150)
}

function clearIntervalSecondLevel() {
  clearInterval(secondLevelInterval)
}

function changeHeaderTabsThirdLevel(evt, fourth_level_content) {
  var event_target = evt.currentTarget;
  thirdLevelInterval = setInterval(function() {
    if (!$(event_target).hasClass("active")) {
      $(".third_level .tablinks").removeClass("active");

      var fourth_level_selector = escapeSpecialCharacters(fourth_level_content.replaceAll(" ", "-"));
      $(".fourth_level_tabcontent").hide();
      $("#fourth_level_" + fourth_level_selector).css('display', 'flex');

      $(event_target).addClass("active");
    }
  }, 150);
}

function clearIntervalThirdLevel() {
  clearInterval(thirdLevelInterval)
}
// Header change tabs on hover JS ends

function moveSliderToSelectedImage(variantImgId) {
  if (variantImgId) {
    $('.simple_product .sb_header_slider_container img').each(function (index, elm) {
      if (elm.id == variantImgId) {
        if ( index > -1) {
          $('.simple_product .sb_header_slider').slick('slickGoTo', index - 1, false);
        }
        return false;
      } 
    });
  }
}

function getB2BOriginalPrice(variantPrice) {
  return originalPrice = variantPrice / (100 - window.has_b2b_discount);
}

function noahB2BPrice(variant) {
  if (variant) {
    var variantPrice =  variant.price;
    var originalPrice = getB2BOriginalPrice(variantPrice);

    $('.mega-sale-container .sale-price.noah_pro').text('Wholesale: '+  theme.Currency.formatMoney(variantPrice))
    $('.mega-sale-container .original-price-value.noah_pro').text('Retail: '+ theme.Currency.formatMoney(originalPrice*100))
  }
}
